webpackJsonp([1],{

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLogin_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b63128e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLogin_vue__ = __webpack_require__(975);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b63128e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b63128e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 171:
/***/ (function(module, exports) {

module.exports = {
	"default": {
		"title": "Geogaming",
		"logo": "/static/img/menu/logo/geogaming.jpg",
		"introText": "This is a <strong>fun geocaching game </strong>where you walk around to discover challenge locations, and <strong>answer questions</strong> as fast as possible with your team!"
	},
	"dev": {
		"title": "Geogaming DEV",
		"logo": "/static/img/menu/logo/dev.jpg",
		"introText": "[dev] \"We are so happy you are trying Geogaming.<br/>We hope you’ll love it. Remember this is a demo version, (almost) <strong>everything is customisable</strong><br/>Support: <a href='mailto:info@geogaming.io'>info@geogaming.io</a>"
	},
	"demo": {
		"title": "Geogaming DEMO",
		"logo": "/static/img/menu/logo/demo.jpg",
		"introText": "We are so happy you are trying Geogaming.<br/>We hope you’ll love it. Remember this is a demo version, (almost) <strong>everything is customisable</strong><br/>Support: <a href='mailto:info@geogaming.io'>info@geogaming.io</a>"
	},
	"elpro": {
		"title": "ELpro",
		"logo": "/static/img/menu/logo/elpro.jpg"
	},
	"prod": {
		"title": "Corporate Challenge",
		"logo": "/static/img/menu/logo/prod.jpg"
	},
	"play": {
		"title": "Corporate Challenge",
		"logo": "/static/img/menu/logo/prod.jpg"
	}
};

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

module.exports = {
	"envName": "dev"
};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TeamLogin__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PinCodeLogin__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ZooHomePage__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TeamLeaderboard__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Questions__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Question__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Photos__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_store__ = __webpack_require__(73);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/p/zoo',
    name: 'ZooHomePage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ZooHomePage__["a" /* default */]
  }, {
    path: '/g/:tenantId',
    name: 'TeamLogin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_TeamLogin__["a" /* default */]
  }, {
    path: '/pin',
    name: 'PinCodeLogin',
    component: __WEBPACK_IMPORTED_MODULE_4__components_PinCodeLogin__["a" /* default */]
  }, {
    path: '/',
    name: 'TeamLogin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_TeamLogin__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    beforeEnter: requireAuth
  }, {
    path: '/questions',
    name: 'Questions',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Questions__["a" /* default */],
    beforeEnter: requireAuth
  }, {
    path: '/question/:id',
    name: 'Question',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Question__["a" /* default */],
    beforeEnter: requireAuth
  }, {
    path: '/teamleaderboard',
    name: 'TeamLeaderboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_TeamLeaderboard__["a" /* default */],
    beforeEnter: requireAuth
  }, {
    path: '/photos',
    name: 'Photos',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Photos__["a" /* default */],
    beforeEnter: requireAuth
  }]
}));

function requireAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_10__store_store__["a" /* default */].getters.isLoggedIn) {
    console.log('Not authorised.. routing to login');
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = storeClient;
/* harmony export (immutable) */ __webpack_exports__["b"] = setUpClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(174);







var storedClient = void 0;
var handle = void 0;

function storeClient(client) {
  storedClient = client;
  var team = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters.team;
  if (team && team.idTeam) {
    setUpClient(team.idTeam);
  }
}

function setUpClient(teamId) {

  var subquery = __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()('\nsubscription subscribeToNotification {\nsubscribeToNotification(teamId: "' + teamId + '") {\n    teamId\n    gameId\n    content\n}\n}');
  console.log('gonna try to subscribe');

  var notifObservable = storedClient.subscribe({ query: subquery });
  handle = notifObservable.subscribe({
    next: realtimeResults,
    complete: console.log,
    error: console.log
  });
}

var realtimeResults = function realtimeResults(data) {
  console.log('REAL TIME DATA', data);
  var notificationObject = data.data.subscribeToNotification;
  if (notificationObject.content === 'LOG_OUT') {
    __WEBPACK_IMPORTED_MODULE_1__store_actions__["logoutTeam"](__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].push({ name: 'TeamLogin' });
    handle.unsubscribe();
  }
};

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    height: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this4 = this;

      // ie 11 support
      var File = window.File;
      try {
        new File([], ''); // eslint-disable-line
      } catch (e) {
        File = function (_Blob) {
          __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(File, _Blob);

          function File(chunks, filename) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, File);

            var _this3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (File.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(File)).call(this, chunks, opts));

            _this3.lastModifiedDate = new Date();
            _this3.lastModified = +_this3.lastModifiedDate;
            _this3.name = filename;
            return _this3;
          }

          return File;
        }(Blob);
      }
      options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this4.onFileChange(e, true);
      }).catch(function (err) {
        _this4.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TeamLogin__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_fingerprint__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_single_TeamAvatar__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__geogaming_selected__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__geogaming_selected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__geogaming_selected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__geogaming_config__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__geogaming_config__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var DEFAULT_CONFIG_NAME = 'default';
var configName = __WEBPACK_IMPORTED_MODULE_8__geogaming_selected___default.a.envName;
console.log(' > stage:' + configName);

var DEFAULT_TITLE = __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[configName] ? __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[configName].title : __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[DEFAULT_CONFIG_NAME].title;
var DEFAULT_IMAGE_URL = __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[configName] ? __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[configName].logo : __WEBPACK_IMPORTED_MODULE_9__geogaming_config___default.a[DEFAULT_CONFIG_NAME].logo;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyAKhSBrvzrbhuFJJnp9Zi5W7YzuFqfLFjA",
    // Force maps to load the 'geometry' library from the beginning
    libraries: 'geometry'
  }
});

var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['team', 'fingerprint', 'game']);

var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['logoutTeam']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    TeamAvatar: __WEBPACK_IMPORTED_MODULE_6__components_single_TeamAvatar__["a" /* default */],
    TeamLogin: __WEBPACK_IMPORTED_MODULE_4__components_TeamLogin__["a" /* default */]
  },
  data: function data() {
    return {
      drawer: true,
      navigationDrawerElement: null
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_DRAWER_STATE', this.drawer);
    this.generateAndStoreFingerprint();
    this.navigationDrawerElement = this.$el.querySelector('.navigation-drawer');
  },

  watch: {
    'drawer': function drawer(_drawer) {
      this.$store.commit('SET_DRAWER_STATE', _drawer);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters, {
    imageUrl: function imageUrl() {
      if (this.game) {
        return this.game.imageUrl ? this.game.imageUrl : __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL);
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL);
      }
    },
    gameDisplayedName: function gameDisplayedName() {
      if (this.game) {
        return this.game.gameDisplayedName ? this.game.gameDisplayedName : __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.$store.state.tenant, 'title', DEFAULT_TITLE);
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.$store.state.tenant, 'title', DEFAULT_TITLE);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    goTo: function goTo(pathName) {
      if (this.navigationDrawerElement.classList.contains('navigation-drawer--is-mobile')) {
        this.drawer = false;
      }
      this.$router.push({ name: pathName });
    },
    showTeamLoginButton: function showTeamLoginButton() {
      if (!this.team && this.$route.name !== 'TeamLogin') {
        return true;
      }
      return false;
    },
    generateAndStoreFingerprint: function generateAndStoreFingerprint() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_fingerprint__["a" /* generateFingerprint */])(function (fingerprint) {
        // Store fingerprint
        _this.$store.commit('SET_FINGERPRINT', fingerprint);
      });
    },
    logout: function logout() {
      this.logoutTeam();
      this.goTo('TeamLogin');
    },
    isActive: function isActive(routeName) {
      return routeName === this.$router.currentRoute.name;
    },
    launchTutorial: function launchTutorial() {
      this.$store.commit('LAUNCH_TUTORIAL', true);
      this.$store.commit('IS_TUTORIAL_IN_PROGRESS', true);
      this.goTo('Home');
    }
  })
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_single_Map__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_single_TutorialDialog__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_watchLocation__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_challengesUtils__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_challengeStatus_enum__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








//  import * as helpfulLocations from '../services/helpfulLocations'

var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['unlockQuestion', 'setPositionToDefaultChallenge']);

var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['errorMessage', 'isUserAtChallengeLocation', 'tutorialInProgress', 'challengesLocations', 'game']);

var unwatchIsUserAtChallengeLocation = void 0;
var unwatchChallengesLocations = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    MapComponent: __WEBPACK_IMPORTED_MODULE_3__components_single_Map__["a" /* default */],
    watchLocation: __WEBPACK_IMPORTED_MODULE_5__services_watchLocation__["a" /* default */],
    TutorialDialogComponent: __WEBPACK_IMPORTED_MODULE_4__components_single_TutorialDialog__["a" /* default */]
  },
  data: function data() {
    return {
      showUnlockDialog: false,
      discoveredChallengeId: null,
      googleMapsLoaded: false,
      needToUnlockDialogAfterTutorial: false
    };
  },

  // https://router.vuejs.org/en/advanced/data-fetching.html
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__["loaded"].then(function () {
      next(function (vm) {
        return vm.setGoogleMapsLoaded(true);
      });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters),
  mounted: function mounted() {
    var _this = this;

    // Inject fake locations... And go to a checkpoint
    //      this.$store.commit('SET_USER_LOCATION', helpfulLocations.two)

    //      setTimeout(() => {
    //        this.$store.commit('SET_USER_LOCATION', helpfulLocations.three)
    //      }, 1500)
    //      setTimeout(() => {
    //        this.$store.commit('SET_USER_LOCATION', wynyard)
    //      }, 3000)
    //      setTimeout(() => {
    //        this.$store.commit('SET_USER_LOCATION', botanicGarden)
    //      }, 4000)

    unwatchIsUserAtChallengeLocation = this.$watch('isUserAtChallengeLocation', function () {
      _this.positionDefaultChallenge();
    });
    unwatchChallengesLocations = this.$watch('challengesLocations', function () {
      _this.positionDefaultChallenge();
    });
  },

  watch: {
    isUserAtChallengeLocation: function isUserAtChallengeLocation(userAtChallengeLocation) {
      var _this2 = this;

      if (userAtChallengeLocation.isUserInOneZone) {

        var challengeId = userAtChallengeLocation.challengeId;
        var challenge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_challengesUtils__["a" /* getChallengeById */])(this.$store.state.challengesLocations, challengeId);

        if (challenge && challenge.status === __WEBPACK_IMPORTED_MODULE_7__services_challengeStatus_enum__["a" /* challengeStatus */].LOCKED) {

          this.unlockQuestion(challengeId).then(function (questionResponse) {
            _this2.$store.commit('SET_ERROR_MESSAGE', '');
            // Unlock challenge (update state)
            _this2.$store.commit('UNLOCK_CHALLENGE', questionResponse.data);
          }).catch(function (err) {
            console.log('unlockQuestion() / server error', err);
            _this2.$store.commit('SET_ERROR_MESSAGE', 'Challenge could not be unlocked...');
            setTimeout(function () {
              _this2.$store.commit('SET_ERROR_MESSAGE', '');
            }, 2000);
          });

          if (this.tutorialInProgress === false) {
            setTimeout(function () {
              _this2.openUnlockedDialog(challengeId);
            }, 500);
          } else {
            this.needToUnlockDialogAfterTutorial = true;
          }
        }
      }
    },
    tutorialInProgress: function tutorialInProgress(isTutorialInProgress) {
      var _this3 = this;

      var challengeId = this.isUserAtChallengeLocation.challengeId;
      if (isTutorialInProgress === false && this.needToUnlockDialogAfterTutorial) {
        this.needToUnlockDialogAfterTutorial = false;
        setTimeout(function () {
          _this3.openUnlockedDialog(challengeId);
        }, 100);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    setGoogleMapsLoaded: function setGoogleMapsLoaded(loaded) {
      this.googleMapsLoaded = loaded;
    },
    goToQuestion: function goToQuestion(challengeId) {
      this.showUnlockDialog = false;
      this.$router.push({ name: 'Question', params: { id: challengeId } });
    },
    openUnlockedDialog: function openUnlockedDialog(challengeId) {
      this.discoveredChallengeId = challengeId;
      this.showUnlockDialog = true;
    },
    positionDefaultChallenge: function positionDefaultChallenge() {
      if (this.challengesLocations && this.challengesLocations.length > 0 && this.isUserAtChallengeLocation && this.isUserAtChallengeLocation.isUserInOneZone !== null) {
        this.setPositionToDefaultChallenge();
        unwatchIsUserAtChallengeLocation();
        unwatchChallengesLocations();
      }
    }
  })
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gallery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getPhotos']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Photos',
  data: function data() {
    return {
      photos: [],
      errorMessage: '',
      showLoading: false,
      index: null,
      attemptedToLoadPhotos: false
    };
  },
  created: function created() {
    this.loadPhotos();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    loadPhotos: function loadPhotos() {
      var _this = this;

      this.attemptedToLoadPhotos = true;
      this.showLoading = true;
      this.getPhotos().then(function (result) {
        _this.photos = result.data.map(function (url) {
          return url;
        });
        _this.showLoading = false;
      }, function (error) {
        _this.showLoading = false;
        _this.errorMessage = error.message;
      });
    }
  }),
  components: {
    'gallery': __WEBPACK_IMPORTED_MODULE_2_vue_gallery___default.a
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_teamService__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geogaming_selected__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geogaming_selected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__geogaming_selected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geogaming_config__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geogaming_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__geogaming_config__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DEFAULT_CONFIG_NAME = 'default';
var configName = __WEBPACK_IMPORTED_MODULE_4__geogaming_selected___default.a.envName;
console.log(' > stage:' + configName);

var DEFAULT_IMAGE_URL = __WEBPACK_IMPORTED_MODULE_5__geogaming_config___default.a[configName] ? __WEBPACK_IMPORTED_MODULE_5__geogaming_config___default.a[configName].logo : __WEBPACK_IMPORTED_MODULE_5__geogaming_config___default.a[DEFAULT_CONFIG_NAME].logo;

var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['loginTeam']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pinCodeLogin',
  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default.a
  },
  data: function data() {
    return {
      pinCode: '',
      error: false,
      errorMessage: ''
    };
  },

  computed: {
    imageUrl: function imageUrl() {
      return DEFAULT_IMAGE_URL;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    login: function login() {
      var _this = this;

      this.clearErrorMessage();

      var credentials = {
        pinCode: this.pinCode
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_teamService__["b" /* teamLogin */])(credentials, this.$store.state.fingerprint).then(function (loginDetails) {
        _this.loginTeam(loginDetails);
      }).then(function () {
        _this.$emit('loginSuccess');
        _this.$router.push({ name: 'Home' });
      }).catch(function (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          _this.errorMessage = error.response.data.message;
        } else {
          _this.errorMessage = 'Sorry we are unable to serve your request :(';
        }
        _this.error = true;
      });
    },
    clearErrorMessage: function clearErrorMessage() {
      this.errorMessage = '';
      this.error = false;
    }
  })
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TeamLogin__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_single_MultipleAnswer__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_single_TextAnswer__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_single_OneChoiceAnswer__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_challengeStatus_enum__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_picture_input__ = __webpack_require__(940);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['challengesLocations', 'team']);

var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['getChallengesLocations', 'sendAnswer', 'uploadPicture']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'question',
  components: {
    TeamLogin: __WEBPACK_IMPORTED_MODULE_4__components_TeamLogin__["a" /* default */],
    MultipleAnswer: __WEBPACK_IMPORTED_MODULE_5__components_single_MultipleAnswer__["a" /* default */],
    TextAnswer: __WEBPACK_IMPORTED_MODULE_6__components_single_TextAnswer__["a" /* default */],
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default.a,
    OneChoiceAnswer: __WEBPACK_IMPORTED_MODULE_7__components_single_OneChoiceAnswer__["a" /* default */],
    PictureInput: __WEBPACK_IMPORTED_MODULE_9_vue_picture_input__["a" /* default */]
  },
  data: function data() {
    return {
      photoToUpload: null,
      photoUploaded: false,
      showLoading: false,
      answer: null,
      show: false,
      chosenAnswer: null,
      goodAnswer: null,
      disableAnswers: false,
      goButtonLoading: false,
      errorMessage: '',
      errorOnCheckAnswer: false,
      dialog: false,

      questionPoints: null,
      bonusFirstTry: null,
      bonusSpeed: null,
      score: null,

      showQuestionPoints: false,
      showBonusFirstTry: false,
      showBonusSpeed: false,
      showScore: false,
      challengeStatus: null,
      remainingAttempts: -1
    };
  },
  created: function created() {
    var _this = this;

    if (!this.challengesLocations || this.challengesLocations.length === 0) {
      // Reload from API
      this.showLoading = true;
      this.getChallengesLocations().then(function () {
        if (_this.challenge && _this.challenge.remainingAttempts !== null) {
          _this.remainingAttempts = _this.challenge.remainingAttempts;
          if (_this.remainingAttempts === 0) {
            _this.disableAnswers = true;
          }
        }
        _this.showLoading = false;
      });
    }

    if (this.challenge && this.challenge.status === __WEBPACK_IMPORTED_MODULE_8__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED) {
      this.updateScreenToAnsweredState();
    }

    if (this.challenge && this.challenge.status === __WEBPACK_IMPORTED_MODULE_8__services_challengeStatus_enum__["a" /* challengeStatus */].FAILED || this.remainingAttempts === 0) {
      this.updateScreenToFailedState();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // Go back to 'Map' page when pressing 'Esc'
    if (this.challenge && this.challenge.remainingAttempts !== null) {
      this.remainingAttempts = this.challenge.remainingAttempts;
      if (this.remainingAttempts === 0) {
        this.disableAnswers = true;
      }
    }
    var escKeyCode = 27;
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === escKeyCode) {
        _this2.$router.push({ name: 'Home' });
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters, {
    urlComputed: function urlComputed() {
      return 'https://geogaming-dev-games.s3.amazonaws.com/' + this.challenge.imgSrc;
    },


    /**
     * We could have put that in the .then() of mounted() / this.getChallengesLocations()
     * Or here as a computed property as it will get re-evaluated when 'this.challengesLocations' changes
     */
    challenge: function challenge() {
      var _this3 = this;

      var challengeToDisplay = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.challengesLocations, function (question) {
        return question.challengeId === _this3.$route.params.id;
      });
      if (this.challengesLocations && this.challengesLocations.length > 0 && !challengeToDisplay) {
        this.errorMessage = 'Oops, invalid challenge ID...';
      } else {
        this.errorMessage = '';
      }
      return challengeToDisplay;
    },
    questionOnlyText: function questionOnlyText() {
      return typeof this.challenge.question === 'string';
    },
    isSubmittable: function isSubmittable() {
      return this.challenge.question && !this.disableAnswers && this.challenge.status === __WEBPACK_IMPORTED_MODULE_8__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    onPictureChosen: function onPictureChosen(photo) {
      console.log('New picture selected!');
      if (photo) {
        this.photoToUpload = photo;
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!');
      }
    },
    startPictureUpload: function startPictureUpload() {
      var _this4 = this;

      var challengeId = this.$route.params.id;
      this.showLoading = true;
      this.uploadPicture({
        challengeId: challengeId, photo: this.photoToUpload
      }).then(function (response) {
        console.log('Success uploading photo!' + response);
        _this4.photoUploaded = true;
        _this4.showLoading = false;
        _this4.errorMessage = '';
      }).catch(function (err) {
        console.log('Error uploading photo!' + err);
        _this4.showLoading = false;
        _this4.errorMessage = err.message;
      });
    },
    submitAnswer: function submitAnswer() {
      var _this5 = this;

      this.goodAnswer = null;
      this.goButtonLoading = true;
      this.errorOnCheckAnswer = false;

      var challengeId = this.$route.params.id;

      this.sendAnswer({
        challengeId: challengeId,
        answer: this.answer + ''
      }).then(function (response) {
        var responseData = response.data;

        if (responseData.error) {
          _this5.errorOnCheckAnswer = true;
          console.error('Error back from server:', responseData.error);
        } else if (responseData.code) {
          _this5.errorOnCheckAnswer = true;
          console.error('Error back from server:', responseData.code, responseData.message);
        } else if (responseData.isValid) {
          var scoreObj = responseData.score;
          _this5.score = scoreObj.score;
          _this5.questionPoints = scoreObj.questionPoints;
          _this5.bonusFirstTry = scoreObj.bonusFirstTry;
          _this5.bonusSpeed = scoreObj.bonusSpeed;
          _this5.onGoodAnswer();
        } else {
          _this5.goodAnswer = false;
          _this5.status = responseData.status;
          _this5.remainingAttempts = responseData.remainingAttempts;
          _this5.$store.commit('UPDATE_CHALLENGE_REMAINING_ATTEMPTS', {
            challengeId: challengeId,
            remainingAttempts: _this5.remainingAttempts
          });
          if (responseData.remainingAttempts === 0) {
            _this5.disableAnswers = true;
            _this5.$store.commit('MARK_CHALLENGE_AS_FAILED', {
              challengeId: challengeId,
              challengeAnswer: _this5.answer
            });
          }
        }
        _this5.goButtonLoading = false;
      }).catch(function (err) {
        console.error(err);
        _this5.errorOnCheckAnswer = true;
        _this5.goButtonLoading = false;
      });
    },
    updateScreenToAnsweredState: function updateScreenToAnsweredState() {
      this.chosenAnswer = this.challenge.chosenAnswer;
      this.disableAnswers = true;
      this.goodAnswer = true;
    },
    updateScreenToFailedState: function updateScreenToFailedState() {
      this.disableAnswers = true;
    },
    onAnswerUpdate: function onAnswerUpdate(answer) {
      this.answer = answer;
    },
    onGoodAnswer: function onGoodAnswer() {
      this.challengeDone();
    },
    loginSuccess: function loginSuccess() {
      this.dialog = false;
      // Points have already been transferred from the unlogged state
      var addPoints = false;
      this.challengeDone(addPoints);
    },
    challengeDone: function challengeDone() {
      var addPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


      var challengeId = this.$route.params.id;

      this.showScoreDetails();

      this.$store.commit('MARK_CHALLENGE_AS_DONE', {
        challengeId: challengeId,
        challengeAnswer: this.answer
      });
      if (addPoints) {
        this.$store.commit('ADD_POINTS_TO_USER_SCORE', this.score);
      }
      this.updateScreenToAnsweredState();
    },
    showScoreDetails: function showScoreDetails() {
      var _this6 = this;

      this.goodAnswer = true;
      var currentTimer = 0;
      var delay = 500;
      currentTimer += delay;
      setTimeout(function () {
        _this6.showQuestionPoints = true;
      }, currentTimer);
      if (this.bonusFirstTry) {
        currentTimer += delay;
        setTimeout(function () {
          _this6.showBonusFirstTry = true;
        }, currentTimer);
      }
      if (this.bonusSpeed) {
        currentTimer += delay;
        setTimeout(function () {
          _this6.showBonusSpeed = true;
        }, currentTimer);
      }
      currentTimer += delay;
      setTimeout(function () {
        _this6.showScore = true;
      }, currentTimer);
    }
  })
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stable__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_difficulty_enum__ = __webpack_require__(273);



var _sortHelper;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['challengesLocations', 'userLocation']);

var sortHelper = (_sortHelper = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sortHelper, __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED, 3), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sortHelper, __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED, 2), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sortHelper, __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].LOCKED, 1), _sortHelper);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'questions',
  data: function data() {
    return {
      challengesList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters),
  mounted: function mounted() {
    this.buildQuestionsList(this.challengesLocations);
  },

  watch: {
    challengesLocations: function challengesLocations(_challengesLocations) {
      this.buildQuestionsList(_challengesLocations);
    }
  },
  methods: {
    buildQuestionsList: function buildQuestionsList(challengesLocations) {
      var _this = this;

      if (challengesLocations) {
        var challenges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(challengesLocations);

        this.challengesList = __WEBPACK_IMPORTED_MODULE_3_stable__(challenges, function (c1, c2) {
          return sortHelper[c1.status] < sortHelper[c2.status];
        });

        __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__["loaded"].then(function () {
          var challengesWithDistances = _this.getDistanceForLockedChallenges();
          _this.challengesList = __WEBPACK_IMPORTED_MODULE_3_stable__(challengesWithDistances, function (c1, c2) {
            if (c1.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].LOCKED && c1.status === c2.status) {
              return c1.distanceToUserRound > c2.distanceToUserRound;
            }
            return sortHelper[c1.status] < sortHelper[c2.status];
          });
        });
      }
    },
    goToQuestion: function goToQuestion(challengeId) {
      this.$router.push({ name: 'Question', params: { id: challengeId } });
    },
    getDistanceForLockedChallenges: function getDistanceForLockedChallenges() {
      var _this2 = this;

      // eslint-disable-next-line no-undef
      var userLocationPoint = new google.maps.LatLng(this.userLocation.lat, this.userLocation.lng);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(this.challengesList, function (challenge) {
        if (challenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].LOCKED) {
          // eslint-disable-next-line no-undef,no-undef
          var challengeLocation = new google.maps.LatLng(challenge.location.lat, challenge.location.lng);
          // eslint-disable-next-line no-undef
          var sphericalMaps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(google, 'maps.geometry.spherical');
          if (sphericalMaps) {
            var distanceToUserGoogle = sphericalMaps.computeDistanceBetween(userLocationPoint, challengeLocation);
            var distanceToUserRound = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(distanceToUserGoogle);
            var distanceToUserReadable = _this2.getReadableDistance(distanceToUserRound);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])({}, challenge, {
              distanceToUserRound: distanceToUserRound,
              distanceToUserReadable: distanceToUserReadable
            });
          }
        }
        return challenge;
      });
    },
    getReadableDistance: function getReadableDistance(distanceToUser) {
      if (distanceToUser < 1000) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(distanceToUser, -1) + 'm';
      } else if (distanceToUser < 10000) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(distanceToUser / 1000, 1) + 'km';
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(distanceToUser / 1000) + 'km';
    },
    showGoToQuestion: function showGoToQuestion(status) {
      return status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED || status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED;
    },
    getDifficulty: function getDifficulty(difficulty) {
      return __WEBPACK_IMPORTED_MODULE_7__services_difficulty_enum__["a" /* difficultyMap */][difficulty];
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getTeamLeaderboard']);

var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['game']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'teamleaderboard',
  data: function data() {
    return {
      teams: [],
      showLoading: true,
      search: '',
      first: String,
      second: String,
      third: String,
      isLeaderBoardDisabled: false
    };
  },
  created: function created() {
    var _this = this;

    this.getTeamLeaderboard().then(function (response) {
      if (response.data.isLeaderDisabled) {
        _this.isLeaderBoardDisabled = true;
      } else {
        _this.isLeaderBoardDisabled = false;
        _this.teams = response.data.teams.slice(0, 15);
        if (response.data[0]) {
          _this.first = response.data[0].name;
        }
      }
    }).catch(function (err) {

      console.error(err);
    }).finally(function () {
      _this.showLoading = false;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    customFilter: function customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      return items.filter(function (i) {
        return filter(i.name, search);
      });
    }
  })
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_teamService__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_gameService__ = __webpack_require__(513);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['loginTeam']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default.a
  },
  data: function data() {
    return {
      tenantId: '',

      gameId: '',
      games: [],
      teams: [],
      teamName: '',
      password: '',
      error: false,
      errorMessage: ''
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var serverGames;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.tenantId = _this.$route.params.tenantId;
              _context.prev = 1;
              _context.next = 4;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_gameService__["a" /* getGames */])(_this.tenantId);

            case 4:
              serverGames = _context.sent;

              _this.games = serverGames.data.filter(function (game) {
                return game.gameStatus !== 'stopped';
              });
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0);
              _this.games = [];

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 8]]);
    }))();
  },

  watch: {
    gameId: function gameId() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_teamService__["a" /* getTeamsByGameId */])(_this2.gameId).then(function (teams) {
                  _this2.teams = teams;
                }).catch(function (err) {
                  console.log(err);
                  _this2.teams = [];
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, actions, {
    login: function login() {
      var _this3 = this;

      this.clearErrorMessage();

      var credentials = {
        gameId: this.gameId,
        teamName: this.teamName,
        password: this.password + ''
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_teamService__["b" /* teamLogin */])(credentials, this.$store.state.fingerprint).then(function (loginDetails) {
        _this3.loginTeam(loginDetails);
      }).then(function () {
        _this3.$emit('loginSuccess');
        _this3.$router.push({ name: 'Home' });
      }).catch(function (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          _this3.errorMessage = error.response.data.message;
        } else {
          _this3.errorMessage = 'Sorry we are unable to serve your request :(';
        }
        _this3.error = true;
      });
    },
    clearErrorMessage: function clearErrorMessage() {
      this.errorMessage = '';
      this.error = false;
    }
  })
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_css_only_css_bootstrap_min_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_css_only_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_css_only_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mdbvue_lib_css_mdb_min_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mdbvue_lib_css_mdb_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mdbvue_lib_css_mdb_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_css_all_min_css__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_css_all_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_css_all_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdbvue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdbvue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mdbvue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomePage',
  components: {
    mdbContainer: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbContainer"],
    mdbCol: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCol"],
    mdbRow: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbRow"],
    mdbIcon: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbIcon"],
    mdbBtn: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbBtn"],
    mdbEdgeHeader: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbEdgeHeader"],
    mdbCard: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCard"],
    mdbCardImage: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCardImage"],
    mdbCardTitle: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCardTitle"],
    mdbCardText: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCardText"],
    mdbCardBody: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["mdbCardBody"]
  },
  directives: {
    animateOnScroll: __WEBPACK_IMPORTED_MODULE_3_mdbvue__["animateOnScroll"]
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_single_Heart__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_difficulty_enum__ = __webpack_require__(273);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */








var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['userLocation', 'challengesLocations', 'drawerState', 'mapZoomState', 'mapCenterState', 'game', 'questionRadius']);

var actions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['getChallengesLocations']);

// Center of the map at start (will be changed by defineCenterAndZoom())
var sydney2000 = {
  lat: -33.867888,
  lng: 151.2012157
};

var zoomStartShowCircles = 15;
// https://developers.google.com/maps/documentation/javascript/examples/circle-simple
var circleOptions = {
  fillColor: 'transparent',
  strokeWeight: 0
};
var circleOptionsIfZoom = {
  fillColor: 'white',
  fillOpacity: 0.6,
  strokeWeight: 0
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  components: {
    HeartComponent: __WEBPACK_IMPORTED_MODULE_5__components_single_Heart__["a" /* default */]
  },
  created: function created() {
    if (this.mapZoomState == null) {
      this.mapZoom = this.game.gameZoom;
    }
  },
  data: function data() {
    return {
      mapZoom: null,

      markers: [],

      // In meters
      checkpointCircleRadius: 80,

      userLocationIcon: {
        url: '/static/img/map/here-google-like.svg',
        // Size of the original image
        scaledSize: new google.maps.Size(30, 30),
        // The origin for this image is (0, 0)
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the middle of the base
        anchor: new google.maps.Point(15, 15)
      },

      clickedChallenge: null,

      circleOptions: {
        fillColor: 'transparent',
        strokeWeight: 0
      },

      // https://developers.google.com/maps/documentation/javascript/examples/control-positioning
      mapOptions: {
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        clickableIcons: false
      },

      mapObject: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.checkpointCircleRadius = this.questionRadius;
    this.getChallengesLocations().then(function () {
      if (_this.challengesLocations) {
        _this.markers = _this.filterChallengesWithLocations(_this.challengesLocations);

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["size"])(_this.challengesLocations) > 0 && !_this.mapZoomState && !_this.mapCenterState) {
          _this.defineCenterAndZoom();
        }
      }
    });

    setTimeout(function () {

      _this.mapObject = _this.$refs.mapRef.$mapObject;

      // Add "Locate Me" custom control to center map on user location
      var centerControlDiv = _this.buildCenterControlDiv();
      centerControlDiv.index = 1;
      _this.mapObject.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv);

      _this.showCirclesAroundCheckpoints(_this.mapZoom);

      // Set back previous 'mapZoom' and 'mapCenter' if any
      if (_this.mapZoomState && _this.mapCenterState) {
        _this.mapZoom = _this.mapZoomState;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["size"])(_this.markers) > 0) {
        // In order to show all markers
        _this.defineCenterAndZoom();
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getters, {
    mapCenter: function mapCenter() {
      return this.mapCenterState ? this.mapCenterState : sydney2000;
    }
  }),
  watch: {
    userLocation: function userLocation() {
      if (this.challengesLocations && this.challengesLocations.length > 0) {
        this.checkIfUserInZone();
      }
    },
    challengesLocations: function challengesLocations(locations) {
      this.markers = this.filterChallengesWithLocations(locations);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["size"])(this.challengesLocations) > 0 && !this.mapZoomState && !this.mapCenterState) {
        this.defineCenterAndZoom();
      }

      if (this.userLocation) {
        this.checkIfUserInZone();
      }
    },
    drawerState: function drawerState() {
      var _this2 = this;

      // Need to wait until end of drawer hide animation!
      setTimeout(function () {
        _this2.onResizeMap();
      }, 50);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, actions, {
    filterChallengesWithLocations: function filterChallengesWithLocations(questions) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(questions, function (q) {
        return !!q.location;
      });
    },
    onResizeMap: function onResizeMap() {
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].$gmapDefaultResizeBus.$emit('resize');
    },
    checkIfUserInZone: function checkIfUserInZone() {
      var _this3 = this;

      var isUserInOneZone = false;
      var challengeId = null;

      var sphericalMaps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(google, 'maps.geometry.spherical');
      if (sphericalMaps) {

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"])(this.markers, function (marker) {

          var markerLat = marker.location.lat;
          var markerLng = marker.location.lng;

          var markerPositionPoint = new google.maps.LatLng(markerLat, markerLng);
          var userLocationPoint = new google.maps.LatLng(_this3.userLocation.lat, _this3.userLocation.lng);

          var distanceToMarker = sphericalMaps.computeDistanceBetween(markerPositionPoint, userLocationPoint);
          isUserInOneZone = distanceToMarker <= _this3.checkpointCircleRadius;
          challengeId = marker.challengeId;

          // No need to check other checkpoints
          // (Maybe yes, if overlapping between zones?...)
          if (isUserInOneZone) {
            return false;
          }
        });

        this.$store.commit('SET_IS_USER_AT_CHALLENGE_LOCATION', {
          isUserInOneZone: isUserInOneZone,
          challengeId: challengeId
        });
      }
    },
    showGoToQuestionButton: function showGoToQuestionButton(clickedChallenge) {
      return clickedChallenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED || clickedChallenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED;
    },
    onMarkerClicked: function onMarkerClicked(challenge) {
      this.clickedChallenge = challenge;
    },
    goToQuestion: function goToQuestion(challengeId) {
      this.$router.push({ name: 'Question', params: { id: challengeId } });
    },
    getIconForChallenge: function getIconForChallenge(challenge) {

      var iconImg = challenge.activityType === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["b" /* challengeActivityType */].FINISH_LINE ? 'checkered-flag-' : '';

      if (challenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED) {
        iconImg += 'challenge-correct.png';
      } else if (challenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED) {
        iconImg += 'challenge-unlocked.png';
      } else if (challenge.status === __WEBPACK_IMPORTED_MODULE_6__services_challengeStatus_enum__["a" /* challengeStatus */].FAILED) {
        iconImg += 'challenge-failed.png';
      } else {
        iconImg += 'challenge-locked.png';
      }
      return this.getIcon(iconImg);
    },
    getIcon: function getIcon(iconImg) {

      // If no icon defined here, default red marker from Google is used

      var icon = void 0;

      // Working PNG!
      // https://developers.google.com/maps/documentation/javascript/examples/icon-complex
      var width = 120;
      var height = 166;
      var scaledWidth = width / 4;
      var scaledHeight = height / 4;
      icon = {
        url: '/static/img/map/' + iconImg,
        // Size of the original image
        scaledSize: new google.maps.Size(scaledWidth, scaledHeight),
        // The origin for this image is (0, 0)
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the middle of the base
        anchor: new google.maps.Point(scaledWidth / 2, scaledHeight)

        // Better to use a SVG, but harder... :(
        /**
         * In computed / markers:
         * return this.challengesLocations.slice(0, 4) ==> Works
         * return this.challengesLocations.slice(0, 5) ==> Breaks...
         */
        // https://codepen.io/defvayne23/pen/EVYGRw
        // https://github.com/defvayne23/SVGMarker/blob/master/SVGMarker.js

      };return icon;
    },


    /**
     * Show or hide checkpoint circles depending on the map zoom
     */
    onZoomChanged: function onZoomChanged(newZoom) {
      this.showCirclesAroundCheckpoints(newZoom);

      // Save 'zoom' to state --> get it back when coming back from another screen
      this.$store.commit('SET_MAP_ZOOM', newZoom);
    },
    showCirclesAroundCheckpoints: function showCirclesAroundCheckpoints(zoom) {
      if (zoom >= zoomStartShowCircles) {
        this.circleOptions = circleOptionsIfZoom;
      } else {
        this.circleOptions = circleOptions;
      }
    },


    /**
     * Update map center in Vue component
     * (Otherwise "locate-me' icon works only once)
     */
    onCenterChanged: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (newCenter) {
      this.$store.commit('SET_MAP_CENTER', newCenter);
    }, 150),

    /**
     * Add "Locate Me" custom control to center map on user location
     */
    // https://developers.google.com/maps/documentation/javascript/examples/control-custom
    buildCenterControlDiv: function buildCenterControlDiv() {
      var _this4 = this;

      var controlDiv = document.createElement('div');

      // Set CSS for the control border.
      var controlUI = document.createElement('div');
      controlUI.style.backgroundColor = '#fff';
      controlUI.style.border = '2px solid #fff';
      controlUI.style.borderRadius = '2px';
      controlUI.style.boxShadow = '0 1px 2px rgba(0,0,0,.2)';
      controlUI.style.cursor = 'pointer';
      controlUI.style.marginRight = '10px';
      controlUI.style.textAlign = 'center';
      controlDiv.appendChild(controlUI);

      // Set CSS for the control interior.
      var controlText = document.createElement('div');
      controlText.style.width = '24px';
      controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlText.style.fontSize = '16px';
      controlText.style.paddingTop = '5px';
      controlText.innerHTML = '<img src="/static/img/map/locate-me.png" style="width: 15px;" />';
      controlUI.appendChild(controlText);

      controlUI.addEventListener('click', function () {
        _this4.$store.commit('SET_MAP_CENTER', _this4.userLocation);
      });

      return controlDiv;
    },
    defineCenterAndZoom: function defineCenterAndZoom() {
      console.log('Setting center to ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ lat: this.game.gameLatitude, lng: this.game.gameLongitude }));
      this.$store.commit('SET_MAP_CENTER', { lat: this.game.gameLatitude, lng: this.game.gameLongitude });
    },
    getDifficulty: function getDifficulty(difficulty) {
      return __WEBPACK_IMPORTED_MODULE_7__services_difficulty_enum__["a" /* difficultyMap */][difficulty];
    }
  })
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiple-answer',
  props: ['possibleAnswers', 'chosenAnswer', 'disabledAnswers'],
  data: function data() {
    return {
      answer: []
    };
  },
  mounted: function mounted() {
    this.answer = this.chosenAnswer;
  },

  watch: {
    'answer': function answer() {
      this.$emit('updated', this.answer);
    }
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lowerCase__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lowerCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_lowerCase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'one-choice-answer',
  props: ['possibleAnswers', 'chosenAnswer', 'disabledAnswers'],
  data: function data() {
    return {
      answer: null
    };
  },
  mounted: function mounted() {
    if (this.chosenAnswer) {
      this.answer = this.chosenAnswer;
    }
  },

  watch: {
    'answer': function answer() {
      this.$emit('updated', this.answer);
    }
  },
  methods: {
    toLowerCase: function toLowerCase(value) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_lowerCase___default()(value);
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_avatar__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_avatar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['team', 'userScore', 'isLoggedIn']);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'team-avatar',
  components: {
    'avatar': __WEBPACK_IMPORTED_MODULE_2_vue_avatar___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getters),
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    clickedLogOut: function clickedLogOut() {
      console.log('clickedLogOut log out');
      this.dialog = true;
    },
    logout: function logout() {
      console.log('Team log out');
      this.dialog = false;

      // Emit event up to parent
      this.$emit('logout');
    }
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-answer',
  props: ['chosenAnswer', 'disabledAnswers'],
  data: function data() {
    return {
      answer: null
    };
  },
  mounted: function mounted() {
    if (this.chosenAnswer) {
      this.answer = this.chosenAnswer;
    }
  },

  methods: {
    updateAnswer: function updateAnswer(event) {
      this.$emit('updated', event);
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_single_TutorialGifCard__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geogaming_selected__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geogaming_selected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__geogaming_selected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geogaming_config__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__geogaming_config__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var DEFAULT_CONFIG_NAME = 'default';
var configName = __WEBPACK_IMPORTED_MODULE_2__geogaming_selected___default.a.envName;
console.log(' > stage:' + configName);

var DEFAULT_TITLE = __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName] ? __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName].title : __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[DEFAULT_CONFIG_NAME].title;
var DEFAULT_IMAGE_URL = __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName] ? __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName].logo : __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[DEFAULT_CONFIG_NAME].logo;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tutorial-dialog',
  components: {
    TutorialGifCard: __WEBPACK_IMPORTED_MODULE_1__components_single_TutorialGifCard__["a" /* default */]
  },
  props: {
    game: null
  },
  data: function data() {
    return {
      showSlides: [null, false, false, false, false, false, false],
      unwatchHandler: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var localStorage = window && window.localStorage;
    if (localStorage && !localStorage.getItem('tutorialShowedOnce') || this.$store.state.launchTutorial === true) {
      this.showSlide(1);
      localStorage.setItem('tutorialShowedOnce', 'true');
      this.$store.commit('IS_TUTORIAL_IN_PROGRESS', true);
    }

    // For tests, display it all the time
    // this.showSlide(1)

    this.unwatchHandler = this.$store.watch(function (state) {
      return state.launchTutorial;
    }, function (newLaunchTutorialValue) {
      if (newLaunchTutorialValue === true) {
        _this.showSlide(1);
      }
    });
  },
  destroyed: function destroyed() {
    if (this.unwatched !== null) {
      this.unwatchHandler();
    }
  },

  computed: {
    imageUrl: function imageUrl() {
      if (this.game) {
        return this.game.imageUrl ? this.game.imageUrl : __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL);
      }
    },
    gameDisplayedName: function gameDisplayedName() {
      if (this.game) {
        return this.game.gameDisplayedName ? this.game.gameDisplayedName : __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.tenant, 'title', DEFAULT_TITLE);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.tenant, 'title', DEFAULT_TITLE);
      }
    },
    gameIntroText: function gameIntroText() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.tenant, 'introText', __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName].introText ? __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[configName].introText : __WEBPACK_IMPORTED_MODULE_3__geogaming_config___default.a[DEFAULT_CONFIG_NAME].introText);
    }
  },
  methods: {
    showSlide: function showSlide(slideIndex) {
      var _this2 = this;

      this.$store.commit('LAUNCH_TUTORIAL', false);
      var newShow = [null, false, false, false, false, false, false];
      setTimeout(function () {
        if (slideIndex) {
          newShow[slideIndex] = true;
        }
        _this2.showSlides = newShow;
      });
    }
  },
  watch: {
    showSlides: function showSlides(_showSlides) {
      var hideSlidesState = [null, false, false, false, false, false, false];
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(_showSlides, hideSlidesState)) {
        this.$store.commit('IS_TUTORIAL_IN_PROGRESS', false);
      }
    }
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tutorial-gif-card',
  props: ['title', 'gifPath'],
  methods: {
    onClickPrevious: function onClickPrevious() {
      this.$emit('previous');
    },
    onClickNext: function onClickNext() {
      this.$emit('next');
    }
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/**
 * Here is the service responsible for watching user location.
 *
 * It needs to be a proper Vue component in order to have access to the $store,
 * and to commit the new location each time it changes.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'watch-location',
  mounted: function mounted() {
    console.log('Start watching user location...');
    this.watchUserLocation();
  },

  methods: {
    watchUserLocation: function watchUserLocation() {
      if (navigator.geolocation) {
        // https://developer.mozilla.org/en-US/docs/Web/API/PositionOptions
        navigator.geolocation.watchPosition(this.success, this.error, {
          enableHighAccuracy: true
        });
      } else {
        alert('Hum, it looks like your browser can\'t help us get your GPS position...');
      }
    },
    success: function success(position) {
      console.log(' >>> watchLocation / watchPosition() / success / New user location');
      var _position$coords = position.coords,
          latitude = _position$coords.latitude,
          longitude = _position$coords.longitude;

      // Push new location to store

      this.$store.commit('SET_USER_LOCATION', {
        lat: latitude,
        lng: longitude
      });

      this.$store.commit('SET_ERROR_MESSAGE', '');
    },
    error: function error(errorMessage) {
      console.error(errorMessage);

      this.$store.commit('SET_ERROR_MESSAGE', errorMessage.message);

      // Possible errors:
      // - User denied Geolocation
      // - Origin does not have permission to use Geolocation service --> Needs to be https
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return difficultyMap; });
var difficultyMap = {
  '1': 'Easy',
  '2': 'Medium',
  '3': 'Hard'
};

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = teamLogin;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTeamsByGameId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var baseUrl = 'https://dev-player.geogaming-back.com';
console.log('teamsService > baseUrl:', baseUrl);

function teamLogin(credentials, fingerprint) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
    method: 'post',
    url: baseUrl + '/login',
    data: {
      credentials: credentials,
      fingerprint: fingerprint
    }
  }).then(function (teamLoginResponse) {
    return teamLoginResponse.data;
  });
}

var getTeamsByGameId = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(gameId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (gameId) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', []);

          case 2:
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
              method: 'get',
              url: baseUrl + '/games/' + gameId + '/teams'
            });

          case 4:
            response = _context.sent;

            console.log(response);
            return _context.abrupt('return', response.data);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getTeamsByGameId(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getPhotos"] = getPhotos;
/* harmony export (immutable) */ __webpack_exports__["getChallengesLocations"] = getChallengesLocations;
/* harmony export (immutable) */ __webpack_exports__["setPositionToDefaultChallenge"] = setPositionToDefaultChallenge;
/* harmony export (immutable) */ __webpack_exports__["unlockQuestion"] = unlockQuestion;
/* harmony export (immutable) */ __webpack_exports__["uploadPicture"] = uploadPicture;
/* harmony export (immutable) */ __webpack_exports__["sendAnswer"] = sendAnswer;
/* harmony export (immutable) */ __webpack_exports__["getTeamLeaderboard"] = getTeamLeaderboard;
/* harmony export (immutable) */ __webpack_exports__["loginTeam"] = loginTeam;
/* harmony export (immutable) */ __webpack_exports__["logoutTeam"] = logoutTeam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_sync_service__ = __webpack_require__(175);





var baseUrl = 'https://dev-player.geogaming-back.com';

function getPhotos(store) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'get',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/photos/'
  }).catch(console.error);
}

function getChallengesLocations(store) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'get',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/challenges'
  }).then(function (questions) {
    console.log('locations received:', questions.data);

    store.commit('SET_CHALLENGES_LOCATIONS', questions.data);

    var userScore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* computeUserScore */])(questions.data);
    store.commit('SET_USER_SCORE', userScore);
  }).catch(function (err) {
    console.error(err);
  });
}

function setPositionToDefaultChallenge(store) {
  var _store$state = store.state,
      challengesLocations = _store$state.challengesLocations,
      userLocation = _store$state.userLocation;

  var challengeToReposition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(challengesLocations, function (question) {
    return !!question.defaultLocation;
  });

  if (!challengeToReposition) {
    console.log('XX No challenge with defaultLocation');
  } else if (!userLocation || !store.state.isUserAtChallengeLocation) {
    console.log('userLocation', userLocation);
    console.log('store.isUserAtChallengeLocation', store.state.isUserAtChallengeLocation);
    console.log('TOO EARLY !');
  } else {

    // Check if user doesn't already have a challenge close to him
    if (!store.state.isUserAtChallengeLocation.isUserInOneZone) {
      console.log('Reposition default challenge close to user');
      challengeToReposition.location = userLocation;
    } else {
      // Keep defaultLocation
      console.log('User already has a challenge close to him, keep defaultLocation');
      challengeToReposition.location = challengeToReposition.defaultLocation;
    }

    delete challengeToReposition.defaultLocation;
    // Tell backend to store this new challenge location
    setChallengePosition(store, challengeToReposition.challengeId, challengeToReposition.location);
  }

  store.commit('SET_CHALLENGES_LOCATIONS', challengesLocations);
}

function setChallengePosition(store, challengeId, location) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'post',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/questions/' + challengeId + '/location',
    data: {
      location: location
    }
  }).then(function () {
    console.log('Challenge ' + challengeId + ' position successfully saved to backend.');
  }).catch(function (err) {
    console.error(err);
  });
}

function unlockQuestion(store, challengeId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'put',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/questions/' + challengeId + '/unlock'
  });
}

function uploadPicture(store, _ref) {
  var challengeId = _ref.challengeId,
      photo = _ref.photo;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'put',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/photos/' + challengeId + '/upload',
    data: {
      photo: photo
    }
  });
}

function sendAnswer(store, _ref2) {
  var challengeId = _ref2.challengeId,
      answer = _ref2.answer;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'post',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teams/' + store.state.team.idTeam + '/questions/' + challengeId + '/submit',
    data: {
      answer: answer
    }
  });
}

function getTeamLeaderboard(store) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_axios_helper__["a" /* myaxios */])({
    method: 'get',
    url: baseUrl + '/games/' + store.state.game.idGame + '/teamleaderboard'
  });
}

function loginTeam(store, teamDetails) {
  store.commit('SET_CONFIG', teamDetails.config);
  store.commit('SET_TENANT', teamDetails.tenant);
  store.commit('SET_TEAM', teamDetails.team);
  store.commit('SET_GAME', teamDetails.game);
  store.commit('SET_QUESTION_RADIUS', teamDetails.game.questionRadius ? teamDetails.game.questionRadius : 80);
  store.commit('SET_API_KEY', teamDetails.authToken.token);
  store.commit('LOGIN', true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_app_sync_service__["b" /* setUpClient */])(teamDetails.team.idTeam);
}

function logoutTeam(store) {
  store.commit('LOGOUT');
  store.commit('SET_CONFIG', null);
  store.commit('SET_TENANT', null);
  store.commit('SET_GAME', null);
  store.commit('SET_TEAM', null);
  store.commit('SET_API_KEY', null);
  store.commit('SET_MAP_ZOOM', null);
  store.commit('SET_MAP_CENTER', null);
  store.commit('SET_CHALLENGES_LOCATIONS', null);
  store.commit('SET_QUESTION_RADIUS', 80);
}

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8a7941a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(979);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8a7941a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 351:
/***/ (function(module, exports) {

module.exports = {
	"graphqlEndpoint": "https://nuefclyjtrhpvnxzrt7kroovd4.appsync-api.ap-southeast-2.amazonaws.com/graphql",
	"region": "ap-southeast-2",
	"authenticationType": "API_KEY",
	"apiKey": "da2-v6xiqrsi3vfmhpircg64jcdo5i"
};

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			"aws-appsync@1.3.4",
			"/root/project"
		]
	],
	"_from": "aws-appsync@1.3.4",
	"_id": "aws-appsync@1.3.4",
	"_inBundle": false,
	"_integrity": "sha512-5tmCKLRlvUYWnjAIoEMMbQvATZJXXpzTmGZgFS4MoqmvpdIVVqh+oJb0t+JGs/JX7iXnm+FQVilEoDavpZ2ayQ==",
	"_location": "/aws-appsync",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "aws-appsync@1.3.4",
		"name": "aws-appsync",
		"escapedName": "aws-appsync",
		"rawSpec": "1.3.4",
		"saveSpec": null,
		"fetchSpec": "1.3.4"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/aws-appsync/-/aws-appsync-1.3.4.tgz",
	"_spec": "1.3.4",
	"_where": "/root/project",
	"author": {
		"name": "Amazon Web Services",
		"url": "https://aws.amazon.com/"
	},
	"bugs": {
		"url": "https://github.com/awslabs/aws-mobile-appsync-sdk-js/issues"
	},
	"dependencies": {
		"@redux-offline/redux-offline": "^2.2.1",
		"apollo-cache-inmemory": "^1.0.0",
		"apollo-client": "2.3.7",
		"apollo-link": "^1.0.0",
		"apollo-link-context": "^1.0.0",
		"apollo-link-http": "^1.0.0",
		"aws-sdk": "^2.139.0",
		"graphql": "^0.11.7",
		"redux": "^3.7.2",
		"redux-thunk": "^2.2.0",
		"setimmediate": "^1.0.5",
		"url": "^0.11.0",
		"uuid": "3.x"
	},
	"description": "AWS Mobile AppSync SDK for JavaScript",
	"devDependencies": {
		"@types/graphql": "0.12.4",
		"@types/jest": "^23.3.1",
		"@types/node": "^8.0.46",
		"@types/zen-observable": "^0.5.3",
		"graphql-tag": "^2.9.2",
		"jest": "^23.4.2",
		"ts-jest": "^23.0.1",
		"typescript": "^3.0.1"
	},
	"homepage": "https://github.com/awslabs/aws-mobile-appsync-sdk-js.git",
	"jest": {
		"transform": {
			"^.+\\.tsx?$": "ts-jest"
		},
		"testRegex": "(/__tests__/.*|(\\.|/)(test|spec))\\.(jsx?|tsx?)$",
		"moduleFileExtensions": [
			"ts",
			"tsx",
			"js",
			"jsx",
			"json",
			"node"
		],
		"testEnvironment": "node"
	},
	"license": "SEE LICENSE IN LICENSE",
	"main": "lib/index.js",
	"name": "aws-appsync",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/awslabs/aws-mobile-appsync-sdk-js.git"
	},
	"scripts": {
		"prepare": "tsc && cp -r src/vendor lib/vendor",
		"test": "jest --coverage --coverageReporters=text",
		"test-watch": "jest --watch"
	},
	"version": "1.3.4"
};

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-30",
		"endpointPrefix": "cognito-identity",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity",
		"serviceId": "Cognito Identity",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityService",
		"uid": "cognito-identity-2014-06-30"
	},
	"operations": {
		"CreateIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"DeleteIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityIdsToDelete"
				],
				"members": {
					"IdentityIdsToDelete": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedIdentityIds": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"ErrorCode": {}
							}
						}
					}
				}
			}
		},
		"DeleteIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			}
		},
		"DescribeIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {}
				}
			},
			"output": {
				"shape": "Sr"
			}
		},
		"DescribeIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetCredentialsForIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"CustomRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Credentials": {
						"type": "structure",
						"members": {
							"AccessKeyId": {},
							"SecretKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetId": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"AccountId": {},
					"IdentityPoolId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"GetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"GetOpenIdToken": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"GetOpenIdTokenForDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Logins"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"TokenDuration": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"ListIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"MaxResults"
				],
				"members": {
					"IdentityPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"HideDisabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Identities": {
						"type": "list",
						"member": {
							"shape": "Sr"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityPoolId": {},
								"IdentityPoolName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"LookupDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"DeveloperUserIdentifier": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DeveloperUserIdentifierList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"MergeDeveloperIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"SourceUserIdentifier",
					"DestinationUserIdentifier",
					"DeveloperProviderName",
					"IdentityPoolId"
				],
				"members": {
					"SourceUserIdentifier": {},
					"DestinationUserIdentifier": {},
					"DeveloperProviderName": {},
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"SetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Roles"
				],
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"UnlinkDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"IdentityPoolId",
					"DeveloperProviderName",
					"DeveloperUserIdentifier"
				],
				"members": {
					"IdentityId": {},
					"IdentityPoolId": {},
					"DeveloperProviderName": {},
					"DeveloperUserIdentifier": {}
				}
			}
		},
		"UnlinkIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"Logins",
					"LoginsToRemove"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"LoginsToRemove": {
						"shape": "Ss"
					}
				}
			}
		},
		"UpdateIdentityPool": {
			"input": {
				"shape": "Sg"
			},
			"output": {
				"shape": "Sg"
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ClientId": {},
					"ServerSideTokenCheck": {
						"type": "boolean"
					}
				}
			}
		},
		"Sf": {
			"type": "list",
			"member": {}
		},
		"Sg": {
			"type": "structure",
			"required": [
				"IdentityPoolId",
				"IdentityPoolName",
				"AllowUnauthenticatedIdentities"
			],
			"members": {
				"IdentityPoolId": {},
				"IdentityPoolName": {},
				"AllowUnauthenticatedIdentities": {
					"type": "boolean"
				},
				"SupportedLoginProviders": {
					"shape": "S4"
				},
				"DeveloperProviderName": {},
				"OpenIdConnectProviderARNs": {
					"shape": "S8"
				},
				"CognitoIdentityProviders": {
					"shape": "Sa"
				},
				"SamlProviderARNs": {
					"shape": "Sf"
				}
			}
		},
		"Sr": {
			"type": "structure",
			"members": {
				"IdentityId": {},
				"Logins": {
					"shape": "Ss"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S18": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1a": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"AmbiguousRoleResolution": {},
					"RulesConfiguration": {
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Claim",
										"MatchType",
										"Value",
										"RoleARN"
									],
									"members": {
										"Claim": {},
										"MatchType": {},
										"Value": {},
										"RoleARN": {}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

module.exports = {
	"acm": {
		"name": "ACM",
		"cors": true
	},
	"apigateway": {
		"name": "APIGateway",
		"cors": true
	},
	"applicationautoscaling": {
		"prefix": "application-autoscaling",
		"name": "ApplicationAutoScaling",
		"cors": true
	},
	"appstream": {
		"name": "AppStream"
	},
	"autoscaling": {
		"name": "AutoScaling",
		"cors": true
	},
	"batch": {
		"name": "Batch"
	},
	"budgets": {
		"name": "Budgets"
	},
	"clouddirectory": {
		"name": "CloudDirectory",
		"versions": [
			"2016-05-10*"
		]
	},
	"cloudformation": {
		"name": "CloudFormation",
		"cors": true
	},
	"cloudfront": {
		"name": "CloudFront",
		"versions": [
			"2013-05-12*",
			"2013-11-11*",
			"2014-05-31*",
			"2014-10-21*",
			"2014-11-06*",
			"2015-04-17*",
			"2015-07-27*",
			"2015-09-17*",
			"2016-01-13*",
			"2016-01-28*",
			"2016-08-01*",
			"2016-08-20*",
			"2016-09-07*",
			"2016-09-29*",
			"2016-11-25*",
			"2017-03-25*",
			"2017-10-30*"
		],
		"cors": true
	},
	"cloudhsm": {
		"name": "CloudHSM",
		"cors": true
	},
	"cloudsearch": {
		"name": "CloudSearch"
	},
	"cloudsearchdomain": {
		"name": "CloudSearchDomain"
	},
	"cloudtrail": {
		"name": "CloudTrail",
		"cors": true
	},
	"cloudwatch": {
		"prefix": "monitoring",
		"name": "CloudWatch",
		"cors": true
	},
	"cloudwatchevents": {
		"prefix": "events",
		"name": "CloudWatchEvents",
		"versions": [
			"2014-02-03*"
		],
		"cors": true
	},
	"cloudwatchlogs": {
		"prefix": "logs",
		"name": "CloudWatchLogs",
		"cors": true
	},
	"codebuild": {
		"name": "CodeBuild",
		"cors": true
	},
	"codecommit": {
		"name": "CodeCommit",
		"cors": true
	},
	"codedeploy": {
		"name": "CodeDeploy",
		"cors": true
	},
	"codepipeline": {
		"name": "CodePipeline",
		"cors": true
	},
	"cognitoidentity": {
		"prefix": "cognito-identity",
		"name": "CognitoIdentity",
		"cors": true
	},
	"cognitoidentityserviceprovider": {
		"prefix": "cognito-idp",
		"name": "CognitoIdentityServiceProvider",
		"cors": true
	},
	"cognitosync": {
		"prefix": "cognito-sync",
		"name": "CognitoSync",
		"cors": true
	},
	"configservice": {
		"prefix": "config",
		"name": "ConfigService",
		"cors": true
	},
	"cur": {
		"name": "CUR",
		"cors": true
	},
	"datapipeline": {
		"name": "DataPipeline"
	},
	"devicefarm": {
		"name": "DeviceFarm",
		"cors": true
	},
	"directconnect": {
		"name": "DirectConnect",
		"cors": true
	},
	"directoryservice": {
		"prefix": "ds",
		"name": "DirectoryService"
	},
	"discovery": {
		"name": "Discovery"
	},
	"dms": {
		"name": "DMS"
	},
	"dynamodb": {
		"name": "DynamoDB",
		"cors": true
	},
	"dynamodbstreams": {
		"prefix": "streams.dynamodb",
		"name": "DynamoDBStreams",
		"cors": true
	},
	"ec2": {
		"name": "EC2",
		"versions": [
			"2013-06-15*",
			"2013-10-15*",
			"2014-02-01*",
			"2014-05-01*",
			"2014-06-15*",
			"2014-09-01*",
			"2014-10-01*",
			"2015-03-01*",
			"2015-04-15*",
			"2015-10-01*",
			"2016-04-01*",
			"2016-09-15*"
		],
		"cors": true
	},
	"ecr": {
		"name": "ECR",
		"cors": true
	},
	"ecs": {
		"name": "ECS",
		"cors": true
	},
	"efs": {
		"prefix": "elasticfilesystem",
		"name": "EFS",
		"cors": true
	},
	"elasticache": {
		"name": "ElastiCache",
		"versions": [
			"2012-11-15*",
			"2014-03-24*",
			"2014-07-15*",
			"2014-09-30*"
		],
		"cors": true
	},
	"elasticbeanstalk": {
		"name": "ElasticBeanstalk",
		"cors": true
	},
	"elb": {
		"prefix": "elasticloadbalancing",
		"name": "ELB",
		"cors": true
	},
	"elbv2": {
		"prefix": "elasticloadbalancingv2",
		"name": "ELBv2",
		"cors": true
	},
	"emr": {
		"prefix": "elasticmapreduce",
		"name": "EMR",
		"cors": true
	},
	"es": {
		"name": "ES"
	},
	"elastictranscoder": {
		"name": "ElasticTranscoder",
		"cors": true
	},
	"firehose": {
		"name": "Firehose",
		"cors": true
	},
	"gamelift": {
		"name": "GameLift",
		"cors": true
	},
	"glacier": {
		"name": "Glacier"
	},
	"health": {
		"name": "Health"
	},
	"iam": {
		"name": "IAM"
	},
	"importexport": {
		"name": "ImportExport"
	},
	"inspector": {
		"name": "Inspector",
		"versions": [
			"2015-08-18*"
		],
		"cors": true
	},
	"iot": {
		"name": "Iot",
		"cors": true
	},
	"iotdata": {
		"prefix": "iot-data",
		"name": "IotData",
		"cors": true
	},
	"kinesis": {
		"name": "Kinesis",
		"cors": true
	},
	"kinesisanalytics": {
		"name": "KinesisAnalytics"
	},
	"kms": {
		"name": "KMS",
		"cors": true
	},
	"lambda": {
		"name": "Lambda",
		"cors": true
	},
	"lexruntime": {
		"prefix": "runtime.lex",
		"name": "LexRuntime",
		"cors": true
	},
	"lightsail": {
		"name": "Lightsail"
	},
	"machinelearning": {
		"name": "MachineLearning",
		"cors": true
	},
	"marketplacecommerceanalytics": {
		"name": "MarketplaceCommerceAnalytics",
		"cors": true
	},
	"marketplacemetering": {
		"prefix": "meteringmarketplace",
		"name": "MarketplaceMetering"
	},
	"mturk": {
		"prefix": "mturk-requester",
		"name": "MTurk",
		"cors": true
	},
	"mobileanalytics": {
		"name": "MobileAnalytics",
		"cors": true
	},
	"opsworks": {
		"name": "OpsWorks",
		"cors": true
	},
	"opsworkscm": {
		"name": "OpsWorksCM"
	},
	"organizations": {
		"name": "Organizations"
	},
	"pinpoint": {
		"name": "Pinpoint"
	},
	"polly": {
		"name": "Polly",
		"cors": true
	},
	"rds": {
		"name": "RDS",
		"versions": [
			"2014-09-01*"
		],
		"cors": true
	},
	"redshift": {
		"name": "Redshift",
		"cors": true
	},
	"rekognition": {
		"name": "Rekognition",
		"cors": true
	},
	"resourcegroupstaggingapi": {
		"name": "ResourceGroupsTaggingAPI"
	},
	"route53": {
		"name": "Route53",
		"cors": true
	},
	"route53domains": {
		"name": "Route53Domains",
		"cors": true
	},
	"s3": {
		"name": "S3",
		"dualstackAvailable": true,
		"cors": true
	},
	"servicecatalog": {
		"name": "ServiceCatalog",
		"cors": true
	},
	"ses": {
		"prefix": "email",
		"name": "SES",
		"cors": true
	},
	"shield": {
		"name": "Shield"
	},
	"simpledb": {
		"prefix": "sdb",
		"name": "SimpleDB"
	},
	"sms": {
		"name": "SMS"
	},
	"snowball": {
		"name": "Snowball"
	},
	"sns": {
		"name": "SNS",
		"cors": true
	},
	"sqs": {
		"name": "SQS",
		"cors": true
	},
	"ssm": {
		"name": "SSM",
		"cors": true
	},
	"storagegateway": {
		"name": "StorageGateway",
		"cors": true
	},
	"stepfunctions": {
		"prefix": "states",
		"name": "StepFunctions"
	},
	"sts": {
		"name": "STS",
		"cors": true
	},
	"support": {
		"name": "Support"
	},
	"swf": {
		"name": "SWF"
	},
	"xray": {
		"name": "XRay"
	},
	"waf": {
		"name": "WAF",
		"cors": true
	},
	"wafregional": {
		"prefix": "waf-regional",
		"name": "WAFRegional"
	},
	"workdocs": {
		"name": "WorkDocs",
		"cors": true
	},
	"workspaces": {
		"name": "WorkSpaces"
	},
	"codestar": {
		"name": "CodeStar"
	},
	"lexmodelbuildingservice": {
		"prefix": "lex-models",
		"name": "LexModelBuildingService",
		"cors": true
	},
	"marketplaceentitlementservice": {
		"prefix": "entitlement.marketplace",
		"name": "MarketplaceEntitlementService"
	},
	"athena": {
		"name": "Athena"
	},
	"greengrass": {
		"name": "Greengrass"
	},
	"dax": {
		"name": "DAX"
	},
	"migrationhub": {
		"prefix": "AWSMigrationHub",
		"name": "MigrationHub"
	},
	"cloudhsmv2": {
		"name": "CloudHSMV2"
	},
	"glue": {
		"name": "Glue"
	},
	"mobile": {
		"name": "Mobile"
	},
	"pricing": {
		"name": "Pricing"
	},
	"costexplorer": {
		"prefix": "ce",
		"name": "CostExplorer"
	},
	"mediaconvert": {
		"name": "MediaConvert"
	},
	"medialive": {
		"name": "MediaLive"
	},
	"mediapackage": {
		"name": "MediaPackage"
	},
	"mediastore": {
		"name": "MediaStore"
	},
	"mediastoredata": {
		"prefix": "mediastore-data",
		"name": "MediaStoreData"
	},
	"appsync": {
		"name": "AppSync"
	},
	"guardduty": {
		"name": "GuardDuty"
	},
	"mq": {
		"name": "MQ"
	},
	"comprehend": {
		"name": "Comprehend"
	},
	"iotjobsdataplane": {
		"prefix": "iot-jobs-data",
		"name": "IoTJobsDataPlane"
	},
	"kinesisvideoarchivedmedia": {
		"prefix": "kinesis-video-archived-media",
		"name": "KinesisVideoArchivedMedia",
		"cors": true
	},
	"kinesisvideomedia": {
		"prefix": "kinesis-video-media",
		"name": "KinesisVideoMedia"
	},
	"kinesisvideo": {
		"name": "KinesisVideo",
		"cors": true
	},
	"sagemakerruntime": {
		"prefix": "runtime.sagemaker",
		"name": "SageMakerRuntime"
	},
	"sagemaker": {
		"name": "SageMaker"
	},
	"translate": {
		"name": "Translate",
		"cors": true
	},
	"resourcegroups": {
		"prefix": "resource-groups",
		"name": "ResourceGroups"
	},
	"alexaforbusiness": {
		"name": "AlexaForBusiness"
	},
	"cloud9": {
		"name": "Cloud9"
	},
	"serverlessapplicationrepository": {
		"prefix": "serverlessrepo",
		"name": "ServerlessApplicationRepository"
	},
	"servicediscovery": {
		"name": "ServiceDiscovery"
	},
	"workmail": {
		"name": "WorkMail"
	},
	"autoscalingplans": {
		"prefix": "autoscaling-plans",
		"name": "AutoScalingPlans"
	},
	"transcribeservice": {
		"prefix": "transcribe",
		"name": "TranscribeService"
	},
	"connect": {
		"name": "Connect"
	},
	"acmpca": {
		"prefix": "acm-pca",
		"name": "ACMPCA"
	},
	"fms": {
		"name": "FMS"
	},
	"secretsmanager": {
		"name": "SecretsManager",
		"cors": true
	},
	"iotanalytics": {
		"name": "IoTAnalytics"
	},
	"iot1clickdevicesservice": {
		"prefix": "iot1click-devices",
		"name": "IoT1ClickDevicesService"
	},
	"iot1clickprojects": {
		"prefix": "iot1click-projects",
		"name": "IoT1ClickProjects"
	},
	"pi": {
		"name": "PI"
	},
	"neptune": {
		"name": "Neptune"
	},
	"mediatailor": {
		"name": "MediaTailor"
	},
	"eks": {
		"name": "EKS"
	},
	"macie": {
		"name": "Macie"
	},
	"dlm": {
		"name": "DLM"
	},
	"signer": {
		"name": "Signer"
	}
};

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2006-03-01",
		"checksumFormat": "md5",
		"endpointPrefix": "s3",
		"globalEndpoint": "s3.amazonaws.com",
		"protocol": "rest-xml",
		"serviceAbbreviation": "Amazon S3",
		"serviceFullName": "Amazon Simple Storage Service",
		"serviceId": "S3",
		"signatureVersion": "s3",
		"timestampFormat": "rfc822",
		"uid": "s3-2006-03-01"
	},
	"operations": {
		"AbortMultipartUpload": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"CompleteMultipartUpload": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MultipartUpload": {
						"locationName": "CompleteMultipartUpload",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"Parts": {
								"locationName": "Part",
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"ETag": {},
										"PartNumber": {
											"type": "integer"
										}
									}
								},
								"flattened": true
							}
						}
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "MultipartUpload"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {},
					"Bucket": {},
					"Key": {},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"ETag": {},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"CopyObject": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CopySource",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"CopySource": {
						"location": "header",
						"locationName": "x-amz-copy-source"
					},
					"CopySourceIfMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-match"
					},
					"CopySourceIfModifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-modified-since",
						"type": "timestamp"
					},
					"CopySourceIfNoneMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-none-match"
					},
					"CopySourceIfUnmodifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-unmodified-since",
						"type": "timestamp"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"MetadataDirective": {
						"location": "header",
						"locationName": "x-amz-metadata-directive"
					},
					"TaggingDirective": {
						"location": "header",
						"locationName": "x-amz-tagging-directive"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"CopySourceSSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
					},
					"CopySourceSSECustomerKey": {
						"shape": "S1c",
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
					},
					"CopySourceSSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CopyObjectResult": {
						"type": "structure",
						"members": {
							"ETag": {},
							"LastModified": {
								"type": "timestamp"
							}
						}
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"CopySourceVersionId": {
						"location": "header",
						"locationName": "x-amz-copy-source-version-id"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "CopyObjectResult"
			},
			"alias": "PutObjectCopy"
		},
		"CreateBucket": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CreateBucketConfiguration": {
						"locationName": "CreateBucketConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"LocationConstraint": {}
						}
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					}
				},
				"payload": "CreateBucketConfiguration"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			},
			"alias": "PutBucket"
		},
		"CreateMultipartUpload": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}?uploads"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AbortDate": {
						"location": "header",
						"locationName": "x-amz-abort-date",
						"type": "timestamp"
					},
					"AbortRuleId": {
						"location": "header",
						"locationName": "x-amz-abort-rule-id"
					},
					"Bucket": {
						"locationName": "Bucket"
					},
					"Key": {},
					"UploadId": {},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			},
			"alias": "InitiateMultipartUpload"
		},
		"DeleteBucket": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketAnalyticsConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketCors": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketEncryption": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?encryption"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketInventoryConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketLifecycle": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketMetricsConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketPolicy": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketReplication": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketTagging": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketWebsite": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteObject": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"DeleteObjectTagging": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					}
				}
			}
		},
		"DeleteObjects": {
			"http": {
				"requestUri": "/{Bucket}?delete"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Delete"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delete": {
						"locationName": "Delete",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Objects"
						],
						"members": {
							"Objects": {
								"locationName": "Object",
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Key"
									],
									"members": {
										"Key": {},
										"VersionId": {}
									}
								},
								"flattened": true
							},
							"Quiet": {
								"type": "boolean"
							}
						}
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "Delete"
			},
			"output": {
				"type": "structure",
				"members": {
					"Deleted": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"VersionId": {},
								"DeleteMarker": {
									"type": "boolean"
								},
								"DeleteMarkerVersionId": {}
							}
						},
						"flattened": true
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"Errors": {
						"locationName": "Error",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"VersionId": {},
								"Code": {},
								"Message": {}
							}
						},
						"flattened": true
					}
				}
			},
			"alias": "DeleteMultipleObjects"
		},
		"GetBucketAccelerateConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?accelerate"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {}
				}
			}
		},
		"GetBucketAcl": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Owner": {
						"shape": "S2v"
					},
					"Grants": {
						"shape": "S2y",
						"locationName": "AccessControlList"
					}
				}
			}
		},
		"GetBucketAnalyticsConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AnalyticsConfiguration": {
						"shape": "S37"
					}
				},
				"payload": "AnalyticsConfiguration"
			}
		},
		"GetBucketCors": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CORSRules": {
						"shape": "S3n",
						"locationName": "CORSRule"
					}
				}
			}
		},
		"GetBucketEncryption": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?encryption"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ServerSideEncryptionConfiguration": {
						"shape": "S40"
					}
				},
				"payload": "ServerSideEncryptionConfiguration"
			}
		},
		"GetBucketInventoryConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InventoryConfiguration": {
						"shape": "S46"
					}
				},
				"payload": "InventoryConfiguration"
			}
		},
		"GetBucketLifecycle": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S4m",
						"locationName": "Rule"
					}
				}
			},
			"deprecated": true
		},
		"GetBucketLifecycleConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S51",
						"locationName": "Rule"
					}
				}
			}
		},
		"GetBucketLocation": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?location"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LocationConstraint": {}
				}
			}
		},
		"GetBucketLogging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?logging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LoggingEnabled": {
						"shape": "S5b"
					}
				}
			}
		},
		"GetBucketMetricsConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MetricsConfiguration": {
						"shape": "S5j"
					}
				},
				"payload": "MetricsConfiguration"
			}
		},
		"GetBucketNotification": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"shape": "S5m"
			},
			"output": {
				"shape": "S5n"
			},
			"deprecated": true
		},
		"GetBucketNotificationConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"shape": "S5m"
			},
			"output": {
				"shape": "S5y"
			}
		},
		"GetBucketPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Policy": {}
				},
				"payload": "Policy"
			}
		},
		"GetBucketReplication": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReplicationConfiguration": {
						"shape": "S6h"
					}
				},
				"payload": "ReplicationConfiguration"
			}
		},
		"GetBucketRequestPayment": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?requestPayment"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Payer": {}
				}
			}
		},
		"GetBucketTagging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"TagSet": {
						"shape": "S3d"
					}
				}
			}
		},
		"GetBucketVersioning": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?versioning"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {},
					"MFADelete": {
						"locationName": "MfaDelete"
					}
				}
			}
		},
		"GetBucketWebsite": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RedirectAllRequestsTo": {
						"shape": "S75"
					},
					"IndexDocument": {
						"shape": "S78"
					},
					"ErrorDocument": {
						"shape": "S7a"
					},
					"RoutingRules": {
						"shape": "S7b"
					}
				}
			}
		},
		"GetObject": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					},
					"IfModifiedSince": {
						"location": "header",
						"locationName": "If-Modified-Since",
						"type": "timestamp"
					},
					"IfNoneMatch": {
						"location": "header",
						"locationName": "If-None-Match"
					},
					"IfUnmodifiedSince": {
						"location": "header",
						"locationName": "If-Unmodified-Since",
						"type": "timestamp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Range": {
						"location": "header",
						"locationName": "Range"
					},
					"ResponseCacheControl": {
						"location": "querystring",
						"locationName": "response-cache-control"
					},
					"ResponseContentDisposition": {
						"location": "querystring",
						"locationName": "response-content-disposition"
					},
					"ResponseContentEncoding": {
						"location": "querystring",
						"locationName": "response-content-encoding"
					},
					"ResponseContentLanguage": {
						"location": "querystring",
						"locationName": "response-content-language"
					},
					"ResponseContentType": {
						"location": "querystring",
						"locationName": "response-content-type"
					},
					"ResponseExpires": {
						"location": "querystring",
						"locationName": "response-expires",
						"type": "timestamp"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"AcceptRanges": {
						"location": "header",
						"locationName": "accept-ranges"
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"Restore": {
						"location": "header",
						"locationName": "x-amz-restore"
					},
					"LastModified": {
						"location": "header",
						"locationName": "Last-Modified",
						"type": "timestamp"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"MissingMeta": {
						"location": "header",
						"locationName": "x-amz-missing-meta",
						"type": "integer"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentRange": {
						"location": "header",
						"locationName": "Content-Range"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"ReplicationStatus": {
						"location": "header",
						"locationName": "x-amz-replication-status"
					},
					"PartsCount": {
						"location": "header",
						"locationName": "x-amz-mp-parts-count",
						"type": "integer"
					},
					"TagCount": {
						"location": "header",
						"locationName": "x-amz-tagging-count",
						"type": "integer"
					}
				},
				"payload": "Body"
			}
		},
		"GetObjectAcl": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Owner": {
						"shape": "S2v"
					},
					"Grants": {
						"shape": "S2y",
						"locationName": "AccessControlList"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"GetObjectTagging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"TagSet": {
						"shape": "S3d"
					}
				}
			}
		},
		"GetObjectTorrent": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?torrent"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "Body"
			}
		},
		"HeadBucket": {
			"http": {
				"method": "HEAD",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"HeadObject": {
			"http": {
				"method": "HEAD",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					},
					"IfModifiedSince": {
						"location": "header",
						"locationName": "If-Modified-Since",
						"type": "timestamp"
					},
					"IfNoneMatch": {
						"location": "header",
						"locationName": "If-None-Match"
					},
					"IfUnmodifiedSince": {
						"location": "header",
						"locationName": "If-Unmodified-Since",
						"type": "timestamp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Range": {
						"location": "header",
						"locationName": "Range"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"AcceptRanges": {
						"location": "header",
						"locationName": "accept-ranges"
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"Restore": {
						"location": "header",
						"locationName": "x-amz-restore"
					},
					"LastModified": {
						"location": "header",
						"locationName": "Last-Modified",
						"type": "timestamp"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"MissingMeta": {
						"location": "header",
						"locationName": "x-amz-missing-meta",
						"type": "integer"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"ReplicationStatus": {
						"location": "header",
						"locationName": "x-amz-replication-status"
					},
					"PartsCount": {
						"location": "header",
						"locationName": "x-amz-mp-parts-count",
						"type": "integer"
					}
				}
			}
		},
		"ListBucketAnalyticsConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"AnalyticsConfigurationList": {
						"locationName": "AnalyticsConfiguration",
						"type": "list",
						"member": {
							"shape": "S37"
						},
						"flattened": true
					}
				}
			}
		},
		"ListBucketInventoryConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ContinuationToken": {},
					"InventoryConfigurationList": {
						"locationName": "InventoryConfiguration",
						"type": "list",
						"member": {
							"shape": "S46"
						},
						"flattened": true
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextContinuationToken": {}
				}
			}
		},
		"ListBucketMetricsConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"MetricsConfigurationList": {
						"locationName": "MetricsConfiguration",
						"type": "list",
						"member": {
							"shape": "S5j"
						},
						"flattened": true
					}
				}
			}
		},
		"ListBuckets": {
			"http": {
				"method": "GET"
			},
			"output": {
				"type": "structure",
				"members": {
					"Buckets": {
						"type": "list",
						"member": {
							"locationName": "Bucket",
							"type": "structure",
							"members": {
								"Name": {},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"Owner": {
						"shape": "S2v"
					}
				}
			},
			"alias": "GetService"
		},
		"ListMultipartUploads": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?uploads"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"KeyMarker": {
						"location": "querystring",
						"locationName": "key-marker"
					},
					"MaxUploads": {
						"location": "querystring",
						"locationName": "max-uploads",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"UploadIdMarker": {
						"location": "querystring",
						"locationName": "upload-id-marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"KeyMarker": {},
					"UploadIdMarker": {},
					"NextKeyMarker": {},
					"Prefix": {},
					"Delimiter": {},
					"NextUploadIdMarker": {},
					"MaxUploads": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Uploads": {
						"locationName": "Upload",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"UploadId": {},
								"Key": {},
								"Initiated": {
									"type": "timestamp"
								},
								"StorageClass": {},
								"Owner": {
									"shape": "S2v"
								},
								"Initiator": {
									"shape": "S97"
								}
							}
						},
						"flattened": true
					},
					"CommonPrefixes": {
						"shape": "S98"
					},
					"EncodingType": {}
				}
			}
		},
		"ListObjectVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?versions"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"KeyMarker": {
						"location": "querystring",
						"locationName": "key-marker"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"VersionIdMarker": {
						"location": "querystring",
						"locationName": "version-id-marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"KeyMarker": {},
					"VersionIdMarker": {},
					"NextKeyMarker": {},
					"NextVersionIdMarker": {},
					"Versions": {
						"locationName": "Version",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ETag": {},
								"Size": {
									"type": "integer"
								},
								"StorageClass": {},
								"Key": {},
								"VersionId": {},
								"IsLatest": {
									"type": "boolean"
								},
								"LastModified": {
									"type": "timestamp"
								},
								"Owner": {
									"shape": "S2v"
								}
							}
						},
						"flattened": true
					},
					"DeleteMarkers": {
						"locationName": "DeleteMarker",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Owner": {
									"shape": "S2v"
								},
								"Key": {},
								"VersionId": {},
								"IsLatest": {
									"type": "boolean"
								},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"flattened": true
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S98"
					},
					"EncodingType": {}
				}
			},
			"alias": "GetBucketObjectVersions"
		},
		"ListObjects": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"Marker": {},
					"NextMarker": {},
					"Contents": {
						"shape": "S9q"
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S98"
					},
					"EncodingType": {}
				}
			},
			"alias": "GetBucket"
		},
		"ListObjectsV2": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?list-type=2"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					},
					"FetchOwner": {
						"location": "querystring",
						"locationName": "fetch-owner",
						"type": "boolean"
					},
					"StartAfter": {
						"location": "querystring",
						"locationName": "start-after"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"Contents": {
						"shape": "S9q"
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S98"
					},
					"EncodingType": {},
					"KeyCount": {
						"type": "integer"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"StartAfter": {}
				}
			}
		},
		"ListParts": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MaxParts": {
						"location": "querystring",
						"locationName": "max-parts",
						"type": "integer"
					},
					"PartNumberMarker": {
						"location": "querystring",
						"locationName": "part-number-marker",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AbortDate": {
						"location": "header",
						"locationName": "x-amz-abort-date",
						"type": "timestamp"
					},
					"AbortRuleId": {
						"location": "header",
						"locationName": "x-amz-abort-rule-id"
					},
					"Bucket": {},
					"Key": {},
					"UploadId": {},
					"PartNumberMarker": {
						"type": "integer"
					},
					"NextPartNumberMarker": {
						"type": "integer"
					},
					"MaxParts": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Parts": {
						"locationName": "Part",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PartNumber": {
									"type": "integer"
								},
								"LastModified": {
									"type": "timestamp"
								},
								"ETag": {},
								"Size": {
									"type": "integer"
								}
							}
						},
						"flattened": true
					},
					"Initiator": {
						"shape": "S97"
					},
					"Owner": {
						"shape": "S2v"
					},
					"StorageClass": {},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutBucketAccelerateConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?accelerate"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"AccelerateConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"AccelerateConfiguration": {
						"locationName": "AccelerateConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"Status": {}
						}
					}
				},
				"payload": "AccelerateConfiguration"
			}
		},
		"PutBucketAcl": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"AccessControlPolicy": {
						"shape": "Sa8",
						"locationName": "AccessControlPolicy",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					}
				},
				"payload": "AccessControlPolicy"
			}
		},
		"PutBucketAnalyticsConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"AnalyticsConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"AnalyticsConfiguration": {
						"shape": "S37",
						"locationName": "AnalyticsConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "AnalyticsConfiguration"
			}
		},
		"PutBucketCors": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CORSConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CORSConfiguration": {
						"locationName": "CORSConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"CORSRules"
						],
						"members": {
							"CORSRules": {
								"shape": "S3n",
								"locationName": "CORSRule"
							}
						}
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					}
				},
				"payload": "CORSConfiguration"
			}
		},
		"PutBucketEncryption": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?encryption"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"ServerSideEncryptionConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ServerSideEncryptionConfiguration": {
						"shape": "S40",
						"locationName": "ServerSideEncryptionConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "ServerSideEncryptionConfiguration"
			}
		},
		"PutBucketInventoryConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"InventoryConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"InventoryConfiguration": {
						"shape": "S46",
						"locationName": "InventoryConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "InventoryConfiguration"
			}
		},
		"PutBucketLifecycle": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"LifecycleConfiguration": {
						"locationName": "LifecycleConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"shape": "S4m",
								"locationName": "Rule"
							}
						}
					}
				},
				"payload": "LifecycleConfiguration"
			},
			"deprecated": true
		},
		"PutBucketLifecycleConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"LifecycleConfiguration": {
						"locationName": "LifecycleConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"shape": "S51",
								"locationName": "Rule"
							}
						}
					}
				},
				"payload": "LifecycleConfiguration"
			}
		},
		"PutBucketLogging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?logging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"BucketLoggingStatus"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"BucketLoggingStatus": {
						"locationName": "BucketLoggingStatus",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"LoggingEnabled": {
								"shape": "S5b"
							}
						}
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					}
				},
				"payload": "BucketLoggingStatus"
			}
		},
		"PutBucketMetricsConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"MetricsConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"MetricsConfiguration": {
						"shape": "S5j",
						"locationName": "MetricsConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "MetricsConfiguration"
			}
		},
		"PutBucketNotification": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"NotificationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"NotificationConfiguration": {
						"shape": "S5n",
						"locationName": "NotificationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "NotificationConfiguration"
			},
			"deprecated": true
		},
		"PutBucketNotificationConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"NotificationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"NotificationConfiguration": {
						"shape": "S5y",
						"locationName": "NotificationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "NotificationConfiguration"
			}
		},
		"PutBucketPolicy": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Policy"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ConfirmRemoveSelfBucketAccess": {
						"location": "header",
						"locationName": "x-amz-confirm-remove-self-bucket-access",
						"type": "boolean"
					},
					"Policy": {}
				},
				"payload": "Policy"
			}
		},
		"PutBucketReplication": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"ReplicationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ReplicationConfiguration": {
						"shape": "S6h",
						"locationName": "ReplicationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "ReplicationConfiguration"
			}
		},
		"PutBucketRequestPayment": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?requestPayment"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"RequestPaymentConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"RequestPaymentConfiguration": {
						"locationName": "RequestPaymentConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Payer"
						],
						"members": {
							"Payer": {}
						}
					}
				},
				"payload": "RequestPaymentConfiguration"
			}
		},
		"PutBucketTagging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Tagging"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Tagging": {
						"shape": "Sau",
						"locationName": "Tagging",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "Tagging"
			}
		},
		"PutBucketVersioning": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?versioning"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"VersioningConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"VersioningConfiguration": {
						"locationName": "VersioningConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"MFADelete": {
								"locationName": "MfaDelete"
							},
							"Status": {}
						}
					}
				},
				"payload": "VersioningConfiguration"
			}
		},
		"PutBucketWebsite": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"WebsiteConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"WebsiteConfiguration": {
						"locationName": "WebsiteConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"ErrorDocument": {
								"shape": "S7a"
							},
							"IndexDocument": {
								"shape": "S78"
							},
							"RedirectAllRequestsTo": {
								"shape": "S75"
							},
							"RoutingRules": {
								"shape": "S7b"
							}
						}
					}
				},
				"payload": "WebsiteConfiguration"
			}
		},
		"PutObject": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				},
				"payload": "Body"
			},
			"output": {
				"type": "structure",
				"members": {
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutObjectAcl": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"AccessControlPolicy": {
						"shape": "Sa8",
						"locationName": "AccessControlPolicy",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				},
				"payload": "AccessControlPolicy"
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutObjectTagging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"Tagging"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Tagging": {
						"shape": "Sau",
						"locationName": "Tagging",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "Tagging"
			},
			"output": {
				"type": "structure",
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					}
				}
			}
		},
		"RestoreObject": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}?restore"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RestoreRequest": {
						"locationName": "RestoreRequest",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"Days": {
								"type": "integer"
							},
							"GlacierJobParameters": {
								"type": "structure",
								"required": [
									"Tier"
								],
								"members": {
									"Tier": {}
								}
							},
							"Type": {},
							"Tier": {},
							"Description": {},
							"SelectParameters": {
								"type": "structure",
								"required": [
									"InputSerialization",
									"ExpressionType",
									"Expression",
									"OutputSerialization"
								],
								"members": {
									"InputSerialization": {
										"shape": "Sbd"
									},
									"ExpressionType": {},
									"Expression": {},
									"OutputSerialization": {
										"shape": "Sbr"
									}
								}
							},
							"OutputLocation": {
								"type": "structure",
								"members": {
									"S3": {
										"type": "structure",
										"required": [
											"BucketName",
											"Prefix"
										],
										"members": {
											"BucketName": {},
											"Prefix": {},
											"Encryption": {
												"type": "structure",
												"required": [
													"EncryptionType"
												],
												"members": {
													"EncryptionType": {},
													"KMSKeyId": {
														"shape": "Sj"
													},
													"KMSContext": {}
												}
											},
											"CannedACL": {},
											"AccessControlList": {
												"shape": "S2y"
											},
											"Tagging": {
												"shape": "Sau"
											},
											"UserMetadata": {
												"type": "list",
												"member": {
													"locationName": "MetadataEntry",
													"type": "structure",
													"members": {
														"Name": {},
														"Value": {}
													}
												}
											},
											"StorageClass": {}
										}
									}
								}
							}
						}
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "RestoreRequest"
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"RestoreOutputPath": {
						"location": "header",
						"locationName": "x-amz-restore-output-path"
					}
				}
			},
			"alias": "PostObjectRestore"
		},
		"SelectObjectContent": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}?select&select-type=2"
			},
			"input": {
				"locationName": "SelectObjectContentRequest",
				"xmlNamespace": {
					"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
				},
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"Expression",
					"ExpressionType",
					"InputSerialization",
					"OutputSerialization"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"Expression": {},
					"ExpressionType": {},
					"RequestProgress": {
						"type": "structure",
						"members": {
							"Enabled": {
								"type": "boolean"
							}
						}
					},
					"InputSerialization": {
						"shape": "Sbd"
					},
					"OutputSerialization": {
						"shape": "Sbr"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Payload": {
						"type": "structure",
						"members": {
							"Records": {
								"type": "structure",
								"members": {
									"Payload": {
										"eventpayload": true,
										"type": "blob"
									}
								},
								"event": true
							},
							"Stats": {
								"type": "structure",
								"members": {
									"Details": {
										"eventpayload": true,
										"type": "structure",
										"members": {
											"BytesScanned": {
												"type": "long"
											},
											"BytesProcessed": {
												"type": "long"
											},
											"BytesReturned": {
												"type": "long"
											}
										}
									}
								},
								"event": true
							},
							"Progress": {
								"type": "structure",
								"members": {
									"Details": {
										"eventpayload": true,
										"type": "structure",
										"members": {
											"BytesScanned": {
												"type": "long"
											},
											"BytesProcessed": {
												"type": "long"
											},
											"BytesReturned": {
												"type": "long"
											}
										}
									}
								},
								"event": true
							},
							"Cont": {
								"type": "structure",
								"members": {},
								"event": true
							},
							"End": {
								"type": "structure",
								"members": {},
								"event": true
							}
						},
						"eventstream": true
					}
				},
				"payload": "Payload"
			}
		},
		"UploadPart": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"PartNumber",
					"UploadId"
				],
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "Body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"UploadPartCopy": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CopySource",
					"Key",
					"PartNumber",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CopySource": {
						"location": "header",
						"locationName": "x-amz-copy-source"
					},
					"CopySourceIfMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-match"
					},
					"CopySourceIfModifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-modified-since",
						"type": "timestamp"
					},
					"CopySourceIfNoneMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-none-match"
					},
					"CopySourceIfUnmodifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-unmodified-since",
						"type": "timestamp"
					},
					"CopySourceRange": {
						"location": "header",
						"locationName": "x-amz-copy-source-range"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"CopySourceSSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
					},
					"CopySourceSSECustomerKey": {
						"shape": "S1c",
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
					},
					"CopySourceSSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CopySourceVersionId": {
						"location": "header",
						"locationName": "x-amz-copy-source-version-id"
					},
					"CopyPartResult": {
						"type": "structure",
						"members": {
							"ETag": {},
							"LastModified": {
								"type": "timestamp"
							}
						}
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "CopyPartResult"
			}
		}
	},
	"shapes": {
		"Sj": {
			"type": "string",
			"sensitive": true
		},
		"S11": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S19": {
			"type": "blob",
			"sensitive": true
		},
		"S1c": {
			"type": "blob",
			"sensitive": true
		},
		"S2v": {
			"type": "structure",
			"members": {
				"DisplayName": {},
				"ID": {}
			}
		},
		"S2y": {
			"type": "list",
			"member": {
				"locationName": "Grant",
				"type": "structure",
				"members": {
					"Grantee": {
						"shape": "S30"
					},
					"Permission": {}
				}
			}
		},
		"S30": {
			"type": "structure",
			"required": [
				"Type"
			],
			"members": {
				"DisplayName": {},
				"EmailAddress": {},
				"ID": {},
				"Type": {
					"locationName": "xsi:type",
					"xmlAttribute": true
				},
				"URI": {}
			},
			"xmlNamespace": {
				"prefix": "xsi",
				"uri": "http://www.w3.org/2001/XMLSchema-instance"
			}
		},
		"S37": {
			"type": "structure",
			"required": [
				"Id",
				"StorageClassAnalysis"
			],
			"members": {
				"Id": {},
				"Filter": {
					"type": "structure",
					"members": {
						"Prefix": {},
						"Tag": {
							"shape": "S3a"
						},
						"And": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tags": {
									"shape": "S3d",
									"flattened": true,
									"locationName": "Tag"
								}
							}
						}
					}
				},
				"StorageClassAnalysis": {
					"type": "structure",
					"members": {
						"DataExport": {
							"type": "structure",
							"required": [
								"OutputSchemaVersion",
								"Destination"
							],
							"members": {
								"OutputSchemaVersion": {},
								"Destination": {
									"type": "structure",
									"required": [
										"S3BucketDestination"
									],
									"members": {
										"S3BucketDestination": {
											"type": "structure",
											"required": [
												"Format",
												"Bucket"
											],
											"members": {
												"Format": {},
												"BucketAccountId": {},
												"Bucket": {},
												"Prefix": {}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"S3a": {
			"type": "structure",
			"required": [
				"Key",
				"Value"
			],
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"S3d": {
			"type": "list",
			"member": {
				"shape": "S3a",
				"locationName": "Tag"
			}
		},
		"S3n": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AllowedMethods",
					"AllowedOrigins"
				],
				"members": {
					"AllowedHeaders": {
						"locationName": "AllowedHeader",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"AllowedMethods": {
						"locationName": "AllowedMethod",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"AllowedOrigins": {
						"locationName": "AllowedOrigin",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"ExposeHeaders": {
						"locationName": "ExposeHeader",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"MaxAgeSeconds": {
						"type": "integer"
					}
				}
			},
			"flattened": true
		},
		"S40": {
			"type": "structure",
			"required": [
				"Rules"
			],
			"members": {
				"Rules": {
					"locationName": "Rule",
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"ApplyServerSideEncryptionByDefault": {
								"type": "structure",
								"required": [
									"SSEAlgorithm"
								],
								"members": {
									"SSEAlgorithm": {},
									"KMSMasterKeyID": {
										"shape": "Sj"
									}
								}
							}
						}
					},
					"flattened": true
				}
			}
		},
		"S46": {
			"type": "structure",
			"required": [
				"Destination",
				"IsEnabled",
				"Id",
				"IncludedObjectVersions",
				"Schedule"
			],
			"members": {
				"Destination": {
					"type": "structure",
					"required": [
						"S3BucketDestination"
					],
					"members": {
						"S3BucketDestination": {
							"type": "structure",
							"required": [
								"Bucket",
								"Format"
							],
							"members": {
								"AccountId": {},
								"Bucket": {},
								"Format": {},
								"Prefix": {},
								"Encryption": {
									"type": "structure",
									"members": {
										"SSES3": {
											"locationName": "SSE-S3",
											"type": "structure",
											"members": {}
										},
										"SSEKMS": {
											"locationName": "SSE-KMS",
											"type": "structure",
											"required": [
												"KeyId"
											],
											"members": {
												"KeyId": {
													"shape": "Sj"
												}
											}
										}
									}
								}
							}
						}
					}
				},
				"IsEnabled": {
					"type": "boolean"
				},
				"Filter": {
					"type": "structure",
					"required": [
						"Prefix"
					],
					"members": {
						"Prefix": {}
					}
				},
				"Id": {},
				"IncludedObjectVersions": {},
				"OptionalFields": {
					"type": "list",
					"member": {
						"locationName": "Field"
					}
				},
				"Schedule": {
					"type": "structure",
					"required": [
						"Frequency"
					],
					"members": {
						"Frequency": {}
					}
				}
			}
		},
		"S4m": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Prefix",
					"Status"
				],
				"members": {
					"Expiration": {
						"shape": "S4o"
					},
					"ID": {},
					"Prefix": {},
					"Status": {},
					"Transition": {
						"shape": "S4t"
					},
					"NoncurrentVersionTransition": {
						"shape": "S4v"
					},
					"NoncurrentVersionExpiration": {
						"shape": "S4w"
					},
					"AbortIncompleteMultipartUpload": {
						"shape": "S4x"
					}
				}
			},
			"flattened": true
		},
		"S4o": {
			"type": "structure",
			"members": {
				"Date": {
					"shape": "S4p"
				},
				"Days": {
					"type": "integer"
				},
				"ExpiredObjectDeleteMarker": {
					"type": "boolean"
				}
			}
		},
		"S4p": {
			"type": "timestamp",
			"timestampFormat": "iso8601"
		},
		"S4t": {
			"type": "structure",
			"members": {
				"Date": {
					"shape": "S4p"
				},
				"Days": {
					"type": "integer"
				},
				"StorageClass": {}
			}
		},
		"S4v": {
			"type": "structure",
			"members": {
				"NoncurrentDays": {
					"type": "integer"
				},
				"StorageClass": {}
			}
		},
		"S4w": {
			"type": "structure",
			"members": {
				"NoncurrentDays": {
					"type": "integer"
				}
			}
		},
		"S4x": {
			"type": "structure",
			"members": {
				"DaysAfterInitiation": {
					"type": "integer"
				}
			}
		},
		"S51": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Expiration": {
						"shape": "S4o"
					},
					"ID": {},
					"Prefix": {
						"deprecated": true
					},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S3a"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3d",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					},
					"Status": {},
					"Transitions": {
						"locationName": "Transition",
						"type": "list",
						"member": {
							"shape": "S4t"
						},
						"flattened": true
					},
					"NoncurrentVersionTransitions": {
						"locationName": "NoncurrentVersionTransition",
						"type": "list",
						"member": {
							"shape": "S4v"
						},
						"flattened": true
					},
					"NoncurrentVersionExpiration": {
						"shape": "S4w"
					},
					"AbortIncompleteMultipartUpload": {
						"shape": "S4x"
					}
				}
			},
			"flattened": true
		},
		"S5b": {
			"type": "structure",
			"required": [
				"TargetBucket",
				"TargetPrefix"
			],
			"members": {
				"TargetBucket": {},
				"TargetGrants": {
					"type": "list",
					"member": {
						"locationName": "Grant",
						"type": "structure",
						"members": {
							"Grantee": {
								"shape": "S30"
							},
							"Permission": {}
						}
					}
				},
				"TargetPrefix": {}
			}
		},
		"S5j": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {},
				"Filter": {
					"type": "structure",
					"members": {
						"Prefix": {},
						"Tag": {
							"shape": "S3a"
						},
						"And": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tags": {
									"shape": "S3d",
									"flattened": true,
									"locationName": "Tag"
								}
							}
						}
					}
				}
			}
		},
		"S5m": {
			"type": "structure",
			"required": [
				"Bucket"
			],
			"members": {
				"Bucket": {
					"location": "uri",
					"locationName": "Bucket"
				}
			}
		},
		"S5n": {
			"type": "structure",
			"members": {
				"TopicConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Events": {
							"shape": "S5q",
							"locationName": "Event"
						},
						"Event": {
							"deprecated": true
						},
						"Topic": {}
					}
				},
				"QueueConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Event": {
							"deprecated": true
						},
						"Events": {
							"shape": "S5q",
							"locationName": "Event"
						},
						"Queue": {}
					}
				},
				"CloudFunctionConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Event": {
							"deprecated": true
						},
						"Events": {
							"shape": "S5q",
							"locationName": "Event"
						},
						"CloudFunction": {},
						"InvocationRole": {}
					}
				}
			}
		},
		"S5q": {
			"type": "list",
			"member": {},
			"flattened": true
		},
		"S5y": {
			"type": "structure",
			"members": {
				"TopicConfigurations": {
					"locationName": "TopicConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"TopicArn",
							"Events"
						],
						"members": {
							"Id": {},
							"TopicArn": {
								"locationName": "Topic"
							},
							"Events": {
								"shape": "S5q",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S61"
							}
						}
					},
					"flattened": true
				},
				"QueueConfigurations": {
					"locationName": "QueueConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"QueueArn",
							"Events"
						],
						"members": {
							"Id": {},
							"QueueArn": {
								"locationName": "Queue"
							},
							"Events": {
								"shape": "S5q",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S61"
							}
						}
					},
					"flattened": true
				},
				"LambdaFunctionConfigurations": {
					"locationName": "CloudFunctionConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"LambdaFunctionArn",
							"Events"
						],
						"members": {
							"Id": {},
							"LambdaFunctionArn": {
								"locationName": "CloudFunction"
							},
							"Events": {
								"shape": "S5q",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S61"
							}
						}
					},
					"flattened": true
				}
			}
		},
		"S61": {
			"type": "structure",
			"members": {
				"Key": {
					"locationName": "S3Key",
					"type": "structure",
					"members": {
						"FilterRules": {
							"locationName": "FilterRule",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Value": {}
								}
							},
							"flattened": true
						}
					}
				}
			}
		},
		"S6h": {
			"type": "structure",
			"required": [
				"Role",
				"Rules"
			],
			"members": {
				"Role": {},
				"Rules": {
					"locationName": "Rule",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Prefix",
							"Status",
							"Destination"
						],
						"members": {
							"ID": {},
							"Prefix": {},
							"Status": {},
							"SourceSelectionCriteria": {
								"type": "structure",
								"members": {
									"SseKmsEncryptedObjects": {
										"type": "structure",
										"required": [
											"Status"
										],
										"members": {
											"Status": {}
										}
									}
								}
							},
							"Destination": {
								"type": "structure",
								"required": [
									"Bucket"
								],
								"members": {
									"Bucket": {},
									"Account": {},
									"StorageClass": {},
									"AccessControlTranslation": {
										"type": "structure",
										"required": [
											"Owner"
										],
										"members": {
											"Owner": {}
										}
									},
									"EncryptionConfiguration": {
										"type": "structure",
										"members": {
											"ReplicaKmsKeyID": {}
										}
									}
								}
							}
						}
					},
					"flattened": true
				}
			}
		},
		"S75": {
			"type": "structure",
			"required": [
				"HostName"
			],
			"members": {
				"HostName": {},
				"Protocol": {}
			}
		},
		"S78": {
			"type": "structure",
			"required": [
				"Suffix"
			],
			"members": {
				"Suffix": {}
			}
		},
		"S7a": {
			"type": "structure",
			"required": [
				"Key"
			],
			"members": {
				"Key": {}
			}
		},
		"S7b": {
			"type": "list",
			"member": {
				"locationName": "RoutingRule",
				"type": "structure",
				"required": [
					"Redirect"
				],
				"members": {
					"Condition": {
						"type": "structure",
						"members": {
							"HttpErrorCodeReturnedEquals": {},
							"KeyPrefixEquals": {}
						}
					},
					"Redirect": {
						"type": "structure",
						"members": {
							"HostName": {},
							"HttpRedirectCode": {},
							"Protocol": {},
							"ReplaceKeyPrefixWith": {},
							"ReplaceKeyWith": {}
						}
					}
				}
			}
		},
		"S97": {
			"type": "structure",
			"members": {
				"ID": {},
				"DisplayName": {}
			}
		},
		"S98": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Prefix": {}
				}
			},
			"flattened": true
		},
		"S9q": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"LastModified": {
						"type": "timestamp"
					},
					"ETag": {},
					"Size": {
						"type": "integer"
					},
					"StorageClass": {},
					"Owner": {
						"shape": "S2v"
					}
				}
			},
			"flattened": true
		},
		"Sa8": {
			"type": "structure",
			"members": {
				"Grants": {
					"shape": "S2y",
					"locationName": "AccessControlList"
				},
				"Owner": {
					"shape": "S2v"
				}
			}
		},
		"Sau": {
			"type": "structure",
			"required": [
				"TagSet"
			],
			"members": {
				"TagSet": {
					"shape": "S3d"
				}
			}
		},
		"Sbd": {
			"type": "structure",
			"members": {
				"CSV": {
					"type": "structure",
					"members": {
						"FileHeaderInfo": {},
						"Comments": {},
						"QuoteEscapeCharacter": {},
						"RecordDelimiter": {},
						"FieldDelimiter": {},
						"QuoteCharacter": {},
						"AllowQuotedRecordDelimiter": {
							"type": "boolean"
						}
					}
				},
				"CompressionType": {},
				"JSON": {
					"type": "structure",
					"members": {
						"Type": {}
					}
				}
			}
		},
		"Sbr": {
			"type": "structure",
			"members": {
				"CSV": {
					"type": "structure",
					"members": {
						"QuoteFields": {},
						"QuoteEscapeCharacter": {},
						"RecordDelimiter": {},
						"FieldDelimiter": {},
						"QuoteCharacter": {}
					}
				},
				"JSON": {
					"type": "structure",
					"members": {
						"RecordDelimiter": {}
					}
				}
			}
		}
	}
};

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListBuckets": {
			"result_key": "Buckets"
		},
		"ListMultipartUploads": {
			"input_token": [
				"KeyMarker",
				"UploadIdMarker"
			],
			"limit_key": "MaxUploads",
			"more_results": "IsTruncated",
			"output_token": [
				"NextKeyMarker",
				"NextUploadIdMarker"
			],
			"result_key": [
				"Uploads",
				"CommonPrefixes"
			]
		},
		"ListObjectVersions": {
			"input_token": [
				"KeyMarker",
				"VersionIdMarker"
			],
			"limit_key": "MaxKeys",
			"more_results": "IsTruncated",
			"output_token": [
				"NextKeyMarker",
				"NextVersionIdMarker"
			],
			"result_key": [
				"Versions",
				"DeleteMarkers",
				"CommonPrefixes"
			]
		},
		"ListObjects": {
			"input_token": "Marker",
			"limit_key": "MaxKeys",
			"more_results": "IsTruncated",
			"output_token": "NextMarker || Contents[-1].Key",
			"result_key": [
				"Contents",
				"CommonPrefixes"
			]
		},
		"ListObjectsV2": {
			"input_token": "ContinuationToken",
			"limit_key": "MaxKeys",
			"output_token": "NextContinuationToken",
			"result_key": [
				"Contents",
				"CommonPrefixes"
			]
		},
		"ListParts": {
			"input_token": "PartNumberMarker",
			"limit_key": "MaxParts",
			"more_results": "IsTruncated",
			"output_token": "NextPartNumberMarker",
			"result_key": "Parts"
		}
	}
};

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"BucketExists": {
			"delay": 5,
			"operation": "HeadBucket",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 200,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 301,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 403,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 404,
					"matcher": "status",
					"state": "retry"
				}
			]
		},
		"BucketNotExists": {
			"delay": 5,
			"operation": "HeadBucket",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 404,
					"matcher": "status",
					"state": "success"
				}
			]
		},
		"ObjectExists": {
			"delay": 5,
			"operation": "HeadObject",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 200,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 404,
					"matcher": "status",
					"state": "retry"
				}
			]
		},
		"ObjectNotExists": {
			"delay": 5,
			"operation": "HeadObject",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 404,
					"matcher": "status",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-06-15",
		"endpointPrefix": "sts",
		"globalEndpoint": "sts.amazonaws.com",
		"protocol": "query",
		"serviceAbbreviation": "AWS STS",
		"serviceFullName": "AWS Security Token Service",
		"serviceId": "STS",
		"signatureVersion": "v4",
		"uid": "sts-2011-06-15",
		"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
	},
	"operations": {
		"AssumeRole": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					},
					"ExternalId": {},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"AssumeRoleWithSAML": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"PrincipalArn",
					"SAMLAssertion"
				],
				"members": {
					"RoleArn": {},
					"PrincipalArn": {},
					"SAMLAssertion": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithSAMLResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Subject": {},
					"SubjectType": {},
					"Issuer": {},
					"Audience": {},
					"NameQualifier": {}
				}
			}
		},
		"AssumeRoleWithWebIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName",
					"WebIdentityToken"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"WebIdentityToken": {},
					"ProviderId": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithWebIdentityResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"SubjectFromWebIdentityToken": {},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Provider": {},
					"Audience": {}
				}
			}
		},
		"DecodeAuthorizationMessage": {
			"input": {
				"type": "structure",
				"required": [
					"EncodedMessage"
				],
				"members": {
					"EncodedMessage": {}
				}
			},
			"output": {
				"resultWrapper": "DecodeAuthorizationMessageResult",
				"type": "structure",
				"members": {
					"DecodedMessage": {}
				}
			}
		},
		"GetCallerIdentity": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "GetCallerIdentityResult",
				"type": "structure",
				"members": {
					"UserId": {},
					"Account": {},
					"Arn": {}
				}
			}
		},
		"GetFederationToken": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "GetFederationTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"FederatedUser": {
						"type": "structure",
						"required": [
							"FederatedUserId",
							"Arn"
						],
						"members": {
							"FederatedUserId": {},
							"Arn": {}
						}
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"GetSessionToken": {
			"input": {
				"type": "structure",
				"members": {
					"DurationSeconds": {
						"type": "integer"
					},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "GetSessionTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"AccessKeyId",
				"SecretAccessKey",
				"SessionToken",
				"Expiration"
			],
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {},
				"Expiration": {
					"type": "timestamp"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"AssumedRoleId",
				"Arn"
			],
			"members": {
				"AssumedRoleId": {},
				"Arn": {}
			}
		}
	}
};

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports = {
	"rules": {
		"*/*": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"cn-*/*": {
			"endpoint": "{service}.{region}.amazonaws.com.cn"
		},
		"*/budgets": "globalSSL",
		"*/cloudfront": "globalSSL",
		"*/iam": "globalSSL",
		"*/sts": "globalSSL",
		"*/importexport": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2",
			"globalEndpoint": true
		},
		"*/route53": {
			"endpoint": "https://{service}.amazonaws.com",
			"signatureVersion": "v3https",
			"globalEndpoint": true
		},
		"*/waf": "globalSSL",
		"us-gov-*/iam": "globalGovCloud",
		"us-gov-*/sts": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"us-gov-west-1/s3": "s3signature",
		"us-west-1/s3": "s3signature",
		"us-west-2/s3": "s3signature",
		"eu-west-1/s3": "s3signature",
		"ap-southeast-1/s3": "s3signature",
		"ap-southeast-2/s3": "s3signature",
		"ap-northeast-1/s3": "s3signature",
		"sa-east-1/s3": "s3signature",
		"us-east-1/s3": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "s3"
		},
		"us-east-1/sdb": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2"
		},
		"*/sdb": {
			"endpoint": "{service}.{region}.amazonaws.com",
			"signatureVersion": "v2"
		}
	},
	"patterns": {
		"globalSSL": {
			"endpoint": "https://{service}.amazonaws.com",
			"globalEndpoint": true
		},
		"globalGovCloud": {
			"endpoint": "{service}.us-gov.amazonaws.com"
		},
		"s3signature": {
			"endpoint": "{service}.{region}.amazonaws.com",
			"signatureVersion": "s3"
		}
	}
};

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return challengeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return challengeActivityType; });
/**
 * Decided:
 *  - A user will be able to submit answers as many times as he wants.
 */

var challengeStatus = {
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
  SOLVED: 'solved',
  FAILED: 'failed'
};

var challengeActivityType = {
  CHALLENGE: 'Challenge',
  FINISH_LINE: 'Finish line',
  OTHER: 'Other'
};

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAxiosInstance */
/* harmony export (immutable) */ __webpack_exports__["a"] = myaxios;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(73);



function getAxiosInstance() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.apiKey } });
}

function myaxios(request) {
  console.log(__WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.apiKey);
  var updatedRequest = request;
  if (!updatedRequest.headers) {
    updatedRequest.headers = {};
  }
  if (!updatedRequest.headers.Authorization && __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.apiKey) {
    updatedRequest.headers.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].state.apiKey;
  }
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()(updatedRequest);
}

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_highlightjs__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_apollo__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_app_sync_service__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_appsync__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_appsync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_aws_appsync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_highlightjs___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_apollo__["a" /* default */]);

var client = new __WEBPACK_IMPORTED_MODULE_9_aws_appsync___default.a({
  url: __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync___default.a.graphqlEndpoint,
  region: __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync___default.a.region,
  auth: {
    type: __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync___default.a.authenticationType,
    apiKey: __WEBPACK_IMPORTED_MODULE_10__app_sync_AppSync___default.a.apiKey
  }
}, {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network'
    }
  }
});





client.hydrated().then(__WEBPACK_IMPORTED_MODULE_8__services_app_sync_service__["a" /* storeClient */]);

var appsyncProvider = new __WEBPACK_IMPORTED_MODULE_7_vue_apollo__["a" /* default */]({
  defaultClient: client
});

// Global components
// ...

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */] },
  provide: appsyncProvider.provide(),
  store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */]
});

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChallengeById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function getChallengeById(challenges, challengeId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(challenges, function (c) {
    return c.challengeId === challengeId;
  });
}

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateFingerprint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fingerprintjs2__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fingerprintjs2__);


function generateFingerprint(callback) {
  return new __WEBPACK_IMPORTED_MODULE_0_fingerprintjs2___default.a().get(callback);
}

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var baseUrl = 'https://dev-player.geogaming-back.com';
console.log('teamsService > baseUrl:', baseUrl);

function getGames(tenantId) {
  if (tenantId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      method: 'get',
      url: baseUrl + '/tenants/' + tenantId + '/games'
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'get',
    url: baseUrl + '/games'
  });
}

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeUserScore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_challengeStatus_enum__ = __webpack_require__(50);




function computeUserScore(questions) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["chain"])(questions).map(function (question) {
    if (question.status === __WEBPACK_IMPORTED_MODULE_1__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED) {
      return question.score;
    }
    return 0;
  }).reduce(function (result, value) {
    return result + value;
  }).value();
}

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  userLocation: function userLocation(state) {
    return state.userLocation;
  },
  game: function game(state) {
    return state.game;
  },
  errorMessage: function errorMessage(state) {
    return state.errorMessage;
  },
  isUserAtChallengeLocation: function isUserAtChallengeLocation(state) {
    return state.isUserAtChallengeLocation;
  },
  challengesLocations: function challengesLocations(state) {
    return state.challengesLocations;
  },
  fingerprint: function fingerprint(state) {
    return state.fingerprint;
  },
  drawerState: function drawerState(state) {
    return state.drawerState;
  },
  mapZoomState: function mapZoomState(state) {
    return state.mapZoom;
  },
  mapCenterState: function mapCenterState(state) {
    return state.mapCenter;
  },
  team: function team(state) {
    return state.team;
  },
  userScore: function userScore(state) {
    return state.userScore;
  },
  launchTutorial: function launchTutorial(state) {
    return state.launchTutorial;
  },
  tutorialInProgress: function tutorialInProgress(state) {
    return state.tutorialInProgress;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.isLoggedIn;
  },
  questionRadius: function questionRadius(state) {
    return state.questionRadius;
  },
  apiKey: function apiKey(state) {
    return state.apiKey;
  },
  config: function config(state) {
    return state.config;
  },
  tenant: function tenant(state) {
    return state.tenant;
  }
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_challengeStatus_enum__ = __webpack_require__(50);
var _require = __webpack_require__(4),
    map = _require.map;



/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USER_LOCATION: function SET_USER_LOCATION(state, userLocation) {
    state.userLocation = userLocation;
  },
  SET_GAME: function SET_GAME(state, game) {
    state.game = game;
  },
  SET_ERROR_MESSAGE: function SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  SET_IS_USER_AT_CHALLENGE_LOCATION: function SET_IS_USER_AT_CHALLENGE_LOCATION(state, _ref) {
    var isUserInOneZone = _ref.isUserInOneZone,
        challengeId = _ref.challengeId;

    state.isUserAtChallengeLocation = { isUserInOneZone: isUserInOneZone, challengeId: challengeId };
  },
  SET_CHALLENGES_LOCATIONS: function SET_CHALLENGES_LOCATIONS(state, challengesLocations) {
    // First set it to 'null' to be sure to trigger the 'challengesLocations' watcher in Map.vue
    state.challengesLocations = null;
    state.challengesLocations = challengesLocations;
  },
  SET_DRAWER_STATE: function SET_DRAWER_STATE(state, drawerState) {
    state.drawerState = drawerState;
  },
  SET_FINGERPRINT: function SET_FINGERPRINT(state, fingerprint) {
    state.fingerprint = fingerprint;
  },
  SET_CONFIG: function SET_CONFIG(state, config) {
    state.config = config;
  },
  SET_TENANT: function SET_TENANT(state, tenant) {
    state.tenant = tenant;
  },
  SET_TEAM: function SET_TEAM(state, team) {
    state.team = team;
  },
  SET_API_KEY: function SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey;
  },
  UNLOCK_CHALLENGE: function UNLOCK_CHALLENGE(state, unlockedChallengeObj) {
    var challengesWithUpdatedOne = map(state.challengesLocations, function (c) {
      if (c.challengeId === unlockedChallengeObj.challengeId) {
        c.status = __WEBPACK_IMPORTED_MODULE_0__services_challengeStatus_enum__["a" /* challengeStatus */].UNLOCKED;
        c.type = unlockedChallengeObj.type;
        c.question = unlockedChallengeObj.question;
        if (unlockedChallengeObj.answers) {
          c.answers = unlockedChallengeObj.answers;
        }
      }
      return c;
    });
    state.challengesLocations = challengesWithUpdatedOne;
  },
  MARK_CHALLENGE_AS_DONE: function MARK_CHALLENGE_AS_DONE(state, _ref2) {
    var challengeId = _ref2.challengeId,
        challengeAnswer = _ref2.challengeAnswer;

    state.challengesLocations = map(state.challengesLocations, function (c) {
      if (c.challengeId === challengeId) {
        c.status = __WEBPACK_IMPORTED_MODULE_0__services_challengeStatus_enum__["a" /* challengeStatus */].SOLVED;
        c.chosenAnswer = challengeAnswer;
      }
      return c;
    });
  },
  MARK_CHALLENGE_AS_FAILED: function MARK_CHALLENGE_AS_FAILED(state, _ref3) {
    var challengeId = _ref3.challengeId,
        challengeAnswer = _ref3.challengeAnswer;

    state.challengesLocations = map(state.challengesLocations, function (c) {
      if (c.challengeId === challengeId) {
        c.status = __WEBPACK_IMPORTED_MODULE_0__services_challengeStatus_enum__["a" /* challengeStatus */].FAILED;
        c.chosenAnswer = challengeAnswer;
      }
      return c;
    });
  },
  UPDATE_CHALLENGE_REMAINING_ATTEMPTS: function UPDATE_CHALLENGE_REMAINING_ATTEMPTS(state, _ref4) {
    var challengeId = _ref4.challengeId,
        remainingAttempts = _ref4.remainingAttempts;

    state.challengesLocations = map(state.challengesLocations, function (c) {
      if (c.challengeId === challengeId) {
        c.remainingAttempts = remainingAttempts;
      }
      return c;
    });
  },
  SET_USER_SCORE: function SET_USER_SCORE(state, totalPoints) {
    state.userScore = totalPoints;
  },
  ADD_POINTS_TO_USER_SCORE: function ADD_POINTS_TO_USER_SCORE(state, pointsToAdd) {
    state.userScore += pointsToAdd;
  },
  SET_MAP_ZOOM: function SET_MAP_ZOOM(state, mapZoom) {
    state.mapZoom = mapZoom;
  },
  SET_MAP_CENTER: function SET_MAP_CENTER(state, mapCenter) {
    state.mapCenter = mapCenter;
  },
  SET_QUESTION_RADIUS: function SET_QUESTION_RADIUS(state, questionRadius) {
    state.questionRadius = questionRadius;
  },
  LAUNCH_TUTORIAL: function LAUNCH_TUTORIAL(state, newValue) {
    state.launchTutorial = newValue;
  },
  IS_TUTORIAL_IN_PROGRESS: function IS_TUTORIAL_IN_PROGRESS(state, newValue) {
    state.tutorialInProgress = newValue;
  },
  LOGIN: function LOGIN(state) {
    state.isLoggedIn = true;
  },
  LOGOUT: function LOGOUT(state) {
    state.isLoggedIn = false;
  }
});

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  // userLocation: {
  //   lat: '',
  //   lng: '',
  // },
  userLocation: null,
  game: null,

  errorMessage: '',
  isUserAtChallengeLocation: {
    isUserInOneZone: null,
    challengeId: null
  },
  challengesLocations: [],
  drawerState: false,
  fingerprint: '',

  team: null,
  mapZoom: null,
  mapCenter: null,

  userScore: 0,
  questionRadius: 80,

  launchTutorial: false,
  tutorialInProgress: false,

  apiKey: null,
  isLoggedIn: false,

  config: null,
  tenant: null
});

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__(515);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__["a" /* default */],
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
    paths: ['userLocation', 'isLoggedIn', 'fingerprint', 'game', 'questionRadius', 'team', 'apiKey', 'mapZoom', 'mapCenter', 'config', 'tenant']
  })]
}));

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

module.exports = {
	"100": "💯",
	"1234": "🔢",
	"grinning": "😀",
	"smiley": "😃",
	"smile": "😄",
	"grin": "😁",
	"laughing": "😆",
	"satisfied": "😆",
	"sweat_smile": "😅",
	"joy": "😂",
	"rofl": "🤣",
	"relaxed": "☺️",
	"blush": "😊",
	"innocent": "😇",
	"slightly_smiling_face": "🙂",
	"upside_down_face": "🙃",
	"wink": "😉",
	"relieved": "😌",
	"heart_eyes": "😍",
	"kissing_heart": "😘",
	"kissing": "😗",
	"kissing_smiling_eyes": "😙",
	"kissing_closed_eyes": "😚",
	"yum": "😋",
	"stuck_out_tongue_winking_eye": "😜",
	"stuck_out_tongue_closed_eyes": "😝",
	"stuck_out_tongue": "😛",
	"money_mouth_face": "🤑",
	"hugs": "🤗",
	"nerd_face": "🤓",
	"sunglasses": "😎",
	"clown_face": "🤡",
	"cowboy_hat_face": "🤠",
	"smirk": "😏",
	"unamused": "😒",
	"disappointed": "😞",
	"pensive": "😔",
	"worried": "😟",
	"confused": "😕",
	"slightly_frowning_face": "🙁",
	"frowning_face": "☹️",
	"persevere": "😣",
	"confounded": "😖",
	"tired_face": "😫",
	"weary": "😩",
	"triumph": "😤",
	"angry": "😠",
	"rage": "😡",
	"pout": "😡",
	"no_mouth": "😶",
	"neutral_face": "😐",
	"expressionless": "😑",
	"hushed": "😯",
	"frowning": "😦",
	"anguished": "😧",
	"open_mouth": "😮",
	"astonished": "😲",
	"dizzy_face": "😵",
	"flushed": "😳",
	"scream": "😱",
	"fearful": "😨",
	"cold_sweat": "😰",
	"cry": "😢",
	"disappointed_relieved": "😥",
	"drooling_face": "🤤",
	"sob": "😭",
	"sweat": "😓",
	"sleepy": "😪",
	"sleeping": "😴",
	"roll_eyes": "🙄",
	"thinking": "🤔",
	"lying_face": "🤥",
	"grimacing": "😬",
	"zipper_mouth_face": "🤐",
	"nauseated_face": "🤢",
	"sneezing_face": "🤧",
	"mask": "😷",
	"face_with_thermometer": "🤒",
	"face_with_head_bandage": "🤕",
	"smiling_imp": "😈",
	"imp": "👿",
	"japanese_ogre": "👹",
	"japanese_goblin": "👺",
	"hankey": "💩",
	"poop": "💩",
	"shit": "💩",
	"ghost": "👻",
	"skull": "💀",
	"skull_and_crossbones": "☠️",
	"alien": "👽",
	"space_invader": "👾",
	"robot": "🤖",
	"jack_o_lantern": "🎃",
	"smiley_cat": "😺",
	"smile_cat": "😸",
	"joy_cat": "😹",
	"heart_eyes_cat": "😻",
	"smirk_cat": "😼",
	"kissing_cat": "😽",
	"scream_cat": "🙀",
	"crying_cat_face": "😿",
	"pouting_cat": "😾",
	"open_hands": "👐",
	"raised_hands": "🙌",
	"clap": "👏",
	"pray": "🙏",
	"handshake": "🤝",
	"+1": "👍",
	"thumbsup": "👍",
	"-1": "👎",
	"thumbsdown": "👎",
	"fist_oncoming": "👊",
	"facepunch": "👊",
	"punch": "👊",
	"fist_raised": "✊",
	"fist": "✊",
	"fist_left": "🤛",
	"fist_right": "🤜",
	"crossed_fingers": "🤞",
	"v": "✌️",
	"metal": "🤘",
	"ok_hand": "👌",
	"point_left": "👈",
	"point_right": "👉",
	"point_up_2": "👆",
	"point_down": "👇",
	"point_up": "☝️",
	"hand": "✋",
	"raised_hand": "✋",
	"raised_back_of_hand": "🤚",
	"raised_hand_with_fingers_splayed": "🖐",
	"vulcan_salute": "🖖",
	"wave": "👋",
	"call_me_hand": "🤙",
	"muscle": "💪",
	"middle_finger": "🖕",
	"fu": "🖕",
	"writing_hand": "✍️",
	"selfie": "🤳",
	"nail_care": "💅",
	"ring": "💍",
	"lipstick": "💄",
	"kiss": "💋",
	"lips": "👄",
	"tongue": "👅",
	"ear": "👂",
	"nose": "👃",
	"footprints": "👣",
	"eye": "👁",
	"eyes": "👀",
	"speaking_head": "🗣",
	"bust_in_silhouette": "👤",
	"busts_in_silhouette": "👥",
	"baby": "👶",
	"boy": "👦",
	"girl": "👧",
	"man": "👨",
	"woman": "👩",
	"blonde_woman": "👱‍♀",
	"blonde_man": "👱",
	"person_with_blond_hair": "👱",
	"older_man": "👴",
	"older_woman": "👵",
	"man_with_gua_pi_mao": "👲",
	"woman_with_turban": "👳‍♀",
	"man_with_turban": "👳",
	"policewoman": "👮‍♀",
	"policeman": "👮",
	"cop": "👮",
	"construction_worker_woman": "👷‍♀",
	"construction_worker_man": "👷",
	"construction_worker": "👷",
	"guardswoman": "💂‍♀",
	"guardsman": "💂",
	"female_detective": "🕵️‍♀️",
	"male_detective": "🕵",
	"detective": "🕵",
	"woman_health_worker": "👩‍⚕",
	"man_health_worker": "👨‍⚕",
	"woman_farmer": "👩‍🌾",
	"man_farmer": "👨‍🌾",
	"woman_cook": "👩‍🍳",
	"man_cook": "👨‍🍳",
	"woman_student": "👩‍🎓",
	"man_student": "👨‍🎓",
	"woman_singer": "👩‍🎤",
	"man_singer": "👨‍🎤",
	"woman_teacher": "👩‍🏫",
	"man_teacher": "👨‍🏫",
	"woman_factory_worker": "👩‍🏭",
	"man_factory_worker": "👨‍🏭",
	"woman_technologist": "👩‍💻",
	"man_technologist": "👨‍💻",
	"woman_office_worker": "👩‍💼",
	"man_office_worker": "👨‍💼",
	"woman_mechanic": "👩‍🔧",
	"man_mechanic": "👨‍🔧",
	"woman_scientist": "👩‍🔬",
	"man_scientist": "👨‍🔬",
	"woman_artist": "👩‍🎨",
	"man_artist": "👨‍🎨",
	"woman_firefighter": "👩‍🚒",
	"man_firefighter": "👨‍🚒",
	"woman_pilot": "👩‍✈",
	"man_pilot": "👨‍✈",
	"woman_astronaut": "👩‍🚀",
	"man_astronaut": "👨‍🚀",
	"woman_judge": "👩‍⚖",
	"man_judge": "👨‍⚖",
	"mrs_claus": "🤶",
	"santa": "🎅",
	"princess": "👸",
	"prince": "🤴",
	"bride_with_veil": "👰",
	"man_in_tuxedo": "🤵",
	"angel": "👼",
	"pregnant_woman": "🤰",
	"bowing_woman": "🙇‍♀",
	"bowing_man": "🙇",
	"bow": "🙇",
	"tipping_hand_woman": "💁",
	"information_desk_person": "💁",
	"sassy_woman": "💁",
	"tipping_hand_man": "💁‍♂",
	"sassy_man": "💁‍♂",
	"no_good_woman": "🙅",
	"no_good": "🙅",
	"ng_woman": "🙅",
	"no_good_man": "🙅‍♂",
	"ng_man": "🙅‍♂",
	"ok_woman": "🙆",
	"ok_man": "🙆‍♂",
	"raising_hand_woman": "🙋",
	"raising_hand": "🙋",
	"raising_hand_man": "🙋‍♂",
	"woman_facepalming": "🤦‍♀",
	"man_facepalming": "🤦‍♂",
	"woman_shrugging": "🤷‍♀",
	"man_shrugging": "🤷‍♂",
	"pouting_woman": "🙎",
	"person_with_pouting_face": "🙎",
	"pouting_man": "🙎‍♂",
	"frowning_woman": "🙍",
	"person_frowning": "🙍",
	"frowning_man": "🙍‍♂",
	"haircut_woman": "💇",
	"haircut": "💇",
	"haircut_man": "💇‍♂",
	"massage_woman": "💆",
	"massage": "💆",
	"massage_man": "💆‍♂",
	"business_suit_levitating": "🕴",
	"dancer": "💃",
	"man_dancing": "🕺",
	"dancing_women": "👯",
	"dancers": "👯",
	"dancing_men": "👯‍♂",
	"walking_woman": "🚶‍♀",
	"walking_man": "🚶",
	"walking": "🚶",
	"running_woman": "🏃‍♀",
	"running_man": "🏃",
	"runner": "🏃",
	"running": "🏃",
	"couple": "👫",
	"two_women_holding_hands": "👭",
	"two_men_holding_hands": "👬",
	"couple_with_heart_woman_man": "💑",
	"couple_with_heart": "💑",
	"couple_with_heart_woman_woman": "👩‍❤️‍👩",
	"couple_with_heart_man_man": "👨‍❤️‍👨",
	"couplekiss_man_woman": "💏",
	"couplekiss_woman_woman": "👩‍❤️‍💋‍👩",
	"couplekiss_man_man": "👨‍❤️‍💋‍👨",
	"family_man_woman_boy": "👪",
	"family": "👪",
	"family_man_woman_girl": "👨‍👩‍👧",
	"family_man_woman_girl_boy": "👨‍👩‍👧‍👦",
	"family_man_woman_boy_boy": "👨‍👩‍👦‍👦",
	"family_man_woman_girl_girl": "👨‍👩‍👧‍👧",
	"family_woman_woman_boy": "👩‍👩‍👦",
	"family_woman_woman_girl": "👩‍👩‍👧",
	"family_woman_woman_girl_boy": "👩‍👩‍👧‍👦",
	"family_woman_woman_boy_boy": "👩‍👩‍👦‍👦",
	"family_woman_woman_girl_girl": "👩‍👩‍👧‍👧",
	"family_man_man_boy": "👨‍👨‍👦",
	"family_man_man_girl": "👨‍👨‍👧",
	"family_man_man_girl_boy": "👨‍👨‍👧‍👦",
	"family_man_man_boy_boy": "👨‍👨‍👦‍👦",
	"family_man_man_girl_girl": "👨‍👨‍👧‍👧",
	"family_woman_boy": "👩‍👦",
	"family_woman_girl": "👩‍👧",
	"family_woman_girl_boy": "👩‍👧‍👦",
	"family_woman_boy_boy": "👩‍👦‍👦",
	"family_woman_girl_girl": "👩‍👧‍👧",
	"family_man_boy": "👨‍👦",
	"family_man_girl": "👨‍👧",
	"family_man_girl_boy": "👨‍👧‍👦",
	"family_man_boy_boy": "👨‍👦‍👦",
	"family_man_girl_girl": "👨‍👧‍👧",
	"womans_clothes": "👚",
	"shirt": "👕",
	"tshirt": "👕",
	"jeans": "👖",
	"necktie": "👔",
	"dress": "👗",
	"bikini": "👙",
	"kimono": "👘",
	"high_heel": "👠",
	"sandal": "👡",
	"boot": "👢",
	"mans_shoe": "👞",
	"shoe": "👞",
	"athletic_shoe": "👟",
	"womans_hat": "👒",
	"tophat": "🎩",
	"mortar_board": "🎓",
	"crown": "👑",
	"rescue_worker_helmet": "⛑",
	"school_satchel": "🎒",
	"pouch": "👝",
	"purse": "👛",
	"handbag": "👜",
	"briefcase": "💼",
	"eyeglasses": "👓",
	"dark_sunglasses": "🕶",
	"closed_umbrella": "🌂",
	"open_umbrella": "☂️",
	"dog": "🐶",
	"cat": "🐱",
	"mouse": "🐭",
	"hamster": "🐹",
	"rabbit": "🐰",
	"fox_face": "🦊",
	"bear": "🐻",
	"panda_face": "🐼",
	"koala": "🐨",
	"tiger": "🐯",
	"lion": "🦁",
	"cow": "🐮",
	"pig": "🐷",
	"pig_nose": "🐽",
	"frog": "🐸",
	"monkey_face": "🐵",
	"see_no_evil": "🙈",
	"hear_no_evil": "🙉",
	"speak_no_evil": "🙊",
	"monkey": "🐒",
	"chicken": "🐔",
	"penguin": "🐧",
	"bird": "🐦",
	"baby_chick": "🐤",
	"hatching_chick": "🐣",
	"hatched_chick": "🐥",
	"duck": "🦆",
	"eagle": "🦅",
	"owl": "🦉",
	"bat": "🦇",
	"wolf": "🐺",
	"boar": "🐗",
	"horse": "🐴",
	"unicorn": "🦄",
	"bee": "🐝",
	"honeybee": "🐝",
	"bug": "🐛",
	"butterfly": "🦋",
	"snail": "🐌",
	"shell": "🐚",
	"beetle": "🐞",
	"ant": "🐜",
	"spider": "🕷",
	"spider_web": "🕸",
	"turtle": "🐢",
	"snake": "🐍",
	"lizard": "🦎",
	"scorpion": "🦂",
	"crab": "🦀",
	"squid": "🦑",
	"octopus": "🐙",
	"shrimp": "🦐",
	"tropical_fish": "🐠",
	"fish": "🐟",
	"blowfish": "🐡",
	"dolphin": "🐬",
	"flipper": "🐬",
	"shark": "🦈",
	"whale": "🐳",
	"whale2": "🐋",
	"crocodile": "🐊",
	"leopard": "🐆",
	"tiger2": "🐅",
	"water_buffalo": "🐃",
	"ox": "🐂",
	"cow2": "🐄",
	"deer": "🦌",
	"dromedary_camel": "🐪",
	"camel": "🐫",
	"elephant": "🐘",
	"rhinoceros": "🦏",
	"gorilla": "🦍",
	"racehorse": "🐎",
	"pig2": "🐖",
	"goat": "🐐",
	"ram": "🐏",
	"sheep": "🐑",
	"dog2": "🐕",
	"poodle": "🐩",
	"cat2": "🐈",
	"rooster": "🐓",
	"turkey": "🦃",
	"dove": "🕊",
	"rabbit2": "🐇",
	"mouse2": "🐁",
	"rat": "🐀",
	"chipmunk": "🐿",
	"feet": "🐾",
	"paw_prints": "🐾",
	"dragon": "🐉",
	"dragon_face": "🐲",
	"cactus": "🌵",
	"christmas_tree": "🎄",
	"evergreen_tree": "🌲",
	"deciduous_tree": "🌳",
	"palm_tree": "🌴",
	"seedling": "🌱",
	"herb": "🌿",
	"shamrock": "☘️",
	"four_leaf_clover": "🍀",
	"bamboo": "🎍",
	"tanabata_tree": "🎋",
	"leaves": "🍃",
	"fallen_leaf": "🍂",
	"maple_leaf": "🍁",
	"mushroom": "🍄",
	"ear_of_rice": "🌾",
	"bouquet": "💐",
	"tulip": "🌷",
	"rose": "🌹",
	"wilted_flower": "🥀",
	"sunflower": "🌻",
	"blossom": "🌼",
	"cherry_blossom": "🌸",
	"hibiscus": "🌺",
	"earth_americas": "🌎",
	"earth_africa": "🌍",
	"earth_asia": "🌏",
	"full_moon": "🌕",
	"waning_gibbous_moon": "🌖",
	"last_quarter_moon": "🌗",
	"waning_crescent_moon": "🌘",
	"new_moon": "🌑",
	"waxing_crescent_moon": "🌒",
	"first_quarter_moon": "🌓",
	"moon": "🌔",
	"waxing_gibbous_moon": "🌔",
	"new_moon_with_face": "🌚",
	"full_moon_with_face": "🌝",
	"sun_with_face": "🌞",
	"first_quarter_moon_with_face": "🌛",
	"last_quarter_moon_with_face": "🌜",
	"crescent_moon": "🌙",
	"dizzy": "💫",
	"star": "⭐️",
	"star2": "🌟",
	"sparkles": "✨",
	"zap": "⚡️",
	"fire": "🔥",
	"boom": "💥",
	"collision": "💥",
	"comet": "☄",
	"sunny": "☀️",
	"sun_behind_small_cloud": "🌤",
	"partly_sunny": "⛅️",
	"sun_behind_large_cloud": "🌥",
	"sun_behind_rain_cloud": "🌦",
	"rainbow": "🌈",
	"cloud": "☁️",
	"cloud_with_rain": "🌧",
	"cloud_with_lightning_and_rain": "⛈",
	"cloud_with_lightning": "🌩",
	"cloud_with_snow": "🌨",
	"snowman_with_snow": "☃️",
	"snowman": "⛄️",
	"snowflake": "❄️",
	"wind_face": "🌬",
	"dash": "💨",
	"tornado": "🌪",
	"fog": "🌫",
	"ocean": "🌊",
	"droplet": "💧",
	"sweat_drops": "💦",
	"umbrella": "☔️",
	"green_apple": "🍏",
	"apple": "🍎",
	"pear": "🍐",
	"tangerine": "🍊",
	"orange": "🍊",
	"mandarin": "🍊",
	"lemon": "🍋",
	"banana": "🍌",
	"watermelon": "🍉",
	"grapes": "🍇",
	"strawberry": "🍓",
	"melon": "🍈",
	"cherries": "🍒",
	"peach": "🍑",
	"pineapple": "🍍",
	"kiwi_fruit": "🥝",
	"avocado": "🥑",
	"tomato": "🍅",
	"eggplant": "🍆",
	"cucumber": "🥒",
	"carrot": "🥕",
	"corn": "🌽",
	"hot_pepper": "🌶",
	"potato": "🥔",
	"sweet_potato": "🍠",
	"chestnut": "🌰",
	"peanuts": "🥜",
	"honey_pot": "🍯",
	"croissant": "🥐",
	"bread": "🍞",
	"baguette_bread": "🥖",
	"cheese": "🧀",
	"egg": "🥚",
	"fried_egg": "🍳",
	"bacon": "🥓",
	"pancakes": "🥞",
	"fried_shrimp": "🍤",
	"poultry_leg": "🍗",
	"meat_on_bone": "🍖",
	"pizza": "🍕",
	"hotdog": "🌭",
	"hamburger": "🍔",
	"fries": "🍟",
	"stuffed_flatbread": "🥙",
	"taco": "🌮",
	"burrito": "🌯",
	"green_salad": "🥗",
	"shallow_pan_of_food": "🥘",
	"spaghetti": "🍝",
	"ramen": "🍜",
	"stew": "🍲",
	"fish_cake": "🍥",
	"sushi": "🍣",
	"bento": "🍱",
	"curry": "🍛",
	"rice": "🍚",
	"rice_ball": "🍙",
	"rice_cracker": "🍘",
	"oden": "🍢",
	"dango": "🍡",
	"shaved_ice": "🍧",
	"ice_cream": "🍨",
	"icecream": "🍦",
	"cake": "🍰",
	"birthday": "🎂",
	"custard": "🍮",
	"lollipop": "🍭",
	"candy": "🍬",
	"chocolate_bar": "🍫",
	"popcorn": "🍿",
	"doughnut": "🍩",
	"cookie": "🍪",
	"milk_glass": "🥛",
	"baby_bottle": "🍼",
	"coffee": "☕️",
	"tea": "🍵",
	"sake": "🍶",
	"beer": "🍺",
	"beers": "🍻",
	"clinking_glasses": "🥂",
	"wine_glass": "🍷",
	"tumbler_glass": "🥃",
	"cocktail": "🍸",
	"tropical_drink": "🍹",
	"champagne": "🍾",
	"spoon": "🥄",
	"fork_and_knife": "🍴",
	"plate_with_cutlery": "🍽",
	"soccer": "⚽️",
	"basketball": "🏀",
	"football": "🏈",
	"baseball": "⚾️",
	"tennis": "🎾",
	"volleyball": "🏐",
	"rugby_football": "🏉",
	"8ball": "🎱",
	"ping_pong": "🏓",
	"badminton": "🏸",
	"goal_net": "🥅",
	"ice_hockey": "🏒",
	"field_hockey": "🏑",
	"cricket": "🏏",
	"golf": "⛳️",
	"bow_and_arrow": "🏹",
	"fishing_pole_and_fish": "🎣",
	"boxing_glove": "🥊",
	"martial_arts_uniform": "🥋",
	"ice_skate": "⛸",
	"ski": "🎿",
	"skier": "⛷",
	"snowboarder": "🏂",
	"weight_lifting_woman": "🏋️‍♀️",
	"weight_lifting_man": "🏋",
	"person_fencing": "🤺",
	"women_wrestling": "🤼‍♀",
	"men_wrestling": "🤼‍♂",
	"woman_cartwheeling": "🤸‍♀",
	"man_cartwheeling": "🤸‍♂",
	"basketball_woman": "⛹️‍♀️",
	"basketball_man": "⛹",
	"woman_playing_handball": "🤾‍♀",
	"man_playing_handball": "🤾‍♂",
	"golfing_woman": "🏌️‍♀️",
	"golfing_man": "🏌",
	"surfing_woman": "🏄‍♀",
	"surfing_man": "🏄",
	"surfer": "🏄",
	"swimming_woman": "🏊‍♀",
	"swimming_man": "🏊",
	"swimmer": "🏊",
	"woman_playing_water_polo": "🤽‍♀",
	"man_playing_water_polo": "🤽‍♂",
	"rowing_woman": "🚣‍♀",
	"rowing_man": "🚣",
	"rowboat": "🚣",
	"horse_racing": "🏇",
	"biking_woman": "🚴‍♀",
	"biking_man": "🚴",
	"bicyclist": "🚴",
	"mountain_biking_woman": "🚵‍♀",
	"mountain_biking_man": "🚵",
	"mountain_bicyclist": "🚵",
	"running_shirt_with_sash": "🎽",
	"medal_sports": "🏅",
	"medal_military": "🎖",
	"1st_place_medal": "🥇",
	"2nd_place_medal": "🥈",
	"3rd_place_medal": "🥉",
	"trophy": "🏆",
	"rosette": "🏵",
	"reminder_ribbon": "🎗",
	"ticket": "🎫",
	"tickets": "🎟",
	"circus_tent": "🎪",
	"woman_juggling": "🤹‍♀",
	"man_juggling": "🤹‍♂",
	"performing_arts": "🎭",
	"art": "🎨",
	"clapper": "🎬",
	"microphone": "🎤",
	"headphones": "🎧",
	"musical_score": "🎼",
	"musical_keyboard": "🎹",
	"drum": "🥁",
	"saxophone": "🎷",
	"trumpet": "🎺",
	"guitar": "🎸",
	"violin": "🎻",
	"game_die": "🎲",
	"dart": "🎯",
	"bowling": "🎳",
	"video_game": "🎮",
	"slot_machine": "🎰",
	"car": "🚗",
	"red_car": "🚗",
	"taxi": "🚕",
	"blue_car": "🚙",
	"bus": "🚌",
	"trolleybus": "🚎",
	"racing_car": "🏎",
	"police_car": "🚓",
	"ambulance": "🚑",
	"fire_engine": "🚒",
	"minibus": "🚐",
	"truck": "🚚",
	"articulated_lorry": "🚛",
	"tractor": "🚜",
	"kick_scooter": "🛴",
	"bike": "🚲",
	"motor_scooter": "🛵",
	"motorcycle": "🏍",
	"rotating_light": "🚨",
	"oncoming_police_car": "🚔",
	"oncoming_bus": "🚍",
	"oncoming_automobile": "🚘",
	"oncoming_taxi": "🚖",
	"aerial_tramway": "🚡",
	"mountain_cableway": "🚠",
	"suspension_railway": "🚟",
	"railway_car": "🚃",
	"train": "🚋",
	"mountain_railway": "🚞",
	"monorail": "🚝",
	"bullettrain_side": "🚄",
	"bullettrain_front": "🚅",
	"light_rail": "🚈",
	"steam_locomotive": "🚂",
	"train2": "🚆",
	"metro": "🚇",
	"tram": "🚊",
	"station": "🚉",
	"helicopter": "🚁",
	"small_airplane": "🛩",
	"airplane": "✈️",
	"flight_departure": "🛫",
	"flight_arrival": "🛬",
	"rocket": "🚀",
	"artificial_satellite": "🛰",
	"seat": "💺",
	"canoe": "🛶",
	"boat": "⛵️",
	"sailboat": "⛵️",
	"motor_boat": "🛥",
	"speedboat": "🚤",
	"passenger_ship": "🛳",
	"ferry": "⛴",
	"ship": "🚢",
	"anchor": "⚓️",
	"construction": "🚧",
	"fuelpump": "⛽️",
	"busstop": "🚏",
	"vertical_traffic_light": "🚦",
	"traffic_light": "🚥",
	"world_map": "🗺",
	"moyai": "🗿",
	"statue_of_liberty": "🗽",
	"fountain": "⛲️",
	"tokyo_tower": "🗼",
	"european_castle": "🏰",
	"japanese_castle": "🏯",
	"stadium": "🏟",
	"ferris_wheel": "🎡",
	"roller_coaster": "🎢",
	"carousel_horse": "🎠",
	"parasol_on_ground": "⛱",
	"beach_umbrella": "🏖",
	"desert_island": "🏝",
	"mountain": "⛰",
	"mountain_snow": "🏔",
	"mount_fuji": "🗻",
	"volcano": "🌋",
	"desert": "🏜",
	"camping": "🏕",
	"tent": "⛺️",
	"railway_track": "🛤",
	"motorway": "🛣",
	"building_construction": "🏗",
	"factory": "🏭",
	"house": "🏠",
	"house_with_garden": "🏡",
	"houses": "🏘",
	"derelict_house": "🏚",
	"office": "🏢",
	"department_store": "🏬",
	"post_office": "🏣",
	"european_post_office": "🏤",
	"hospital": "🏥",
	"bank": "🏦",
	"hotel": "🏨",
	"convenience_store": "🏪",
	"school": "🏫",
	"love_hotel": "🏩",
	"wedding": "💒",
	"classical_building": "🏛",
	"church": "⛪️",
	"mosque": "🕌",
	"synagogue": "🕍",
	"kaaba": "🕋",
	"shinto_shrine": "⛩",
	"japan": "🗾",
	"rice_scene": "🎑",
	"national_park": "🏞",
	"sunrise": "🌅",
	"sunrise_over_mountains": "🌄",
	"stars": "🌠",
	"sparkler": "🎇",
	"fireworks": "🎆",
	"city_sunrise": "🌇",
	"city_sunset": "🌆",
	"cityscape": "🏙",
	"night_with_stars": "🌃",
	"milky_way": "🌌",
	"bridge_at_night": "🌉",
	"foggy": "🌁",
	"watch": "⌚️",
	"iphone": "📱",
	"calling": "📲",
	"computer": "💻",
	"keyboard": "⌨️",
	"desktop_computer": "🖥",
	"printer": "🖨",
	"computer_mouse": "🖱",
	"trackball": "🖲",
	"joystick": "🕹",
	"clamp": "🗜",
	"minidisc": "💽",
	"floppy_disk": "💾",
	"cd": "💿",
	"dvd": "📀",
	"vhs": "📼",
	"camera": "📷",
	"camera_flash": "📸",
	"video_camera": "📹",
	"movie_camera": "🎥",
	"film_projector": "📽",
	"film_strip": "🎞",
	"telephone_receiver": "📞",
	"phone": "☎️",
	"telephone": "☎️",
	"pager": "📟",
	"fax": "📠",
	"tv": "📺",
	"radio": "📻",
	"studio_microphone": "🎙",
	"level_slider": "🎚",
	"control_knobs": "🎛",
	"stopwatch": "⏱",
	"timer_clock": "⏲",
	"alarm_clock": "⏰",
	"mantelpiece_clock": "🕰",
	"hourglass": "⌛️",
	"hourglass_flowing_sand": "⏳",
	"satellite": "📡",
	"battery": "🔋",
	"electric_plug": "🔌",
	"bulb": "💡",
	"flashlight": "🔦",
	"candle": "🕯",
	"wastebasket": "🗑",
	"oil_drum": "🛢",
	"money_with_wings": "💸",
	"dollar": "💵",
	"yen": "💴",
	"euro": "💶",
	"pound": "💷",
	"moneybag": "💰",
	"credit_card": "💳",
	"gem": "💎",
	"balance_scale": "⚖️",
	"wrench": "🔧",
	"hammer": "🔨",
	"hammer_and_pick": "⚒",
	"hammer_and_wrench": "🛠",
	"pick": "⛏",
	"nut_and_bolt": "🔩",
	"gear": "⚙️",
	"chains": "⛓",
	"gun": "🔫",
	"bomb": "💣",
	"hocho": "🔪",
	"knife": "🔪",
	"dagger": "🗡",
	"crossed_swords": "⚔️",
	"shield": "🛡",
	"smoking": "🚬",
	"coffin": "⚰️",
	"funeral_urn": "⚱️",
	"amphora": "🏺",
	"crystal_ball": "🔮",
	"prayer_beads": "📿",
	"barber": "💈",
	"alembic": "⚗️",
	"telescope": "🔭",
	"microscope": "🔬",
	"hole": "🕳",
	"pill": "💊",
	"syringe": "💉",
	"thermometer": "🌡",
	"toilet": "🚽",
	"potable_water": "🚰",
	"shower": "🚿",
	"bathtub": "🛁",
	"bath": "🛀",
	"bellhop_bell": "🛎",
	"key": "🔑",
	"old_key": "🗝",
	"door": "🚪",
	"couch_and_lamp": "🛋",
	"bed": "🛏",
	"sleeping_bed": "🛌",
	"framed_picture": "🖼",
	"shopping": "🛍",
	"shopping_cart": "🛒",
	"gift": "🎁",
	"balloon": "🎈",
	"flags": "🎏",
	"ribbon": "🎀",
	"confetti_ball": "🎊",
	"tada": "🎉",
	"dolls": "🎎",
	"izakaya_lantern": "🏮",
	"lantern": "🏮",
	"wind_chime": "🎐",
	"email": "✉️",
	"envelope": "✉️",
	"envelope_with_arrow": "📩",
	"incoming_envelope": "📨",
	"e-mail": "📧",
	"love_letter": "💌",
	"inbox_tray": "📥",
	"outbox_tray": "📤",
	"package": "📦",
	"label": "🏷",
	"mailbox_closed": "📪",
	"mailbox": "📫",
	"mailbox_with_mail": "📬",
	"mailbox_with_no_mail": "📭",
	"postbox": "📮",
	"postal_horn": "📯",
	"scroll": "📜",
	"page_with_curl": "📃",
	"page_facing_up": "📄",
	"bookmark_tabs": "📑",
	"bar_chart": "📊",
	"chart_with_upwards_trend": "📈",
	"chart_with_downwards_trend": "📉",
	"spiral_notepad": "🗒",
	"spiral_calendar": "🗓",
	"calendar": "📆",
	"date": "📅",
	"card_index": "📇",
	"card_file_box": "🗃",
	"ballot_box": "🗳",
	"file_cabinet": "🗄",
	"clipboard": "📋",
	"file_folder": "📁",
	"open_file_folder": "📂",
	"card_index_dividers": "🗂",
	"newspaper_roll": "🗞",
	"newspaper": "📰",
	"notebook": "📓",
	"notebook_with_decorative_cover": "📔",
	"ledger": "📒",
	"closed_book": "📕",
	"green_book": "📗",
	"blue_book": "📘",
	"orange_book": "📙",
	"books": "📚",
	"book": "📖",
	"open_book": "📖",
	"bookmark": "🔖",
	"link": "🔗",
	"paperclip": "📎",
	"paperclips": "🖇",
	"triangular_ruler": "📐",
	"straight_ruler": "📏",
	"pushpin": "📌",
	"round_pushpin": "📍",
	"scissors": "✂️",
	"pen": "🖊",
	"fountain_pen": "🖋",
	"black_nib": "✒️",
	"paintbrush": "🖌",
	"crayon": "🖍",
	"memo": "📝",
	"pencil": "📝",
	"pencil2": "✏️",
	"mag": "🔍",
	"mag_right": "🔎",
	"lock_with_ink_pen": "🔏",
	"closed_lock_with_key": "🔐",
	"lock": "🔒",
	"unlock": "🔓",
	"heart": "❤️",
	"yellow_heart": "💛",
	"green_heart": "💚",
	"blue_heart": "💙",
	"purple_heart": "💜",
	"black_heart": "🖤",
	"broken_heart": "💔",
	"heavy_heart_exclamation": "❣️",
	"two_hearts": "💕",
	"revolving_hearts": "💞",
	"heartbeat": "💓",
	"heartpulse": "💗",
	"sparkling_heart": "💖",
	"cupid": "💘",
	"gift_heart": "💝",
	"heart_decoration": "💟",
	"peace_symbol": "☮️",
	"latin_cross": "✝️",
	"star_and_crescent": "☪️",
	"om": "🕉",
	"wheel_of_dharma": "☸️",
	"star_of_david": "✡️",
	"six_pointed_star": "🔯",
	"menorah": "🕎",
	"yin_yang": "☯️",
	"orthodox_cross": "☦️",
	"place_of_worship": "🛐",
	"ophiuchus": "⛎",
	"aries": "♈️",
	"taurus": "♉️",
	"gemini": "♊️",
	"cancer": "♋️",
	"leo": "♌️",
	"virgo": "♍️",
	"libra": "♎️",
	"scorpius": "♏️",
	"sagittarius": "♐️",
	"capricorn": "♑️",
	"aquarius": "♒️",
	"pisces": "♓️",
	"id": "🆔",
	"atom_symbol": "⚛️",
	"accept": "🉑",
	"radioactive": "☢️",
	"biohazard": "☣️",
	"mobile_phone_off": "📴",
	"vibration_mode": "📳",
	"eight_pointed_black_star": "✴️",
	"vs": "🆚",
	"white_flower": "💮",
	"ideograph_advantage": "🉐",
	"secret": "㊙️",
	"congratulations": "㊗️",
	"u6e80": "🈵",
	"a": "🅰️",
	"b": "🅱️",
	"ab": "🆎",
	"cl": "🆑",
	"o2": "🅾️",
	"sos": "🆘",
	"x": "❌",
	"o": "⭕️",
	"stop_sign": "🛑",
	"no_entry": "⛔️",
	"name_badge": "📛",
	"no_entry_sign": "🚫",
	"anger": "💢",
	"hotsprings": "♨️",
	"no_pedestrians": "🚷",
	"do_not_litter": "🚯",
	"no_bicycles": "🚳",
	"non-potable_water": "🚱",
	"underage": "🔞",
	"no_mobile_phones": "📵",
	"no_smoking": "🚭",
	"exclamation": "❗️",
	"heavy_exclamation_mark": "❗️",
	"grey_exclamation": "❕",
	"question": "❓",
	"grey_question": "❔",
	"bangbang": "‼️",
	"interrobang": "⁉️",
	"low_brightness": "🔅",
	"high_brightness": "🔆",
	"part_alternation_mark": "〽️",
	"warning": "⚠️",
	"children_crossing": "🚸",
	"trident": "🔱",
	"fleur_de_lis": "⚜️",
	"beginner": "🔰",
	"recycle": "♻️",
	"white_check_mark": "✅",
	"chart": "💹",
	"sparkle": "❇️",
	"eight_spoked_asterisk": "✳️",
	"negative_squared_cross_mark": "❎",
	"globe_with_meridians": "🌐",
	"diamond_shape_with_a_dot_inside": "💠",
	"m": "Ⓜ️",
	"cyclone": "🌀",
	"zzz": "💤",
	"atm": "🏧",
	"wc": "🚾",
	"wheelchair": "♿️",
	"parking": "🅿️",
	"sa": "🈂️",
	"passport_control": "🛂",
	"customs": "🛃",
	"baggage_claim": "🛄",
	"left_luggage": "🛅",
	"mens": "🚹",
	"womens": "🚺",
	"baby_symbol": "🚼",
	"restroom": "🚻",
	"put_litter_in_its_place": "🚮",
	"cinema": "🎦",
	"signal_strength": "📶",
	"koko": "🈁",
	"symbols": "🔣",
	"information_source": "ℹ️",
	"abc": "🔤",
	"abcd": "🔡",
	"capital_abcd": "🔠",
	"ng": "🆖",
	"ok": "🆗",
	"up": "🆙",
	"cool": "🆒",
	"new": "🆕",
	"free": "🆓",
	"zero": "0️⃣",
	"one": "1️⃣",
	"two": "2️⃣",
	"three": "3️⃣",
	"four": "4️⃣",
	"five": "5️⃣",
	"six": "6️⃣",
	"seven": "7️⃣",
	"eight": "8️⃣",
	"nine": "9️⃣",
	"keycap_ten": "🔟",
	"hash": "#️⃣",
	"asterisk": "*️⃣",
	"arrow_forward": "▶️",
	"pause_button": "⏸",
	"play_or_pause_button": "⏯",
	"stop_button": "⏹",
	"record_button": "⏺",
	"next_track_button": "⏭",
	"previous_track_button": "⏮",
	"fast_forward": "⏩",
	"rewind": "⏪",
	"arrow_double_up": "⏫",
	"arrow_double_down": "⏬",
	"arrow_backward": "◀️",
	"arrow_up_small": "🔼",
	"arrow_down_small": "🔽",
	"arrow_right": "➡️",
	"arrow_left": "⬅️",
	"arrow_up": "⬆️",
	"arrow_down": "⬇️",
	"arrow_upper_right": "↗️",
	"arrow_lower_right": "↘️",
	"arrow_lower_left": "↙️",
	"arrow_upper_left": "↖️",
	"arrow_up_down": "↕️",
	"left_right_arrow": "↔️",
	"arrow_right_hook": "↪️",
	"leftwards_arrow_with_hook": "↩️",
	"arrow_heading_up": "⤴️",
	"arrow_heading_down": "⤵️",
	"twisted_rightwards_arrows": "🔀",
	"repeat": "🔁",
	"repeat_one": "🔂",
	"arrows_counterclockwise": "🔄",
	"arrows_clockwise": "🔃",
	"musical_note": "🎵",
	"notes": "🎶",
	"heavy_plus_sign": "➕",
	"heavy_minus_sign": "➖",
	"heavy_division_sign": "➗",
	"heavy_multiplication_x": "✖️",
	"heavy_dollar_sign": "💲",
	"currency_exchange": "💱",
	"tm": "™️",
	"copyright": "©️",
	"registered": "®️",
	"wavy_dash": "〰️",
	"curly_loop": "➰",
	"loop": "➿",
	"end": "🔚",
	"back": "🔙",
	"on": "🔛",
	"top": "🔝",
	"soon": "🔜",
	"heavy_check_mark": "✔️",
	"ballot_box_with_check": "☑️",
	"radio_button": "🔘",
	"white_circle": "⚪️",
	"black_circle": "⚫️",
	"red_circle": "🔴",
	"large_blue_circle": "🔵",
	"small_red_triangle": "🔺",
	"small_red_triangle_down": "🔻",
	"small_orange_diamond": "🔸",
	"small_blue_diamond": "🔹",
	"large_orange_diamond": "🔶",
	"large_blue_diamond": "🔷",
	"white_square_button": "🔳",
	"black_square_button": "🔲",
	"black_small_square": "▪️",
	"white_small_square": "▫️",
	"black_medium_small_square": "◾️",
	"white_medium_small_square": "◽️",
	"black_medium_square": "◼️",
	"white_medium_square": "◻️",
	"black_large_square": "⬛️",
	"white_large_square": "⬜️",
	"speaker": "🔈",
	"mute": "🔇",
	"sound": "🔉",
	"loud_sound": "🔊",
	"bell": "🔔",
	"no_bell": "🔕",
	"mega": "📣",
	"loudspeaker": "📢",
	"eye_speech_bubble": "👁‍🗨",
	"speech_balloon": "💬",
	"thought_balloon": "💭",
	"right_anger_bubble": "🗯",
	"spades": "♠️",
	"clubs": "♣️",
	"hearts": "♥️",
	"diamonds": "♦️",
	"black_joker": "🃏",
	"flower_playing_cards": "🎴",
	"mahjong": "🀄️",
	"clock1": "🕐",
	"clock2": "🕑",
	"clock3": "🕒",
	"clock4": "🕓",
	"clock5": "🕔",
	"clock6": "🕕",
	"clock7": "🕖",
	"clock8": "🕗",
	"clock9": "🕘",
	"clock10": "🕙",
	"clock11": "🕚",
	"clock12": "🕛",
	"clock130": "🕜",
	"clock230": "🕝",
	"clock330": "🕞",
	"clock430": "🕟",
	"clock530": "🕠",
	"clock630": "🕡",
	"clock730": "🕢",
	"clock830": "🕣",
	"clock930": "🕤",
	"clock1030": "🕥",
	"clock1130": "🕦",
	"clock1230": "🕧",
	"white_flag": "🏳️",
	"black_flag": "🏴",
	"checkered_flag": "🏁",
	"triangular_flag_on_post": "🚩",
	"rainbow_flag": "🏳️‍🌈",
	"afghanistan": "🇦🇫",
	"aland_islands": "🇦🇽",
	"albania": "🇦🇱",
	"algeria": "🇩🇿",
	"american_samoa": "🇦🇸",
	"andorra": "🇦🇩",
	"angola": "🇦🇴",
	"anguilla": "🇦🇮",
	"antarctica": "🇦🇶",
	"antigua_barbuda": "🇦🇬",
	"argentina": "🇦🇷",
	"armenia": "🇦🇲",
	"aruba": "🇦🇼",
	"australia": "🇦🇺",
	"austria": "🇦🇹",
	"azerbaijan": "🇦🇿",
	"bahamas": "🇧🇸",
	"bahrain": "🇧🇭",
	"bangladesh": "🇧🇩",
	"barbados": "🇧🇧",
	"belarus": "🇧🇾",
	"belgium": "🇧🇪",
	"belize": "🇧🇿",
	"benin": "🇧🇯",
	"bermuda": "🇧🇲",
	"bhutan": "🇧🇹",
	"bolivia": "🇧🇴",
	"caribbean_netherlands": "🇧🇶",
	"bosnia_herzegovina": "🇧🇦",
	"botswana": "🇧🇼",
	"brazil": "🇧🇷",
	"british_indian_ocean_territory": "🇮🇴",
	"british_virgin_islands": "🇻🇬",
	"brunei": "🇧🇳",
	"bulgaria": "🇧🇬",
	"burkina_faso": "🇧🇫",
	"burundi": "🇧🇮",
	"cape_verde": "🇨🇻",
	"cambodia": "🇰🇭",
	"cameroon": "🇨🇲",
	"canada": "🇨🇦",
	"canary_islands": "🇮🇨",
	"cayman_islands": "🇰🇾",
	"central_african_republic": "🇨🇫",
	"chad": "🇹🇩",
	"chile": "🇨🇱",
	"cn": "🇨🇳",
	"christmas_island": "🇨🇽",
	"cocos_islands": "🇨🇨",
	"colombia": "🇨🇴",
	"comoros": "🇰🇲",
	"congo_brazzaville": "🇨🇬",
	"congo_kinshasa": "🇨🇩",
	"cook_islands": "🇨🇰",
	"costa_rica": "🇨🇷",
	"cote_divoire": "🇨🇮",
	"croatia": "🇭🇷",
	"cuba": "🇨🇺",
	"curacao": "🇨🇼",
	"cyprus": "🇨🇾",
	"czech_republic": "🇨🇿",
	"denmark": "🇩🇰",
	"djibouti": "🇩🇯",
	"dominica": "🇩🇲",
	"dominican_republic": "🇩🇴",
	"ecuador": "🇪🇨",
	"egypt": "🇪🇬",
	"el_salvador": "🇸🇻",
	"equatorial_guinea": "🇬🇶",
	"eritrea": "🇪🇷",
	"estonia": "🇪🇪",
	"ethiopia": "🇪🇹",
	"eu": "🇪🇺",
	"european_union": "🇪🇺",
	"falkland_islands": "🇫🇰",
	"faroe_islands": "🇫🇴",
	"fiji": "🇫🇯",
	"finland": "🇫🇮",
	"fr": "🇫🇷",
	"french_guiana": "🇬🇫",
	"french_polynesia": "🇵🇫",
	"french_southern_territories": "🇹🇫",
	"gabon": "🇬🇦",
	"gambia": "🇬🇲",
	"georgia": "🇬🇪",
	"de": "🇩🇪",
	"ghana": "🇬🇭",
	"gibraltar": "🇬🇮",
	"greece": "🇬🇷",
	"greenland": "🇬🇱",
	"grenada": "🇬🇩",
	"guadeloupe": "🇬🇵",
	"guam": "🇬🇺",
	"guatemala": "🇬🇹",
	"guernsey": "🇬🇬",
	"guinea": "🇬🇳",
	"guinea_bissau": "🇬🇼",
	"guyana": "🇬🇾",
	"haiti": "🇭🇹",
	"honduras": "🇭🇳",
	"hong_kong": "🇭🇰",
	"hungary": "🇭🇺",
	"iceland": "🇮🇸",
	"india": "🇮🇳",
	"indonesia": "🇮🇩",
	"iran": "🇮🇷",
	"iraq": "🇮🇶",
	"ireland": "🇮🇪",
	"isle_of_man": "🇮🇲",
	"israel": "🇮🇱",
	"it": "🇮🇹",
	"jamaica": "🇯🇲",
	"jp": "🇯🇵",
	"crossed_flags": "🎌",
	"jersey": "🇯🇪",
	"jordan": "🇯🇴",
	"kazakhstan": "🇰🇿",
	"kenya": "🇰🇪",
	"kiribati": "🇰🇮",
	"kosovo": "🇽🇰",
	"kuwait": "🇰🇼",
	"kyrgyzstan": "🇰🇬",
	"laos": "🇱🇦",
	"latvia": "🇱🇻",
	"lebanon": "🇱🇧",
	"lesotho": "🇱🇸",
	"liberia": "🇱🇷",
	"libya": "🇱🇾",
	"liechtenstein": "🇱🇮",
	"lithuania": "🇱🇹",
	"luxembourg": "🇱🇺",
	"macau": "🇲🇴",
	"macedonia": "🇲🇰",
	"madagascar": "🇲🇬",
	"malawi": "🇲🇼",
	"malaysia": "🇲🇾",
	"maldives": "🇲🇻",
	"mali": "🇲🇱",
	"malta": "🇲🇹",
	"marshall_islands": "🇲🇭",
	"martinique": "🇲🇶",
	"mauritania": "🇲🇷",
	"mauritius": "🇲🇺",
	"mayotte": "🇾🇹",
	"mexico": "🇲🇽",
	"micronesia": "🇫🇲",
	"moldova": "🇲🇩",
	"monaco": "🇲🇨",
	"mongolia": "🇲🇳",
	"montenegro": "🇲🇪",
	"montserrat": "🇲🇸",
	"morocco": "🇲🇦",
	"mozambique": "🇲🇿",
	"myanmar": "🇲🇲",
	"namibia": "🇳🇦",
	"nauru": "🇳🇷",
	"nepal": "🇳🇵",
	"netherlands": "🇳🇱",
	"new_caledonia": "🇳🇨",
	"new_zealand": "🇳🇿",
	"nicaragua": "🇳🇮",
	"niger": "🇳🇪",
	"nigeria": "🇳🇬",
	"niue": "🇳🇺",
	"norfolk_island": "🇳🇫",
	"northern_mariana_islands": "🇲🇵",
	"north_korea": "🇰🇵",
	"norway": "🇳🇴",
	"oman": "🇴🇲",
	"pakistan": "🇵🇰",
	"palau": "🇵🇼",
	"palestinian_territories": "🇵🇸",
	"panama": "🇵🇦",
	"papua_new_guinea": "🇵🇬",
	"paraguay": "🇵🇾",
	"peru": "🇵🇪",
	"philippines": "🇵🇭",
	"pitcairn_islands": "🇵🇳",
	"poland": "🇵🇱",
	"portugal": "🇵🇹",
	"puerto_rico": "🇵🇷",
	"qatar": "🇶🇦",
	"reunion": "🇷🇪",
	"romania": "🇷🇴",
	"ru": "🇷🇺",
	"rwanda": "🇷🇼",
	"st_barthelemy": "🇧🇱",
	"st_helena": "🇸🇭",
	"st_kitts_nevis": "🇰🇳",
	"st_lucia": "🇱🇨",
	"st_pierre_miquelon": "🇵🇲",
	"st_vincent_grenadines": "🇻🇨",
	"samoa": "🇼🇸",
	"san_marino": "🇸🇲",
	"sao_tome_principe": "🇸🇹",
	"saudi_arabia": "🇸🇦",
	"senegal": "🇸🇳",
	"serbia": "🇷🇸",
	"seychelles": "🇸🇨",
	"sierra_leone": "🇸🇱",
	"singapore": "🇸🇬",
	"sint_maarten": "🇸🇽",
	"slovakia": "🇸🇰",
	"slovenia": "🇸🇮",
	"solomon_islands": "🇸🇧",
	"somalia": "🇸🇴",
	"south_africa": "🇿🇦",
	"south_georgia_south_sandwich_islands": "🇬🇸",
	"kr": "🇰🇷",
	"south_sudan": "🇸🇸",
	"es": "🇪🇸",
	"sri_lanka": "🇱🇰",
	"sudan": "🇸🇩",
	"suriname": "🇸🇷",
	"swaziland": "🇸🇿",
	"sweden": "🇸🇪",
	"switzerland": "🇨🇭",
	"syria": "🇸🇾",
	"taiwan": "🇹🇼",
	"tajikistan": "🇹🇯",
	"tanzania": "🇹🇿",
	"thailand": "🇹🇭",
	"timor_leste": "🇹🇱",
	"togo": "🇹🇬",
	"tokelau": "🇹🇰",
	"tonga": "🇹🇴",
	"trinidad_tobago": "🇹🇹",
	"tunisia": "🇹🇳",
	"tr": "🇹🇷",
	"turkmenistan": "🇹🇲",
	"turks_caicos_islands": "🇹🇨",
	"tuvalu": "🇹🇻",
	"uganda": "🇺🇬",
	"ukraine": "🇺🇦",
	"united_arab_emirates": "🇦🇪",
	"gb": "🇬🇧",
	"uk": "🇬🇧",
	"us": "🇺🇸",
	"us_virgin_islands": "🇻🇮",
	"uruguay": "🇺🇾",
	"uzbekistan": "🇺🇿",
	"vanuatu": "🇻🇺",
	"vatican_city": "🇻🇦",
	"venezuela": "🇻🇪",
	"vietnam": "🇻🇳",
	"wallis_futuna": "🇼🇫",
	"western_sahara": "🇪🇭",
	"yemen": "🇾🇪",
	"zambia": "🇿🇲",
	"zimbabwe": "🇿🇼"
};

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5080a0f2_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__(970);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5080a0f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5080a0f2_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4873f7e8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(969);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4873f7e8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(984);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(963);
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(973);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(5)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a67861b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(972);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a67861b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a67861b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photos_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cfb5d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photos_vue__ = __webpack_require__(983);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4cfb5d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cfb5d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinCodeLogin_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ffa942e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PinCodeLogin_vue__ = __webpack_require__(974);
function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ffa942e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinCodeLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ffa942e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PinCodeLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19be308a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__(965);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19be308a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19be308a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 950:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de8cdb8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__ = __webpack_require__(980);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de8cdb8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de8cdb8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Questions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLeaderboard_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3399372_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLeaderboard_vue__ = __webpack_require__(982);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3399372"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamLeaderboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3399372_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamLeaderboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZooHomePage_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165c6246_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZooHomePage_vue__ = __webpack_require__(964);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-165c6246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZooHomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165c6246_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZooHomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38bb801e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heart_vue__ = __webpack_require__(968);
function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var normalizeComponent = __webpack_require__(5)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38bb801e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38bb801e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0c5b336_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(981);
function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0c5b336"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0c5b336_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleAnswer_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577cf6cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleAnswer_vue__ = __webpack_require__(971);
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577cf6cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneChoiceAnswer_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23345b7f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OneChoiceAnswer_vue__ = __webpack_require__(967);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23345b7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneChoiceAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23345b7f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OneChoiceAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamAvatar_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aefc1c96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamAvatar_vue__ = __webpack_require__(978);
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aefc1c96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAnswer_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf43048_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAnswer_vue__ = __webpack_require__(962);
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf43048_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TutorialDialog_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0bff20_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TutorialDialog_vue__ = __webpack_require__(966);
function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b0bff20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TutorialDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0bff20_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TutorialDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TutorialGifCard_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc85803_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TutorialGifCard_vue__ = __webpack_require__(977);
function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fc85803"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TutorialGifCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc85803_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TutorialGifCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_watchLocation_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca4d572_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_watchLocation_vue__ = __webpack_require__(976);
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_watchLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca4d572_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_watchLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Your response","disabled":_vm.disabledAnswers},on:{"input":function($event){_vm.updateAnswer($event)}},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flyout",attrs:{"id":"appZoo"}},[_c('div',{staticStyle:{"margin-top":"-15px","overflow-x":"hidden"}},[_c('mdb-edge-header',{attrs:{"color":"teal darken-2"}},[_c('div',{staticClass:"home-page-background"})]),_vm._v(" "),_c('mdb-container',{staticClass:"free-bird",staticStyle:{"margin-top":"-100px"}},[_c('mdb-row',[_c('mdb-col',{staticClass:"mx-auto white z-depth-1 py-2 px-2",attrs:{"md":"10"}},[_c('mdb-card-body',[_c('h2',{staticClass:"pb-4"},[_c('strong',[_vm._v("Taronga Zoo digital Hunt")])]),_vm._v(" "),_c('mdb-row',[_c('mdb-col',{attrs:{"md":"3"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/img/zoo/taronga-zoo.jpg"}})]),_vm._v(" "),_c('mdb-col',{attrs:{"md":"9"}},[_c('p',{staticClass:"pb-4"},[_vm._v("The unique digital treasure hunts in your favorite Zoo."),_c('br'),_vm._v("\n                Find fun and educational challenges, and get rewarded for that."),_c('br'),_vm._v("The whole family can play")])])],1),_vm._v(" "),_c('mdb-row',{staticClass:"d-flex flex-row justify-content-center"},[_c('a',{staticClass:"nav-link border m-2 font-weight-bold rounded",attrs:{"href":"https://mdbootstrap.com/docs/vue/?utm_source=DemoApp&utm_medium=MDBVue","target":"_blank"}},[_c('mdb-icon',{staticClass:"mr-2",attrs:{"icon":"graduation-cap"}}),_vm._v("Launch the tutorial")],1),_vm._v(" "),_c('a',{staticClass:"nav-link border indigo-text m-2 font-weight-bold rounded",attrs:{"href":"https://mdbootstrap.com/docs/vue/getting-started/download/","target":"_blank"}},[_c('mdb-icon',{staticClass:"mr-2",attrs:{"icon":"download"}}),_vm._v("List of rewards")],1),_vm._v(" "),_c('a',{staticClass:"nav-link border m-2 indigo-text font-weight-bold rounded",attrs:{"href":"https://mdbootstrap.com/products/vue-ui-kit/","target":"_blank"}},[_c('mdb-icon',{staticClass:"mr-2",attrs:{"icon":"gem","far":""}}),_vm._v("See the leaderboard")],1)])],1)],1)],1)],1),_vm._v(" "),_c('mdb-container',[_c('h2',{staticClass:"text-center mt-5 font-weight-bold"},[_vm._v("Start a game")]),_vm._v(" "),_c('mdb-col',{staticClass:"mx-auto text-center text-muted mb-5",attrs:{"md":"10"}},[_c('p',[_vm._v("The hunt is divided in different areas."),_c('br'),_vm._v("\n        Each area will make you visit the Zoo with a different angle."),_c('br'),_vm._v("\n        Go to each geolocated points on the map and solve challenges.")])]),_vm._v(" "),_c('mdb-row',[_c('mdb-col',{staticClass:"mb-5",attrs:{"md":"4"}},[_c('mdb-card',{staticClass:"animated fadeInLeft"},[_c('mdb-card-image',{attrs:{"src":"https://www.elephantnaturepark.org/wp-content/uploads/2019/10/Krating-Dang-10-Oct-19-_-01-1-600x600.jpg","alt":"Card image cap"}}),_vm._v(" "),_c('mdb-card-body',[_c('mdb-card-title',[_c('mdb-icon',{staticClass:"pink-text",attrs:{"fab":"","icon":"css3"}}),_c('strong',[_vm._v(" Laught with elephants")])],1),_vm._v(" "),_c('mdb-card-text',[_vm._v("Animations, colors, shadows, skins and many more! Get to know all our css styles in one place.")]),_vm._v(" "),_c('router-link',{staticClass:"float-right",attrs:{"to":"/css"}},[_c('mdb-btn',{attrs:{"color":"elegant"}},[_vm._v("Start the game")])],1)],1)],1)],1),_vm._v(" "),_c('mdb-col',{staticClass:"mb-5",attrs:{"md":"4"}},[_c('mdb-card',{staticClass:"animated fadeIn"},[_c('mdb-card-image',{attrs:{"src":"https://www.poemhunter.com/i/poem_image/36/53784536_poem_20.jpg","alt":"Card image cap"}}),_vm._v(" "),_c('mdb-card-body',[_c('mdb-card-title',[_c('mdb-icon',{staticClass:"blue-text",attrs:{"icon":"cubes"}}),_c('strong',[_vm._v(" Monkey island ")])],1),_vm._v(" "),_c('mdb-card-text',[_vm._v("Ready-to-use components that you can use in your applications. Both basic and extended versions!")]),_vm._v(" "),_c('router-link',{staticClass:"float-right",attrs:{"to":"/components"}},[_c('mdb-btn',{attrs:{"color":"elegant"}},[_vm._v("Start the game")])],1)],1)],1)],1),_vm._v(" "),_c('mdb-col',{staticClass:"mb-5",attrs:{"md":"4"}},[_c('mdb-card',{staticClass:"animated fadeInRight"},[_c('mdb-card-image',{attrs:{"src":"https://saphotographers.net/wp-content/uploads/2018/05/THE-LEOPARD-600x600.jpg","alt":"Card image cap"}}),_vm._v(" "),_c('mdb-card-body',[_c('mdb-card-title',[_c('mdb-icon',{staticClass:"green-text",attrs:{"icon":"code"}}),_c('strong',[_vm._v(" Leopard race")])],1),_vm._v(" "),_c('mdb-card-text',[_vm._v("Speed is the key. Run as fast as possible though the Zoo. Beat the fastest players to be listed on our wall of fame.")]),_vm._v(" "),_c('router-link',{staticClass:"float-right",attrs:{"to":"/advanced"}},[_c('mdb-btn',{attrs:{"color":"elegant"}},[_vm._v("Start the game")])],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-screen-wrapper"},[(_vm.showLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"5"}}):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('v-alert',{attrs:{"error":"","value":"true"}},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.challenge)?_c('v-card',{staticClass:"my-4"},[_c('v-card-media',{staticClass:"white--text overlay",attrs:{"src":_vm.urlComputed,"height":"200px"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"headline-wrapper",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.challenge.name)+"\n            ")])])],1)],1)],1),_vm._v(" "),(!_vm.challenge.question)?_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n        You have not unlocked this challenge yet...\n      ")])]):_vm._e(),_vm._v(" "),(_vm.challenge.question)?_c('v-card-text',{staticClass:"pt-4 pr-4 pl-4"},[_c('div',{staticClass:"question-wrapper"},[(_vm.goodAnswer !== true)?_c('div',[(_vm.challenge.allowedAttempts && this.remainingAttempts > 0)?_c('v-card-text',[(_vm.challenge.allowedAttempts === 1)?_c('v-alert',{attrs:{"warning":"","value":"true","transition":"scale-transition"}},[_vm._v("\n              Be attentive! You'll get ONLY 1 attempt to solve this challenge\n            ")]):_c('v-alert',{attrs:{"warning":"","value":"true","transition":"scale-transition"}},[_vm._v("\n              You'll get "+_vm._s(_vm.challenge.allowedAttempts)+" attempts to solve this challenge\n              "),_c('br'),_vm._v("Remaining Attempts: "+_vm._s(this.remainingAttempts)+"\n            ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.questionOnlyText)?_c('div',[_c('vue-markdown',{attrs:{"source":_vm.challenge.question}})],1):_c('div',[_c('vue-markdown',{attrs:{"source":_vm.challenge.question.textBeforeCode}}),_vm._v(" "),_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.challenge.question.codeSnippet),expression:"challenge.question.codeSnippet"}]},[_vm._v("            "),_c('code',{class:_vm.challenge.question.codeLanguage}),_vm._v("\n          ")]),_vm._v(" "),(_vm.challenge.question.textAfterCode)?_c('vue-markdown',{attrs:{"source":_vm.challenge.question.textAfterCode}}):_vm._e()],1)]),_vm._v(" "),(_vm.challenge.type === 'multiple-answers')?_c('multiple-answer',{attrs:{"possibleAnswers":_vm.challenge.answers,"chosenAnswer":_vm.chosenAnswer,"disabledAnswers":_vm.disableAnswers},on:{"updated":_vm.onAnswerUpdate}}):_vm._e(),_vm._v(" "),(_vm.challenge.type === 'one-answer')?_c('one-choice-answer',{attrs:{"possibleAnswers":_vm.challenge.answers,"chosenAnswer":_vm.chosenAnswer,"disabledAnswers":_vm.disableAnswers},on:{"updated":_vm.onAnswerUpdate}}):_vm._e(),_vm._v(" "),(_vm.challenge.type === 'free-text')?_c('text-answer',{attrs:{"chosenAnswer":_vm.chosenAnswer,"disabledAnswers":_vm.disableAnswers},on:{"updated":_vm.onAnswerUpdate}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-card-text',[(_vm.goodAnswer === true)?_c('v-alert',{attrs:{"success":"","hide-icon":"","value":"true","transition":"scale-transition"}},[(_vm.score)?_c('div',[_c('h5',{staticClass:"text-xs-center"},[_vm._v("Bravo! "),_c('strong',[_vm._v(" "+_vm._s(_vm.score)+" "+_vm._s(_vm._f("pluralize")(_vm.score,'point'))+" won!")])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('ul',{staticClass:"bonuses"},[(_vm.showQuestionPoints)?_c('li',[_c('v-icon',{staticClass:"amber--text text--lighten-2"},[_vm._v("done")]),_vm._v("\n                  Challenge solved: "),_c('strong',[_vm._v(_vm._s(_vm.questionPoints)+" "+_vm._s(_vm._f("pluralize")(_vm.questionPoints,'point')))])],1):_vm._e(),_vm._v(" "),(_vm.showBonusFirstTry)?_c('li',[_c('v-icon',{staticClass:"amber--text text--lighten-2"},[_vm._v("done")]),_vm._v("\n                  First try bonus: "),_c('strong',[_vm._v("+"+_vm._s(_vm.bonusFirstTry)+" "+_vm._s(_vm._f("pluralize")(_vm.bonusFirstTry,'point')))])],1):_vm._e(),_vm._v(" "),(_vm.showBonusSpeed)?_c('li',[_c('v-icon',{staticClass:"amber--text text--lighten-2"},[_vm._v("done")]),_vm._v("\n                  Speed bonus: "),_c('strong',[_vm._v("+"+_vm._s(_vm.bonusSpeed)+" "+_vm._s(_vm._f("pluralize")(_vm.bonusSpeed,'point')))])],1):_vm._e()])])],1),_vm._v(" "),(!_vm.photoUploaded)?_c('picture-input',{ref:"pictureInput",attrs:{"width":"600","height":"600","margin":"16","accept":"image/jpeg,image/png","size":"10","customStrings":{
              upload: '<h1>Bummer!</h1>',
              drag: 'Choose picture'
            }},on:{"change":_vm.onPictureChosen}}):_vm._e(),_vm._v(" "),(_vm.photoToUpload&&!_vm.photoUploaded)?_c('v-btn',{staticStyle:{"width":"100%"},attrs:{"primary":"","disabled":_vm.showLoading},nativeOn:{"click":function($event){_vm.startPictureUpload()}}},[(_vm.showLoading)?_c('span',[_vm._v("Uploading...")]):_c('span',[_vm._v("Upload")])]):_vm._e()],1):_c('div',[_c('h5',{staticClass:"text-xs-center"},[_c('strong',[_vm._v("Challenge Solved!")])])])]):_vm._e()],1),_vm._v(" "),_c('v-card-text',[(_vm.goodAnswer === false && this.remainingAttempts !==0)?_c('v-alert',{attrs:{"warning":"","value":"true","transition":"scale-transition"}},[_vm._v("\n        :( Too bad, wrong one.\n      ")]):_vm._e(),_vm._v(" "),(this.remainingAttempts === 0)?_c('v-alert',{attrs:{"warning":"","value":"true","transition":"scale-transition"}},[_vm._v("\n        Sorry! You can't answer this challenge as you have no more chances left  :(\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.errorOnCheckAnswer)?_c('v-card-text',[_c('v-alert',{attrs:{"error":"","value":"true","transition":"scale-transition"}},[_vm._v("\n        An error occurred. We were unable to check your answer... :(\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.photoUploaded)?_c('v-card-text',[_c('v-alert',{attrs:{"success":"","value":"true","transition":"scale-transition"}},[_vm._v("\n        Successfully uploaded your picture!\n      ")])],1):_vm._e(),_vm._v(" "),_c('v-card-actions',{staticClass:"ml-2 mt-3"},[_c('v-btn',{attrs:{"flat":"","to":"/Home"}},[_c('v-icon',[_vm._v("fa-chevron-left")]),_vm._v("\n        Back to the maps\n      ")],1),_vm._v(" "),(_vm.isSubmittable)?_c('v-btn',{attrs:{"primary":"","loading":_vm.goButtonLoading},nativeOn:{"click":function($event){_vm.submitAnswer()}}},[_vm._v("\n        Go!\n      ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n          Good answer! Bravo!"),_c('br'),_vm._v("\n          To save your progress, please login\n        ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n          Cancel\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[1]),callback:function ($$v) {_vm.$set(_vm.showSlides, 1, $$v)},expression:"showSlides[1]"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n          Welcome to "+_vm._s(_vm.gameDisplayedName)+"\n        ")])]),_vm._v(" "),_c('v-card-text',[_c('img',{attrs:{"src":_vm.imageUrl,"height":"150px"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.gameIntroText)}})]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"geogaming-dark-blue uia-tutorial-slide1-playNowBtn",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.showSlide(0)}}},[_vm._v("\n          Play now!\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"geogaming-dark-blue",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.showSlide(2)}}},[_vm._v("\n          Watch tutorial\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[2]),callback:function ($$v) {_vm.$set(_vm.showSlides, 2, $$v)},expression:"showSlides[2]"}},[_c('tutorial-gif-card',{attrs:{"title":"See all challenges on the map","gif-path":"/static/img/tutorial/map-screen.3142a5863580f8fbd5b5.gif"},on:{"previous":function($event){_vm.showSlide(1)},"next":function($event){_vm.showSlide(3)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[3]),callback:function ($$v) {_vm.$set(_vm.showSlides, 3, $$v)},expression:"showSlides[3]"}},[_c('tutorial-gif-card',{attrs:{"title":"Go to a challenge to unlock it","gif-path":"/static/img/tutorial/challenge-unlocked.4e2d1d451ef931fac236.gif"},on:{"previous":function($event){_vm.showSlide(2)},"next":function($event){_vm.showSlide(4)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[4]),callback:function ($$v) {_vm.$set(_vm.showSlides, 4, $$v)},expression:"showSlides[4]"}},[_c('tutorial-gif-card',{attrs:{"title":"Solve it and win points!","gif-path":"/static/img/tutorial/challenge-solved.869f18c5b0bd3034b738.gif"},on:{"previous":function($event){_vm.showSlide(3)},"next":function($event){_vm.showSlide(5)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[5]),callback:function ($$v) {_vm.$set(_vm.showSlides, 5, $$v)},expression:"showSlides[5]"}},[_c('tutorial-gif-card',{attrs:{"title":"Bonus if you are fast and right!","gif-path":"/static/img/tutorial/challenge-bonus.9349890e6db4125d45da.gif"},on:{"previous":function($event){_vm.showSlide(4)},"next":function($event){_vm.showSlide(6)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[6]),callback:function ($$v) {_vm.$set(_vm.showSlides, 6, $$v)},expression:"showSlides[6]"}},[_c('tutorial-gif-card',{attrs:{"title":"Check who’s winning in real time","gif-path":"/static/img/tutorial/leaderboard-teams.jk3kj23j434kp320bn3.gif"},on:{"previous":function($event){_vm.showSlide(5)},"next":function($event){_vm.showSlide(7)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[7]),callback:function ($$v) {_vm.$set(_vm.showSlides, 7, $$v)},expression:"showSlides[7]"}},[_c('tutorial-gif-card',{attrs:{"title":"See your pictures in the gallery","gif-path":"/static/img/tutorial/photos-gallery.4kjdfure398dsh213.gif"},on:{"previous":function($event){_vm.showSlide(6)},"next":function($event){_vm.showSlide(8)}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450"},model:{value:(_vm.showSlides[7]),callback:function ($$v) {_vm.$set(_vm.showSlides, 7, $$v)},expression:"showSlides[7]"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n          That’s it!\n        ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"geogaming-dark-blue",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.showSlide(5)}}},[_vm._v("\n          Previous\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"geogaming-dark-blue",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.showSlide()}}},[_vm._v("\n          Play now!\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-radio-group',{model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}},_vm._l((_vm.possibleAnswers),function(possibleAnswer,index){return _c('div',[_c('v-radio',{attrs:{"label":possibleAnswer,"value":index,"disabled":_vm.disabledAnswers,"color":"blue"}})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n  Made with\n  "),_c('span',{staticClass:"heart"},[_vm._v("\n    ❤\n  ")]),_vm._v("\n  by "),_c('a',{attrs:{"className":"{css(styles.footerLink)}","href":"http://geogaming.io","target":"_blank"}},[_vm._v("Geogaming.io")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onFileDrop($event)},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.possibleAnswers),function(possibleAnswer,index){return _c('div',[_c('v-checkbox',{attrs:{"label":possibleAnswer,"value":index,"disabled":_vm.disabledAnswers,"color":"blue"},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper"},[_c('watch-location'),_vm._v(" "),(_vm.errorMessage)?_c('v-alert',{attrs:{"error":"","value":"true"}},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.googleMapsLoaded)?_c('div',{staticClass:"mt-5"},[_vm._v("\n    Loading Maps . . .\n  ")]):_c('map-component'),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":"","absolute":""},model:{value:(_vm.showUnlockDialog),callback:function ($$v) {_vm.showUnlockDialog=$$v},expression:"showUnlockDialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n          Congratulations, you've unlocked a challenge!\n        ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.showUnlockDialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.goToQuestion(_vm.discoveredChallengeId)}}},[_vm._v("\n          Go to question\n        ")])],1)],1)],1),_vm._v(" "),_c('tutorial-dialog-component',{attrs:{"game":this.game}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pinClass"},[_c('v-card',{staticClass:"my-5"},[_c('v-card-text',[_c('img',{attrs:{"src":_vm.imageUrl,"height":"150px"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Game PIN","prepend-icon":"games","type":"number","error":_vm.error},model:{value:(_vm.pinCode),callback:function ($$v) {_vm.pinCode=$$v},expression:"pinCode"}}),_vm._v(" "),(_vm.error)?_c('v-alert',{attrs:{"error":"","value":"true"}},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"primary":""},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("\n        Start to play\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-screen-wrapper"},[_c('v-card',{staticClass:"my-5"},[(_vm.tenantId)?_c('div',{staticClass:"headline",staticStyle:{"padding-top":"20px"}},[_vm._v("\n      "+_vm._s(_vm.tenantId)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n         Team Login\n      ")])]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs10":""}},[_c('v-select',{attrs:{"prepend-icon":"games","items":_vm.games,"label":"Game","single-line":"","item-text":"gameName","item-value":"idGame","autocomplete":""},model:{value:(_vm.gameId),callback:function ($$v) {_vm.gameId=$$v},expression:"gameId"}}),_vm._v(" "),_c('v-select',{attrs:{"prepend-icon":"person","items":_vm.teams,"label":"Team name","single-line":"","item-text":"teamName","item-value":"teamName","autocomplete":"","error":_vm.error},model:{value:(_vm.teamName),callback:function ($$v) {_vm.teamName=$$v},expression:"teamName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","prepend-icon":"lock","type":"password","error":_vm.error},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.error)?_c('v-alert',{attrs:{"error":"","value":"true"}},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"ml-2 mt-3"},[_c('v-btn',{attrs:{"primary":""},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("\n        Login\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('v-card-text',{staticClass:"with-nav"},[_c('v-btn',{staticClass:"btn-nav prev geogaming-dark-blue",attrs:{"fab":"","small":""},nativeOn:{"click":function($event){return _vm.onClickPrevious($event)}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v(" "),_c('div',{staticClass:"gif-wrapper"},[_c('img',{attrs:{"src":_vm.gifPath}})]),_vm._v(" "),_c('v-btn',{staticClass:"btn-nav next geogaming-dark-blue",attrs:{"fab":"","small":""},nativeOn:{"click":function($event){return _vm.onClickNext($event)}}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"avatar-wrapper"},[_c('a',{attrs:{"slot":"activator","href":"#","title":"Logout"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.clickedLogOut()}},slot:"activator"},[_c('avatar',{attrs:{"username":_vm.team.teamName,"size":40,"src":_vm.team.imageUrl,"title":'Logout'}})],1),_vm._v(" "),_c('div',{staticClass:"points"},[_vm._v("\n    "+_vm._s(_vm.userScore)+" pts\n  ")]),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"lazy":"","absolute":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Are you sure you want to logout?")])]),_vm._v(" "),_c('v-card-text',[_vm._v("Your team will be logged out from the ongoing game")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.logout()}}},[_vm._v("Yes, please")])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"v-app","standalone":""}},[_c('v-navigation-drawer',{attrs:{"persistent":"","light":"","enable-resize-watcher":"","absolute":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-card',[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"height":"90px","margin-top":"10px","margin-bottom":"10px"},attrs:{"src":_vm.imageUrl}})])]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{class:{ 'list__tile--active': _vm.isActive('Home') },on:{"click":function($event){_vm.goTo('Home')}}},[_c('v-list-tile-action',[_c('img',{attrs:{"src":"/static/img/icons/favicon-32x32.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"menu-entry-title"},[_vm._v("\n            Home / Map\n          ")])],1)],1),_vm._v(" "),_c('v-list-tile',{class:{ 'list__tile--active': _vm.isActive('Questions') },on:{"click":function($event){_vm.goTo('Questions')}}},[_c('v-list-tile-action',[_c('img',{attrs:{"src":"/static/img/menu/challenges_list.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"menu-entry-title"},[_vm._v("\n            Challenges List\n          ")])],1)],1),_vm._v(" "),_c('v-list-tile',{class:{ 'list__tile--active': _vm.isActive('TeamLeaderboard') },on:{"click":function($event){_vm.goTo('TeamLeaderboard')}}},[_c('v-list-tile-action',[_c('img',{attrs:{"src":"/static/img/menu/picto_winner.png"}})]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"menu-entry-title"},[_vm._v("\n          Team Leaderboard\n        ")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{class:{ 'list__tile--active': _vm.isActive('About') },on:{"click":function($event){_vm.launchTutorial()}}},[_c('v-list-tile-action',[_c('img',{attrs:{"src":"/static/img/menu/eye.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"menu-entry-title"},[_vm._v("\n            Tutorial\n          ")])],1)],1),_vm._v(" "),_c('v-list-tile',{class:{ 'list__tile--active': _vm.isActive('Photos') },on:{"click":function($event){_vm.goTo('Photos')}}},[_c('v-list-tile-action',[_c('img',{attrs:{"src":"/static/img/menu/picto_photos.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"menu-entry-title"},[_vm._v("\n            Photos\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"geogaming-blue-bg",attrs:{"dark":""}},[_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.gameDisplayedName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.showTeamLoginButton())?_c('v-btn',{class:{ 'list__tile--active': _vm.isActive('TeamLogin') },attrs:{"primary":""},on:{"click":function($event){_vm.goTo('TeamLogin')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("people")]),_vm._v("  Sign In\n    ")]):_vm._e(),_vm._v(" "),_c('team-avatar',{on:{"logout":_vm.logout}})],1),_vm._v(" "),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions-screen-wrapper"},[_c('h5',[_vm._v("\n    List of challenges\n  ")]),_vm._v(" "),_vm._l((_vm.challengesList),function(challenge){return _c('div',[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h6',[_vm._v(_vm._s(challenge.name))])]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-3"},[(_vm.showGoToQuestion(challenge.status))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs6":""}},[_vm._v("\n            Difficulty: "+_vm._s(_vm.getDifficulty(challenge.difficulty))+"\n          ")]),_vm._v(" "),_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs6":""}},[_c('v-chip',{staticClass:"white--text",class:'chip-' + challenge.status},[_vm._v("\n              "+_vm._s(challenge.status)+"\n            ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs12":""}},[_c('v-btn',{class:'goto-button-' + challenge.status,attrs:{"flat":""},on:{"click":function($event){_vm.goToQuestion(challenge.challengeId)}}},[_vm._v("\n              Go to question\n            ")])],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs4":""}},[_vm._v("\n            Difficulty: "+_vm._s(_vm.getDifficulty(challenge.difficulty))+"\n          ")]),_vm._v(" "),_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs4":""}},[_c('v-chip',{staticClass:"white--text",class:'chip-' + challenge.status},[_vm._v("\n              "+_vm._s(challenge.status)+"\n            ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"card-text__item",attrs:{"sm4":"","xs4":""}},[_c('div',[_vm._v("\n              "+_vm._s(challenge.distanceToUserReadable)+"\n            ")])])],1)],1)],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-wrapper"},[_c('gmap-map',{ref:"mapRef",staticClass:"gmap-map",attrs:{"center":_vm.mapCenter,"zoom":_vm.mapZoom,"options":_vm.mapOptions},on:{"zoom_changed":function($event){_vm.onZoomChanged($event)},"center_changed":function($event){_vm.onCenterChanged($event)}}},[_c('gmap-marker',{attrs:{"position":_vm.userLocation,"icon":_vm.userLocationIcon,"z-index":99999999}}),_vm._v(" "),_vm._l((_vm.markers),function(challenge,index){return _c('gmap-marker',{key:index,attrs:{"position":challenge.location,"clickable":true,"icon":_vm.getIconForChallenge(challenge)},on:{"click":function($event){_vm.onMarkerClicked(challenge)}}})}),_vm._v(" "),_vm._v("=`${index}_`\n      :center=\"challenge.location\"\n      :radius=\"checkpointCircleRadius\"\n      :options=\"circleOptions\"\n    >"),_vm._v(" "),(_vm.clickedChallenge)?_c('v-card',{staticClass:"marker-info-card slide-from-down",attrs:{"slot":"visible"},slot:"visible"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"card-content-wrapper"},[_c('div',{staticClass:"headline-wrapper"},[_c('h3',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.clickedChallenge.name)+"\n            ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.clickedChallenge = null}}},[_c('v-icon',[_vm._v("\n                close\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"sub-info"},[_c('div',[_vm._v("\n              Status: "+_vm._s(_vm.clickedChallenge.status)+"\n            ")]),_vm._v(" "),_c('div',[_vm._v("\n              Worth: "+_vm._s(_vm.clickedChallenge.points)+" points + bonus\n            ")]),_vm._v(" "),_c('div',[_vm._v("\n              Activity type: "+_vm._s(_vm.clickedChallenge.activityType)+"\n            ")])])])]),_vm._v(" "),(_vm.showGoToQuestionButton(_vm.clickedChallenge))?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-2",attrs:{"primary":""},nativeOn:{"click":function($event){_vm.goToQuestion(_vm.clickedChallenge.challengeId)}}},[_vm._v("\n          Go to question\n        ")]),_vm._v(" "),_c('v-spacer')],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"visible"},slot:"visible"},[_c('div',{staticClass:"heart-wrapper"},[_c('heart-component')],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard"},[_c('h5',{staticClass:"leaderboard__title"},[_vm._v("\n    Team Leaderboard\n  ")]),_vm._v(" "),(!_vm.isLeaderBoardDisabled)?_c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.teams,"search":_vm.search,"hide-actions":"","no-data-text":"Loading Team LeaderBoard..."},scopedSlots:_vm._u([{key:"headers",fn:function(headers){return [_vm._v(" ")]}},{key:"items",fn:function(props){return [_c('td',{staticClass:" text-xs-right cell--team-profile-picture"},[(props.item.imageUrl)?_c('v-avatar',{staticClass:"mr-3",attrs:{"slot":"activator","size":"60px"},slot:"activator"},[_c('img',{attrs:{"src":props.item.imageUrl}})]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center cell--name h1"},[_c('h6',[_vm._v(_vm._s(props.item.name))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left cell--score h4"},[_c('h6',[_vm._v(_vm._s(props.item.score))])]),_vm._v(" "),_c('td',{staticClass:"cell--team-medal-icon"},[(props.item.name === _vm.first && props.item.score > 0)?_c('img',{attrs:{"src":"/static/img/leaderboard/trophy.svg"}}):_vm._e()])]}}])})],1):_c('div',[_c('p',{staticClass:"text-no-leaderboard"},[_vm._v("\n      The leaderBoard is not available for now\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photos"},[_c('v-card',[(_vm.showLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"5"}}):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('v-alert',{attrs:{"error":"","value":"true"}},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.attemptedToLoadPhotos && !_vm.showLoading && !_vm.errorMessage && _vm.photos.length == 0)?_c('div',[_c('h3',{staticClass:"display-3"},[_vm._v("Ooops!")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("You don't have any uploaded photos!")]),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"title mb-3"},[_vm._v("Answer a question, upload a photo and it will be visible here.")]),_vm._v(" "),_c('v-divider',{staticClass:"my-3"})],1):_vm._e(),_vm._v(" "),_c('gallery',{attrs:{"images":_vm.photos,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_vm._l((_vm.photos),function(photo,imageIndex){return _c('div',{key:imageIndex,staticClass:"gallery_image",style:({ backgroundImage: 'url(' + photo + ')', backgroundSize: '300px 300px', height: '200px', width: '200px', margin: '10px' }),on:{"click":function($event){_vm.index = imageIndex}}})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[510]);


// WEBPACK FOOTER //
// static/js/app.2c0c16a5aaec0a2ca156.js